export const el = {
    addDatabase: {
        addDatabase: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        addFromFile: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· Î±ÏÏ ÏÎ¬ÎºÎµÎ»Î¿",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "All packages",
        onePackage: "One package",
        priceType: "Î¤ÏÏÎ¿Ï ÏÎ¹Î¼Î®Ï",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "ÎÏÎ¯ÏÏÎµ ÏÎ·Î½ Î¿ÏÎ±ÏÏÏÎ·ÏÎ± ÎºÎ±Î¹ ÏÎ· ÏÎµÎ¹ÏÎ¬ ÏÏÎ½ ÏÏÏÏÎ½ ÏÎ¹Î¼ÏÎ½",
        withAndWithoutVat: "ÎÎ±Î¹ Î¼Îµ ÎºÎ±Î¹ ÏÏÏÎ¯Ï Î¦Î Î",
        withVat: "ÎÏÎ½Î¿ Î¼Îµ Î¦Î Î",
        withoutVat: "ÎÏÎ½Î¿ ÏÏÏÎ¯Ï Î¦Î Î"
    },
    barvis: {
        base: "ÎÎ½Î¿Î¼Î± Î²Î¬ÏÎ·Ï",
        bigCanSize: "ÎÎµÎ³Î¬Î»Î± Î´Î¿ÏÎµÎ¯Î±",
        coating: "Î£ÏÏÏÎ¼Î± ÏÏÏÎ¼Î±ÏÎ¿Ï",
        identifier: "ÎÎ½Î±Î³Î½ÏÏÎ¹ÏÏÎ¹ÎºÏ",
        laboratory: "ÎÏÎ³Î±ÏÏÎ®ÏÎ¹Î¿",
        orderOverview: "ÎÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        rank: "Î¤Î¬Î¾Î·",
        smallCanSize: "ÎÎ¹ÎºÏÎ¬ Î´Î¿ÏÎµÎ¯Î±"
    },
    basicSetup: {
        alreadyLoggedIn: "ÎÏÎµÏÎµ Î®Î´Î· ÏÏÎ½Î´ÎµÎ¸ÎµÎ¯ ÏÏ %{login}.",
        askSupplier: "ÎÎ·ÏÎ®ÏÏÎµ Î±ÏÏ ÏÎ¿Î½ ÏÏÎ¿Î¼Î·Î¸ÎµÏÏÎ® ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÏÎ±Ï Î½Î± ÏÎ±Ï ÎµÎºÏÏÏÎ®ÏÎµÎ¹ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ Î¬Î´ÎµÎ¹ÎµÏ.",
        asterisk: "Î¤Î± ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ¿Ï ÎµÏÎ¹ÏÎ·Î¼Î±Î¯Î½Î¿Î½ÏÎ±Î¹ Î¼Îµ Î±ÏÏÎµÏÎ¯ÏÎºÎ¿ ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸Î¿ÏÎ½.",
        identificationKeys: "Identification keys",
        importCustomData: "ÎÎ¬Î½ Î¹ÏÏÏÎµÎ¹, ÎµÎ¹ÏÎ±Î³Î¬Î³ÎµÏÎµ ÏÎ± ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î± Î´ÎµÎ´Î¿Î¼Î­Î½Î± ÏÎ±Ï Î±ÏÏ ÏÎ¿ ÏÏÎ¿Î·Î³Î¿ÏÎ¼ÎµÎ½Î¿ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
        learnIdentification: "ÎÎ¬Î¸ÎµÏÎµ ÏÎ± ÎºÎ»ÎµÎ¹Î´Î¹Î¬ Î±Î½Î±Î³Î½ÏÏÎ¹ÏÎ·Ï Î±ÏÏ ÏÎ¿Î½ ÏÏÎ¿Î¼Î·Î¸ÎµÏÏÎ® ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÏÎ±Ï.",
        login: "Î¤Î± Î±ÎºÏÎ»Î¿ÏÎ¸Î± Î²Î®Î¼Î±ÏÎ± ÏÎ·Ï Î±ÏÏÎ¹ÎºÎ®Ï ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ·Ï Î±ÏÎ±Î¹ÏÎ¿ÏÎ½ Î´Î¹ÎºÎ±Î¹ÏÎ¼Î±ÏÎ± Î´Î¹Î±ÏÎµÎ¹ÏÎ¹ÏÏÎ®.",
        noDatabase: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÏÏÎ¿ÏÏÎµÎ¸ÎµÎ¯ Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î±ÎºÏÎ¼Î·, ÏÎ¿ÏÎ»Î¬ÏÎ¹ÏÏÎ¿Î½ Î¼Î¯Î± ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ¹ÏÎ±ÏÎ¸ÎµÎ¯.",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "ÎÎµÎ¯ÏÎµ ÏÎ± Î¼Î¹ÎºÏÎ¬ ÎµÏÏÏÎ·Î¼Î±ÏÎ¹ÎºÎ¬ Î³Î¹Î± Î½Î± Î¼Î¬Î¸ÎµÏÎµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎ± ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ· ÏÏÎ¸Î¼Î¹ÏÎ·.",
        selectDefaultPrinter: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿Î½ ÏÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÎµÎºÏÏÏÏÏÎ® ÎºÎ±Î¹ Î¿ÏÎ¯ÏÏÎµ ÏÏÏÏÎ¸ÎµÏÎ· Î´Î¹Î±Î¼ÏÏÏÏÏÎ·.",
        selectDefaultTemplate:
            "Select the default templates from the already existing ones, create a new template or load your own.",
        selectDispenser: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿Î½ ÏÏÏÎ¿ Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ¿Ï ÏÎ¿Ï ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎµ.",
        selectLanguage: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ·Î½ Î³Î»ÏÏÏÎ± ÏÎ±Ï.",
        selectProducts: "ÎÏÎ¹Î»Î­Î¾ÏÎµ Î­Î½Î± Î±ÏÏ ÏÎ± Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î± ÏÏÎ¿ÏÏÎ½ÏÎ± ÏÎ¿Ï Î¸Î­Î»ÎµÏÎµ Î½Î± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÎµÏÎµ.",
        selectSpectroType: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿Î½ ÏÏÏÎ¿ ÏÎ¿Ï ÏÎ±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿Ï ÏÎ¿Ï ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎµ.",
        setAdditionalPrinterOptions: "ÎÏÎ¯ÏÏÎµ ÏÏÏÏÎ¸ÎµÏÎµÏ ÎµÏÎ¹Î»Î¿Î³Î­Ï ÎµÎºÏÏÏÏÏÎ®.",
        setAutomaticUpdates: "ÎÏÎ¯ÏÏÎµ ÏÎ¹Ï ÎµÏÎ¹Î»Î¿Î³Î­Ï Î±ÏÏÏÎ¼Î±ÏÏÎ½ ÎµÎ½Î·Î¼ÎµÏÏÏÎµÏÎ½.",
        setCustomItems:
            "ÎÏÎ¯ÏÏÎµ ÏÎ± ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î± ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÎºÎ±Î¹ ÏÎ·Î½ ÏÏÎ¿Î²Î¿Î»Î® Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½.  Î£ÏÏÎµÏÎµ ÏÏÎ¿Ï ÏÎ± ÎºÎ¬ÏÏ Î³Î¹Î± Î½Î± Î´ÎµÎ¯ÏÎµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÎµÏÎ¹Î»Î¿Î³Î­Ï.",
        setEnvironment:
            "ÎÏÎ¯ÏÏÎµ ÏÎ¿ ÏÏÎ½Î¿Î»Î¹ÎºÏ ÏÎµÏÎ¹Î²Î¬Î»Î»Î¿Î½ ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï. Î£ÏÏÎµÏÎµ ÏÏÎ¿Ï ÏÎ± ÎºÎ¬ÏÏ Î³Î¹Î± Î½Î± Î´ÎµÎ¯ÏÎµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÎµÏÎ¹Î»Î¿Î³Î­Ï.",
        setFormulaRepresentation:
            "ÎÏÎ¯ÏÏÎµ ÏÎ·Î½ Î±Î½Î±ÏÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÎ·Ï ÏÏÏÎ¼Î¿ÏÎ»Î±Ï. Î£ÏÏÎµÏÎµ ÏÏÎ¿Ï ÏÎ± ÎºÎ¬ÏÏ Î³Î¹Î± Î½Î± Î´ÎµÎ¯ÏÎµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÎµÏÎ¹Î»Î¿Î³Î­Ï.",
        summary:
            "ÎÏÎ¿ÏÎµÎ¯ÏÎµ Î½Î± Î±Î»Î»Î¬Î¾ÎµÏÎµ Î±ÏÏÎ­Ï ÏÎ¹Ï ÏÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î±Î½Î¬ ÏÎ¬ÏÎ± ÏÏÎ¹Î³Î¼Î® ÎºÎ±Î¹ Î½Î± Î²ÏÎµÎ¯ÏÎµ Î±ÎºÏÎ¼Î· ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÎµÏÎ¹Î»Î¿Î³Î­Ï Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï. ÎÏÎ¿Î»Î±ÏÏÏÎµ ÏÎ· ÏÏÎ®ÏÎ· %{name}!",
        summarySuccess: "ÎÎ¯ÏÏÎµ Î­ÏÎ¿Î¹Î¼Î¿Î¹!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Î¡ÏÎ¸Î¼Î¹ÏÎ· ÏÏÎ¬Î¸Î¼Î·Ï ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        criticalLevelCanister: "Critical canister levels",
        fillToMax: "ÎÎµÎ¼Î¯ÏÏÎµ ÏÏÎ¿ Î¼Î­Î³Î¹ÏÏÎ¿",
        maxDispenseLevel: "ÎÎ­Î³Î¹ÏÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        otherCanisters: "ÎÎ»Î»Î± ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        warningLevelCanister: "Warning canister levels"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "ÎÎ¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÎµÎ½Î­ÏÎ³ÎµÎ¹ÎµÏ service",
        canisterInformation: "Î Î»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        canisterPreview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        currentLevel: "Î£ÏÎ¬Î¸Î¼Î·",
        errors: "Î£ÏÎ¬Î»Î¼Î±ÏÎ±",
        fillState: "ÎÎ±ÏÎ¬ÏÏÎ±ÏÎ· Î³ÎµÎ¼Î¯ÏÎ¼Î±ÏÎ¿Ï",
        fillToMax: "ÎÎµÎ¼Î¯ÏÏÎµ ÏÏÎ¿ Î¼Î­Î³Î¹ÏÏÎ¿",
        fillingAmount: "Filling amount",
        finalLevel: "Final level",
        minimumAmount: "ÎÎ»Î¬ÏÎ¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ±",
        minimumLevel: "ÎÎ»Î¬ÏÎ¹ÏÏÎ¿ ÎµÏÎ¯ÏÎµÎ´Î¿",
        moveTableToRefill: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÎ¯Î½Î±ÎºÎ± Î³Î¹Î± ÏÎ»Î®ÏÏÏÎ·",
        refillNoAmount: "ÎÎµÎ½ ÎµÎ¹ÏÎ¬Î³Î±ÏÎ±Î¹ ÏÎ¿ÏÏ",
        refillOverLimit: "Î ÏÎ¿ÏÏÏÎ·ÏÎ± ÏÎ¿Ï ÎµÎ¹ÏÎ¬Î³ÎµÏÎ±Î¹ ÏÏÎµÏÎ²Î±Î¯Î½ÎµÎ¹ ÏÎ· Î¼Î­Î³Î¹ÏÏÎ· ÏÏÏÎ·ÏÎ¹ÎºÏÏÎ·ÏÎ± ÏÎ¿Ï ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        refillSummary: "%{amount} %{unit} of the colorant %{colorant} will be added to the canister %{canisterId}.",
        systemWarningAmount: "Î ÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ±Ï",
        warningAmount: "Î ÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ· ÎµÎ»Î¬ÏÎ¹ÏÏÎ·Ï ÏÎ¿ÏÏÏÎ·ÏÎ±Ï"
    },
    changeDatabase: {
        changeDatabase: "Change database",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "ÎÎ±Î¸Î¬ÏÎ¹ÏÎµ ÏÎ»Î± ÏÎ± ÎºÎ±Î½Î¬Î»Î¹Î±",
        cleanChannels: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
        cleaningTime: "Î§ÏÏÎ½Î¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï'",
        selectChannels: "ÎÏÎ¹Î»Î¿Î³Î® ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
        startCleaning: "ÎÎ½Î±ÏÎ¾Î· ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï"
    },
    clientServerSettings: {
        activeServer: "ÎÎ½ÎµÏÎ³ÏÏ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®Ï",
        addNewServer: "Add new server",
        availableServers: "ÎÎ»Î»Î¿Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿Î¹ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ­Ï",
        clientIdentifier: "ÎÎ½Î±Î³Î½ÏÏÎ¹ÏÏÎ¹ÎºÏ ÏÎµÎ»Î¬ÏÎ·",
        clientServerSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
        disabledStatus: "Î±ÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¼Î­Î½Î¿ ",
        editServer: "Edit server",
        fillRequiredFields: "Î¤Î± ÏÏÎ¿ÏÏÎµÏÏÎ¹ÎºÎ¬ ÏÎµÎ´Î¯Î± ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸Î¿ÏÎ½",
        noOtherServers: "There are no other available servers",
        offlineStatus: "ÎµÎºÏÏÏ ÏÏÎ½Î´ÎµÏÎ·Ï",
        onlineStatus: "Î£Îµ ÏÏÎ½Î´ÎµÏÎ·",
        port: "ÎÏÏÎ±",
        serverName: "ÎÎ½Î¿Î¼Î± Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
        serverNameMissing: "Î¤Î¿ ÏÎ½Î¿Î¼Î± Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ® ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸ÎµÎ¯",
        stabileConnection: "ÎÎ¹Î± Î½Î± ÎµÎ¾Î±ÏÏÎ±Î»Î¯ÏÎµÏÎµ ÏÏÎ±Î¸ÎµÏÎ® ÏÏÎ½Î´ÎµÏÎ·, ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÏÎ±ÏÎ¹ÎºÎ® Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ· IP.",
        wrongFormatIp: "ÎÎ±Î½Î¸Î±ÏÎ¼Î­Î½Î· Î¼Î¿ÏÏÎ® Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ·Ï IP"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Î§ÏÏÎ¼Î±ÏÎ¹ÎºÏÏ ÏÏÎ½Î¿Ï",
        fandeckPosition: "ÎÎ­ÏÎ· Î§ÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        moreInfoIcons: "More info icons",
        notExistingFormula: "ÎÎ½ÏÏÎ±ÏÎºÏÎ· ÏÏÏÎ¼Î¿ÏÎ»Î±",
        orderBy: "Î¤Î±Î¾Î¹Î½ÏÎ¼Î·ÏÎ· ÎºÎ±ÏÎ¬",
        selectYourGrid: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿ ÏÎ»Î­Î³Î¼Î± ÏÎ±Ï",
        showInPanel: "ÎÎ¼ÏÎ¬Î½Î¹ÏÎ· ÏÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ±",
        warningIcon: "ÎÎ½ÏÏÎ±ÏÎºÏÎ¿ ÎµÎ¹ÎºÎ¿Î½Î¯Î´Î¹Î¿ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·Ï ÏÏÏÎ¼Î¿ÏÎ»Î±Ï"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "ÎÏÎ¹Î¸Î¼ÏÏ Î§ÏÏÏÏÎ¹ÎºÏÎ½:",
        preview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ·",
        prices: "Î¤Î¹Î¼Î­Ï"
    },
    currencySettings: {
        addNewCurrency: "Î ÏÎ¿ÏÎ¸Î­ÏÏÎµ Î½Î­Î¿ Î½ÏÎ¼Î¹ÏÎ¼Î±",
        codePlaceholder: "ÎÏÎ´Î¹ÎºÎ±Ï",
        currencySettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î½Î¿Î¼Î¯ÏÎ¼Î±ÏÎ¿Ï",
        namePlaceholder: "ÎÎ½Î¿Î¼Î±",
        ratePlaceholder: "Î¤Î¹Î¼Î®",
        setDecimalPlaces: "ÎÏÎ¯ÏÏÎµ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ Î´ÎµÎºÎ±Î´Î¹ÎºÏÎ½ ÏÎ·ÏÎ¯ÏÎ½",
        setMainCurrency: "ÎÏÎ¯ÏÏÎµ ÎºÏÏÎ¹Î¿ Î½ÏÎ¼Î¹ÏÎ¼Î±",
        setRounding: "Set rounding",
        symbolPlaceholder: "Î£ÏÎ¼Î²Î¿Î»Î¿"
    },
    customFandecks: {
        customFandecks: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î± ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î±",
        deleteButtonWarning: "All formulas in fandeck will be removed too.",
        deleteCustomFandeck:
            "Do you really want to delete this custom fandeck? All formulas in this fandeck will be deleted too.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "ÎÎ½Î¿Î¼Î±ÏÎ¯Î± ÏÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "Î ÏÎ¿ÏÎ¸Î­ÏÏÎµ Î½Î­Î¿ ÏÎµÎ»Î¬ÏÎ·",
        addNewNote: "Î ÏÎ¿ÏÎ¸Î­ÏÏÎµ Î½Î­Î± ÏÎ·Î¼ÎµÎ¯ÏÏÎ·",
        addedDate: "Î ÏÎ¿ÏÏÎ­Î¸Î·ÎºÎµ Î·Î¼ÎµÏÎ¿Î¼Î·Î½Î¯Î±",
        addedQuantity: "Î ÏÎ¿ÏÏÎ­Î¸Î·ÎºÎµ ÏÎ¿ÏÏÏÎ·ÏÎ±",
        availableMachine: "Î Î¼Î·ÏÎ±Î½Î® ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        brand: "ÎÎ¬ÏÎºÎ±",
        brandPlease: "ÎÏÎ¹Î»Î­Î¾ÏÎµ Î¼Î¬ÏÎºÎ±",
        cancelCustomer: "ÎÎºÏÏÏÏÎ· ÏÎµÎ»Î¬ÏÎ·",
        colorPlease: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÏÎ¼Î±",
        confirmCustomerData: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÎ± Î´ÎµÎ´Î¿Î¼Î­Î½Î± ÏÎµÎ»Î±ÏÏÎ½",
        confirmNoteData: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÎ± Î´ÎµÎ´Î¿Î¼Î­Î½Î± ÏÎ·Î¼ÎµÎ¯ÏÏÎ·Ï",
        confirmSelectedUser: "ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎµÏÎµ ÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÎµÎ»Î¬ÏÎ· %{customerName} Î³Î¹Î± Î±ÏÏÎ® ÏÎ·Î½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±.",
        confirmed: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÎ¼Î­Î½Î¿Ï",
        controlData: "Î¤ÎµÎ»Î¹ÎºÏÏ Î­Î»ÎµÎ³ÏÎ¿Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        customerCellNumber: "ÎÏÎ¹Î¸Î¼ÏÏ ÎºÎ¹Î½Î·ÏÎ¿Ï ÏÎ·Î»ÎµÏÏÎ½Î¿Ï ÏÎµÎ»Î¬ÏÎ·",
        customerFilter: "Î¦Î¯Î»ÏÏÎ¿ ÏÎµÎ»Î¬ÏÎ·",
        customerName: "ÎÎ½Î¿Î¼Î± ÏÎµÎ»Î¬ÏÎ·",
        customerPhone: "Î¤Î·Î»Î­ÏÏÎ½Î¿ ÏÎµÎ»Î±ÏÏÎ½",
        customerPlease: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎµÎ»Î¬ÏÎ·",
        dateFilter: "Î¦Î¯Î»ÏÏÎ¿ Î·Î¼ÎµÏÎ¿Î¼Î·Î½Î¯Î±Ï",
        enterPin: "ÎÎ¹ÏÎ±Î³Î¬Î³ÎµÏÎµ ÏÎ¿Î½ ÎºÏÎ´Î¹ÎºÏ PIN",
        enterTheNumberOfPackages: "ÎÎ±ÏÎ±ÏÏÏÎ¯ÏÏÎµ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ ÏÎ±ÎºÎ­ÏÏÎ½",
        existingCustomer: "User Already Exists",
        fandeckPlease: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        fillCanisterHistory: "Î£ÏÎ¼ÏÎ»Î·ÏÏÏÏÎµ ÏÎ¿ Î¹ÏÏÎ¿ÏÎ¹ÎºÏ ÏÎ¿Ï ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        findCustomer:
            "ÎÎ¹Î± Î½Î± ÎµÎºÏÏÏÎ®ÏÎµÏÎµ ÏÎ·Î½ ÎºÎ¬ÏÏÎ± ÏÎ¹ÏÏÏÏÎ·ÏÎ±Ï ÏÎµ Î±ÏÏÎ® ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎ±ÏÏÏÏÎµ ÏÎ¿ barcode Î® Î±Î½Î±Î¶Î·ÏÎ®ÏÏÎµ ÏÎ·Î½ Î·Î»ÎµÎºÏÏÎ¿Î½Î¹ÎºÎ® Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ·",
        findCustomerByEmail: "Î¦Î¹Î»ÏÏÎ¬ÏÎµÏÎµ ÏÎ¿Î½ ÏÎµÎ»Î¬ÏÎ· Î¼Î­ÏÏ Î·Î»ÎµÎºÏÏÎ¿Î½Î¹ÎºÎ¿Ï ÏÎ±ÏÏÎ´ÏÎ¿Î¼ÎµÎ¯Î¿Ï Î® barcode",
        finishPreviousStep: "(Î Î±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¼Î±ÏÎ¯ÏÏÎµ ÏÎ¿ ÏÏÎ¿Î·Î³Î¿ÏÎ¼ÎµÎ½Î¿ Î²Î®Î¼Î±)",
        formulaUnit: "ÎÎ¿Î½Î¬Î´Î± ÏÏÎ½ÏÎ±Î³Î®Ï",
        getBackToList: "ÎÏÎ¹ÏÏÏÎ­ÏÏÎµ ÏÏÎ· Î»Î¯ÏÏÎ± ÏÎµÎ»Î±ÏÏÎ½",
        historyOfOrders: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        insertNote: "Î Î·Î³Î±Î¯Î½ÎµÏÎµ Î½Î± ÎµÎ¹ÏÎ¬Î³ÎµÏÎµ ÏÎ· ÏÎ·Î¼ÎµÎ¯ÏÏÎ·",
        loadHistoryOrder: "ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÎ¿ÏÏÏÏÎµÏÎµ ÏÎ·Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±",
        loyaltyCards: "ÎÎ¬ÏÏÎµÏ Î±Î¼Î¿Î¹Î²Î®Ï",
        machineIsAvailable: "Î ÎÎÎ§ÎÎÎ ÎÎÎÎÎ ÎÎÎÎÎÎ£ÎÎÎ",
        machineIsUnavailable: "Î ÎÎÎ§ÎÎÎ ÎÎÎ ÎÎÎÎÎ ÎÎÎÎÎÎ£ÎÎÎ",
        newLoyaltyCard: "ÎÎ­Î± ÎºÎ¬ÏÏÎ± ÏÎ¯ÏÏÎ·Ï",
        noAvailableMachine: "Î Î¼Î·ÏÎ±Î½Î® Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        noCustomerSelected: "No customer is selected. Do you want continue?",
        notePlease: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÎµÎ¹ÏÎ¬Î³ÎµÏÎµ ÏÎ· ÏÎ·Î¼ÎµÎ¯ÏÏÎ·",
        openHistory: "ÎÎ½Î¿Î¹Î³Î¼Î± Î¹ÏÏÎ¿ÏÎ¹ÎºÎ¿Ï",
        orAdd: "Î® Î½Î± ÏÏÎ¿ÏÎ¸Î­ÏÎµÏÎµ ÏÎµÎ»Î¬ÏÎ·",
        orSelect: "Î® ÎµÏÎ¹Î»Î­Î¾ÏÎµ ÏÎµÎ»Î¬ÏÎ·",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "ÎÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        orderToMachine: "Î£Î¤ÎÎÎÎ¤Î Î¤ÎÎ Î ÎÎ¡ÎÎÎÎÎÎÎ ÎÎÎ¥ Î£Î¤Î ÎÎÎ§ÎÎÎÎÎ",
        ordersHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        packagePlease: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÎµÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ±ÎºÎ­ÏÎ¿",
        pleaseSelectBrand: "ÎÏÎ¹Î»Î­Î¾ÏÎµ Brand",
        previewImage: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· IMG",
        previewPackage: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÎ¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï",
        productPlease: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÎµÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÎ¿ÏÏÎ½",
        resetFilters: "ÎÏÎ±Î½Î±ÏÎ­ÏÎµÏÎµ ÏÎ»Î± ÏÎ± ÏÎ¯Î»ÏÏÎ±",
        searchForHistoricalOrders: "Î Î±Î½Î±Î¶Î·ÏÎ®ÏÏÎµ ÏÎ±Î»Î±Î¹ÏÏÎµÏÎµÏ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯ÎµÏ",
        selectBrand: "ÎÏÎ¹Î»Î­Î¾ÏÎµ Brand",
        selectColor: "Î Î·Î³Î±Î¯Î½ÎµÏÎµ Î³Î¹Î± Î½Î± ÎµÏÎ¹Î»Î­Î¾ÎµÏÎµ ÏÏÏÎ¼Î±",
        selectCustomer: "Î Î·Î³Î±Î¯Î½ÎµÏÎµ Î³Î¹Î± Î½Î± ÎµÏÎ¹Î»Î­Î¾ÎµÏÎµ ÏÎµÎ»Î¬ÏÎ·",
        selectExistingCustomer: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÎ¬ÏÏÎ¿Î½ÏÎ± ÏÎµÎ»Î¬ÏÎ·",
        selectFandeck: "Î Î·Î³Î±Î¯Î½ÎµÏÎµ Î³Î¹Î± Î½Î± ÎµÏÎ¹Î»Î­Î¾ÎµÏÎµ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Î Î·Î³Î±Î¯Î½ÎµÏÎµ Î³Î¹Î± Î½Î± ÎµÏÎ¹Î»Î­Î¾ÎµÏÎµ ÏÎ±ÎºÎ­ÏÎ¿",
        selectProduct: "Î Î·Î³Î±Î¯Î½ÎµÏÎµ ÏÏÎ¿ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÏÏÎ½",
        shotsCoefficient: "Shots ÏÏÎ½ÏÎµÎ»ÎµÏÏÎ®Ï",
        showDetail: "ÎÎµÎ¯Î¾Îµ Î»ÎµÏÏÎ¿Î¼Î­ÏÎµÎ¹Î±",
        showHideEshopName: "Show/Hide the eshop name of the color in a separate column",
        showKeyboard: "ÎÎ¼ÏÎ¬Î½Î¹ÏÎ· ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        skipCustomerButton: "skip select customer",
        skipCustomerText: "Î Î±ÏÎ¬Î»ÎµÎ¹ÏÎ· Î±Î½ Î´ÎµÎ½ Î¸Î­Î»ÎµÏÎµ Î½Î± ÎµÎ¹ÏÎ¬Î³ÎµÏÎµ Î­Î½Î±Î½ ÏÎµÎ»Î¬ÏÎ·",
        skipNote: "Î Î±ÏÎ¬ÎºÎ±Î¼ÏÎ· ÏÎ·Î¼ÎµÎ¯ÏÏÎ·Ï ÎºÎ±Î¹ ÏÎµÏÎ¯Î»Î·ÏÎ· ÏÏÎ¿Î²Î¿Î»Î®Ï",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "Î±ÏÎ¿Î´ÎµÎºÏÏ",
        statusCanceled: "Î±ÎºÏÏÏÎ¸Î·ÎºÎµ",
        statusCreated: "Î´Î·Î¼Î¹Î¿ÏÏÎ³Î®Î¸Î·ÎºÎµ",
        statusDone: "ÎÎ»Î¿ÎºÎ»Î·ÏÏÎ¸Î·ÎºÎµ",
        statusPartlyDone: "ÎµÎ½ Î¼Î­ÏÎµÎ¹",
        statusPreparing: "ÏÏÎ¿ÎµÏÎ¿Î¹Î¼Î±ÏÎ¯Î±",
        summaryChosenBase: "Î²Î¬ÏÎ·",
        summaryChosenBrand: "Î¼Î¬ÏÎºÎ±",
        summaryChosenCanSize: "Î¼Î­Î³ÎµÎ¸Î¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        summaryChosenColor: "ÏÏÏÎ¼Î±",
        summaryChosenColorCard: "ÎºÎ¬ÏÏÎ± ÏÏÏÎ¼Î±ÏÎ¿Ï",
        summaryChosenProduct: "ÏÏÎ¿ÏÏÎ½",
        summaryChosenQuantity: "ÏÎ¿ÏÏÏÎ·ÏÎ±",
        summaryColorPreview: "color preview",
        summaryCustomNote: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î· ÏÎ·Î¼ÎµÎ¯ÏÏÎ·",
        summaryCustomerNumber: "Î±ÏÎ¹Î¸Î¼ÏÏ ÏÎµÎ»Î¬ÏÎ·",
        summaryFormula: "Î£ÏÎ½ÏÎ±Î³Î®",
        summaryFormulaNote: "Î£Î·Î¼ÎµÎ¯ÏÏÎ· ÏÏÎ½ÏÎ±Î³Î®Ï",
        summaryNote: "Î£Î·Î¼ÎµÎ¯ÏÏÎ·",
        sureAboutSend: "ÎÎ¯ÏÏÎµ Î²Î­Î²Î±Î¹Î¿Î¹ ÏÏÎ¹ Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎµÎ¯Î»ÎµÏÎµ Î¼Î¹Î± ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±",
        useCustomerInOrder: "Do you want to use %{customerName} in the following order?",
        uuid: "Uuid",
        viewSummary: "Î ÏÎ¿Î²Î¿Î»Î® ÏÏÎ½Î¿ÏÎ·Ï",
        volume: "volume"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "ÎÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï Î¼Îµ Î±ÎºÎ¯Î´Î±",
        pinScreenSaverConfirmation: "ÎÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ· ÏÏÎ¿ÏÏÎ»Î±Î¾Î·Ï Î¿Î¸ÏÎ½Î·Ï",
        pinSettingsConfirmation: "ÎÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ· ÏÏÎ¸Î¼Î¯ÏÎµÏÎ½ Î±ÎºÎ¯Î´ÏÎ½",
        printAuto: "ÎÎ¹ÏÏÎ­ÏÏÎµ Î±ÏÏÏÎ¼Î±ÏÎ± ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ·",
        printerSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎµÎºÏÏÏÏÏÎ®",
        selectColorWithFandeck: "ÎÎ¿Î¹Î½Î® ÎµÏÎ¹Î»Î¿Î³Î® ÏÏÏÎ¼Î±ÏÎ¿Ï ÎºÎ±Î¹ ÏÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        setKeyboard: "Î¡ÏÎ¸Î¼Î¹ÏÎ· ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        setKioskMode: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ ÏÎ·Î½ Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÏÎ¿Ï ÎºÎ¹Î²ÏÏÎ¯Î¿Ï",
        setLanguage: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ Î³Î»ÏÏÏÎ±",
        setModule: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ module",
        setQuickSelect: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ Î³ÏÎ®Î³Î¿ÏÎ· ÎµÏÎ¹Î»Î¿Î³Î®",
        setScreensaverTimeout: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ ÏÎ¿ ÏÏÎ¿Î½Î¹ÎºÏ ÏÏÎ¹Î¿ Î¿Î¸ÏÎ½Î·Ï Î¿Î¸ÏÎ½Î·Ï",
        setUnit: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ ÏÎ· Î¼Î¿Î½Î¬Î´Î±"
    },
    customRedlikeMachine: {
        action: "ÎÎ½Î­ÏÎ³ÎµÎ¹Î±",
        additionalPrint: "Î ÏÏÏÎ¸ÎµÏÎ· ÎµÎºÏÏÏÏÏÎ·",
        brand: "ÎÎ¬ÏÎºÎ±",
        brandAccess:
            "Î ÏÏÎ®ÏÏÎ·Ï '%{userName}' Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î­ÏÎµÎ¹ ÏÏÏÏÎ²Î±ÏÎ· ÏÏÎ± Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î±ÏÏ ÏÎ¿ ÎµÎ¼ÏÎ¿ÏÎ¹ÎºÏ ÏÎ®Î¼Î± '%{brandName}'",
        can: "Î¤Î¿ Î´Î¿ÏÎµÎ¯Î¿ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÎ¿ÏÎ¿Î¸ÎµÏÎ·Î¸ÎµÎ¯",
        canistersLevel: "ÎÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÎµÏÎ¹ÏÎ­Î´Î¿Ï ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        closeDetailInformation: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÎ¹Ï Î»ÎµÏÏÎ¿Î¼Î­ÏÎµÎ¹ÎµÏ",
        colorantsAmount: "Î Î¿ÏÏÏÎ·ÏÎ± ÏÏÏÏÏÎ¹ÎºÏÎ½",
        confirmRefill: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÎ· ÏÏÎ¼ÏÎ»Î®ÏÏÏÎ· ÏÏÏÏÏÎ¹ÎºÏÎ½",
        deleteOrder: "ÎÎ¹Î±Î³ÏÎ±ÏÎ® ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï",
        dialogNoMachine: "Î¤Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿",
        dialogNoRcc: "ÎÎ±Î½Î­Î½Î± RCC Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿",
        dispense: "ÎÎ¹Î±Î½Î¿Î¼Î®",
        dispenserInErrorState: "Î Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï",
        dispensingIsOk: "Î Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï ÎµÎ¯Î½Î±Î¹ ÎÎ",
        emergencyButtonPressed: "Emergency button pressed",
        errorCode: "ÎÏÎ´Î¹ÎºÏÏ Î»Î¬Î¸Î¿ÏÏ",
        errorEvents: "Î£ÏÎ¬Î»Î¼Î±ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î­Î±",
        errorReset: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï",
        explanation: "ÎÎ¾Î®Î³Î·ÏÎ·",
        imageNotAvailable: "Î ÎµÎ¹ÎºÏÎ½Î± Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        incorrectCanister: "Î£Î±ÏÏÎ¸Î·ÎºÎµ Î»Î±Î½Î¸Î±ÏÎ¼Î­Î½Î¿ ÎºÎ¬Î½Î¹ÏÏÏÎ¿",
        incorrectColorant: "ERROR: Incorrect colorant scanned. Please scan correct colorant",
        lastEvents: "Î¤ÎµÎ»ÎµÏÏÎ±Î¯Î± Î³ÎµÎ³Î¿Î½ÏÏÎ±",
        machineActions: "Dispenser status",
        machineConfiguration: "ÎÎ¹Î±Î¼ÏÏÏÏÏÎ· Î´Î¹Î±Î½Î¿Î¼Î­Î±",
        machineError: "Î£ÏÎ¬Î»Î¼Î± Î¼Î·ÏÎ±Î½Î®Ï",
        machineIsBusy: "Î Î¼Î·ÏÎ±Î½Î® ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÏÎ¿Î»Î·Î¼Î­Î½Î·",
        machineNotAvailable: "Î Î¼Î·ÏÎ±Î½Î® Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        machineTinting: "Please wait, machine tinting...",
        manualScan: "Î§ÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· ÏÎ¬ÏÏÏÎ·",
        notEnoughSpace: "Î£ÏÎ¬Î»Î¼Î±: ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î±ÏÎºÎµÏÏÏ ÏÏÏÎ¿Ï Î³Î¹Î± Î±ÏÏÏ ÏÎ¿ ÏÎ±ÎºÎ­ÏÎ¿ ÏÏÏÏÏÎ¹ÎºÏÎ½",
        numberOfCanistersUnderCriticalLevel: "Î Î±ÏÎ¹Î¸Î¼ÏÏ ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½ ÏÎµ ÎºÏÎ¯ÏÎ¹Î¼Î¿ ÎµÏÎ¯ÏÎµÎ´Î¿ ÎµÎ¯Î½Î±Î¹ %{0}",
        numberOfCanistersUnderWarningLevel: "Î Î±ÏÎ¹Î¸Î¼ÏÏ ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½ ÏÎµ ÎµÏÎ¯ÏÎµÎ´Î¿ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·Ï ÎµÎ¯Î½Î±Î¹ %{0}",
        offlinePressed: "Î Î´Î¹Î±ÎºÏÏÏÎ·Ï Offline Î­ÏÎµÎ¹ ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯",
        orderSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï",
        otherOrderInformation: "ÎÎµÏÏÎ¿Î¼Î­ÏÎµÎ¹ÎµÏ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï",
        packageCount: "ÎÏÎ¹Î¸Î¼ÏÏ ÏÎ±ÎºÎ­ÏÏÎ½",
        packageWithSeparator: "Î Î±ÎºÎ­ÏÎ¿",
        received: "ÎÎ®ÏÎ·",
        receivedOrders: "Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯ÎµÏ ÏÎ¿Ï ÏÎ±ÏÎ±Î»Î®ÏÎ¸Î·ÎºÎ±Î½",
        receivedTime: "Î§ÏÏÎ½Î¿Ï ÏÎ¿Ï ÏÎ±ÏÎ±Î»Î®ÏÎ¸Î·ÎºÎµ",
        recirculation: "ÎÎ½Î±ÎºÏÎºÎ»Î¿ÏÎ¿ÏÎ¯Î±",
        refillInformation: "Î§ÏÏÏÏÎ¹ÎºÎ®: %{0}, Î£ÏÎ¼ÏÎ»Î®ÏÏÏÎ·: %{1}, ÎÎ¬Î½Î¹ÏÏÏÎ¿: %{2}",
        resetErrors: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ±Î»Î¼Î¬ÏÏÎ½",
        scanCanister: "Î£Î¬ÏÏÏÎ· Î±ÏÏÎ¿Ï ÏÎ¿Ï ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        scanColorantPackage: "Scan proper colorant package",
        selectedOrder: "ÎÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· ÏÎµÎ¹ÏÎ¬",
        shelfMovingDown: "Î¤Î¿ ÏÎ¬ÏÎ¹ ÎºÎ¹Î½ÎµÎ¯ÏÎ±Î¹ ÏÏÎ¿Ï ÏÎ± ÎºÎ¬ÏÏ",
        shelfMovingUp: "Î¤Î¿ ÏÎ¬ÏÎ¹ ÎºÎ¹Î½ÎµÎ¯ÏÎ±Î¹ ÏÏÎ¿Ï ÏÎ± ÎµÏÎ¬Î½Ï",
        solution: "ÎÏÏÎ·",
        startDispensing: "ÎÎµÎºÎ¹Î½Î®ÏÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        stirring: "ÎÎ½Î±ÎºÎ¬ÏÎµÎ¼Î±",
        touchToStartFilling: "ÎÎ³Î³Î¯Î¾ÏÎµ Î³Î¹Î± Î½Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÏÎµ ÏÎ· ÏÏÎ¼ÏÎ»Î®ÏÏÏÎ· ÏÏÏÏÏÎ¹ÎºÏÎ½",
        unknownBrand: "ÎÎ³Î½ÏÏÏÎ· Î¼Î¬ÏÎºÎ±"
    },
    customRedlikeSettings: {
        addPos: "Pos Info",
        addServer: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
        adminOperations: "Admin operations",
        adminSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î´Î¹Î±ÏÎµÎ¹ÏÎ¹ÏÏÎ®",
        another: "ÎÎ»Î»Î¿",
        aslOrService: "ASL Î® ÏÏÎ·ÏÎµÏÎ¯Î±",
        availableMachines: "ÎÎ¹Î±Î¸Î­ÏÎ¹Î¼Î± Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ±",
        barcode: "Barcode",
        basicOperations: "ÎÎ±ÏÎ¹ÎºÎ­Ï Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯ÎµÏ",
        canisterBarcodes: "ÎÎ±Î½Î¯ÏÏÏÎ¿Ï barcodes",
        canisterLevels: "ÎÏÎ¯ÏÎµÎ´Î± ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        closeConnection: "Close connection",
        closeRedlike: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÎ¿ %{name}",
        databaseList: "ÎÎ¬ÏÎµÎ¹Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        disabledStatus: "? ÎµÎ¯Î½Î±Î¹ Î±ÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¼Î­Î½Î¿",
        dispenseLogicType: "Î¤ÏÏÎ¿Ï Î»Î¿Î³Î¹ÎºÎ®Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        dropServers: "Î ÏÏÏÎ· Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÏÎ½",
        editServer: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
        lastEvent: "Î¤ÎµÎ»ÎµÏÏÎ±Î¯Î¿ ÏÏÎ¼Î²Î¬Î½",
        logOut: "ÎÏÎ¿ÏÏÎ½Î´ÎµÏÎ·",
        machineConfiguration: "ÎÎ¹Î±Î¼ÏÏÏÏÏÎ·",
        maxDispenseAmount: "ÎÎ­Î³Î¹ÏÏÎ¿ ÏÎ¿ÏÏ Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        offlineStatus: "? ÎµÎºÏÏÏ ÏÏÎ½Î´ÎµÏÎ·Ï",
        onlineStatus: "? ÏÎµ ÏÏÎ½Î´ÎµÏÎ·",
        openFrondesk: "ÎÎ½Î¿Î¹Î³Î¼Î± ÏÏÎ¿Î´Î¿ÏÎ®Ï",
        print: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎµÎºÏÏÏÏÏÎ·Ï",
        rebootPC: "ÎÏÎ±Î½ÎµÎºÎºÎ¹Î½Î®ÏÏÎµ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        restartRedlike: "ÎÎ¬Î½ÏÎµ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï %{name}",
        restoreConnection: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ½Î´ÎµÏÎ·Ï",
        scanCanisterBarcode: "Î£Î¬ÏÏÏÎ· barcode ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        scanOrDeleteCanisterBarcode: "Î£Î¬ÏÏÏÎ· Î® Î´Î¹Î±Î³ÏÎ±ÏÎ® barcode",
        setCanisterBarcode: "Set canister barcode",
        swVersion: "ÎÎºÎ´Î¿ÏÎ· Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ",
        systemFunctions: "ÎÎµÎ¹ÏÎ¿ÏÏÎ³Î¯ÎµÏ ÏÏÏÏÎ®Î¼Î±ÏÎ¿Ï",
        userSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÏÎ®ÏÏÎ·"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± Î±ÏÏÏÏÏÏÎ·Ï",
        editColorant: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÏÏÏÎ¹ÎºÏÎ½",
        emptyColorant: "There is colorant with empty amount",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "ÎÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿",
        noBaseSelected: "ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ Î²Î¬ÏÎ·",
        noColorantsSelected: "ÎÎµÎ½ Î­ÏÎ¿ÏÎ½ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÏÏÏÏÎ¹ÎºÎ­Ï",
        noFandeckSelected: "Î¤Î¿ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿ Î±ÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÏÏÎ¿ÏÏÎ½",
        productPreview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· Î ÏÎ¿ÏÏÎ½ÏÎ¿Ï",
        saveCustomRecipe: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        saveIsNotAvailable: "Î Î±ÏÎ¿Î¸Î®ÎºÎµÏÏÎ· Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÎµÎ»Î¬ÏÎ·",
        additionalSettings: "Additional Settings",
        adress: "ÎÎ¹ÎµÏÎ¸ÏÎ½ÏÎ·",
        createAndSelect: "Create and select",
        createNewCustomer: "ÎÎ·Î¼Î¹Î¿ÏÏÎ³Î®ÏÏÎµ Î½Î­Î¿ ÏÎµÎ»Î¬ÏÎ·",
        editCustomer: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÎµÎ»Î¬ÏÎ·",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identification number",
        information: "Î£ÏÎ¿Î¹ÏÎµÎ¯Î± ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î±Ï",
        listOfCustomers: "ÎÎ±ÏÎ¬Î»Î¿Î³Î¿Ï ÏÎµÎ»Î±ÏÏÎ½",
        rabat: "ÎÎºÏÏÏÏÎ·",
        selectCustomer: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎµÎ»Î¬ÏÎ·",
        spentLastMonth: "ÎÎ±ÏÎ±Î½ÏÎ¼ÎµÎ½Î± ÏÏÎ®Î¼Î±ÏÎ± ÎºÎ±ÏÎ¬ ÏÎ¿Î½ ÏÎµÎ»ÎµÏÏÎ±Î¯Î¿ Î¼Î®Î½Î±",
        spentMoney: "ÎÎ±ÏÎ±Î½ÏÎ¼ÎµÎ½Î± ÏÏÎ®Î¼Î±ÏÎ±",
        typeOfMargin: "Î¤ÏÏÎ¿Ï ÎºÎµÏÎ´Î¿ÏÎ¿ÏÎ¯Î±Ï",
        zipCode: "Î¤.Î:"
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "Î Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÎ¿Ï Î±Î½ÏÎ±Î³ÏÎ½Î¹ÏÏÎ¹ÎºÎ¿Ï ÏÏÏÎ¼Î±ÏÎ¿Ï ÎµÎ¯Î½Î±Î¹ ÏÎµ ÎµÎ¾Î­Î»Î¹Î¾Î·",
        reallyChangeModule: "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± Î±Î»Î»Î¬Î¾ÎµÏÎµ ÏÎ·Î½ Î¼Î¿Î½Î¬Î´Î± Î¼Î­ÏÏÎ·ÏÎ·Ï",
        reallyCloseRedlike:
            "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± ÎºÎ»ÎµÎ¯ÏÎµÏÎµ ÏÎ¿ %{name}. ÎÎ»Î± ÏÎ± ÏÎ¬Î½ÎµÎ» %{name} Î¸Î± ÎºÎ»ÎµÎ¯ÏÎ¿ÏÎ½, Î¿Î¹ Î¼Î· Î±ÏÎ¿Î¸Î·ÎºÎµÏÎ¼Î­Î½ÎµÏ Î±Î»Î»Î±Î³Î­Ï Î¸Î± ÏÎ±Î¸Î¿ÏÎ½.",
        reallyDeleteOrder:
            "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± Î´Î¹Î±Î³ÏÎ¬ÏÎµÏÎµ Î±ÏÏÎ®Î½ ÏÎ·Î½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±. ÎÎ»Î± ÏÎ± Î´ÎµÎ´Î¿Î¼Î­Î½Î± ÏÎ¿Ï ÏÏÎ½Î´Î­Î¿Î½ÏÎ±Î¹ Î¼Îµ Î±ÏÏÎ®Î½ ÏÎ·Î½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î± Î¸Î± ÏÎ±Î¸Î¿ÏÎ½.",
        reallyRebootPC:
            "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± ÎºÎ¬Î½ÎµÏÎµ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· Î±ÏÏÎ¿Ï ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®. ÎÎ»Î± ÏÎ± ÏÎ¬Î½ÎµÎ» Î¸Î± ÎºÎ»ÎµÎ¯ÏÎ¿ÏÎ½, Î¿Î¹ Î¼Î· Î±ÏÎ¿Î¸Î·ÎºÎµÏÎ¼Î­Î½ÎµÏ Î±Î»Î»Î±Î³Î­Ï Î¸Î± ÏÎ±Î¸Î¿ÏÎ½.",
        reallyRestartRedlike:
            "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± ÎºÎ¬Î½ÎµÏÎµ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï %{name}. ÎÎ»Î± ÏÎ± ÏÎ¬Î½ÎµÎ» Î¸Î± ÎºÎ»ÎµÎ¯ÏÎ¿ÏÎ½, Î¿Î¹ Î¼Î· Î±ÏÎ¿Î¸Î·ÎºÎµÏÎ¼Î­Î½ÎµÏ Î±Î»Î»Î±Î³Î­Ï Î¸Î± ÏÎ±Î¸Î¿ÏÎ½.",
        reallyShutdownPc:
            "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± ÎºÎ»ÎµÎ¯ÏÎµÏÎµ Î±ÏÏÏÎ½ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®. ÎÎ»Î± ÏÎ± ÏÎ¬Î½ÎµÎ» %{name} Î¸Î± ÎºÎ»ÎµÎ¯ÏÎ¿ÏÎ½, Î¿Î¹ Î¼Î· Î±ÏÎ¿Î¸Î·ÎºÎµÏÎ¼Î­Î½ÎµÏ Î±Î»Î»Î±Î³Î­Ï Î¸Î± ÏÎ±Î¸Î¿ÏÎ½.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "ÎÎ¿ÏÎ¿Î¼ÎµÏÏÎ®ÏÏÎµ Î¼ÏÎ½Î¿ ÏÎ·Î½ Î¼Î­Î³Î¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± ÏÎ¿Ï Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î´Î¿ÏÎ¿Î¼ÎµÏÏÎ·Î¸ÎµÎ¯",
        2: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ· ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÏÎ½ÏÎ±Ï Î¶ÏÎ³Î±ÏÎ¹Î¬ Î³Î¹Î± ÏÎ¿ÏÏÏÎ·ÏÎµÏ ÏÎ¬Î½Ï Î±ÏÏ ÏÎ¿ Î±Î½ÏÏÎ±ÏÎ¿ ÏÏÎ¹Î¿ Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        3: "ÎÏÎ±Î½Î±ÏÎ»Î·ÏÏÏÏÎµ ÎºÎ±ÏÎ¬ ÏÎ· Î´Î¹Î¬ÏÎºÎµÎ¹Î± ÏÎ·Ï ÏÏÏÏÎ·Ï (ÏÏÏÎ¯ÏÏÎµ ÏÎ¿ ÏÎ¿ÏÏ ÏÎµ Î¼Î¹ÎºÏÏÏÎµÏÎ± ÎºÎ¿Î¼Î¼Î¬ÏÎ¹Î±)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "ÎÎ½Î¿Î¼Î± ÏÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï"
    },
    editFormulaRgbModal: {
        apply: "ÎÏÎ±ÏÎ¼Î¿Î³Î®",
        blue: "ÎÏÎ»Îµ",
        green: "Î ÏÎ¬ÏÎ¹Î½Î¿",
        modalLabel: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÏÎ¼Î±ÏÎ¿Ï",
        red: "ÎÏÎºÎºÎ¹Î½Î¿",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Close formula tab automatically",
        allowBarcodes: "ÎÎ± ÎµÏÎ¹ÏÏÎ­ÏÎ¿Î½ÏÎ±Î¹ Î¿Î¹ barcodes",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎµÎ»Î¬ÏÎµÏ",
        allowDeleteConfirmation: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ·Î½ ÎµÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ· Î´Î¹Î±Î³ÏÎ±ÏÎ®Ï",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ %{name}",
        allowOrderNotificationModal: "ÎÎ¼ÏÎ¬Î½Î¹ÏÎ· Î½Î­ÏÎ½ ÎµÎ¹Î´Î¿ÏÎ¿Î¹Î®ÏÎµÏÎ½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        allowOrdering: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ·Î½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±",
        allowPricing: "ÎÎ± ÎµÏÎ¹ÏÏÎ­ÏÎµÏÎ±Î¹ Î· ÏÎ¹Î¼Î¿Î»ÏÎ³Î·ÏÎ·",
        allowPrint: "Allow print",
        allowProductPreviewImage:
            "ÎÎ± ÎµÏÎ¹ÏÏÎ­ÏÎµÏÎ±Î¹ Î· ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÎ·Ï ÎµÎ¹ÎºÏÎ½Î±Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï ÎºÎ±ÏÎ¬ ÏÎ· Î´Î¹Î¬ÏÎºÎµÎ¹Î± ÏÎ·Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "Allow sound notification",
        allowSpectro: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ¿ ÏÎ¬ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿",
        allowTabs: "Allow tabs",
        applyZoom: "ÎÏÎ±ÏÎ¼ÏÏÏÎµ Î¶Î¿ÏÎ¼",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Canister barcodes",
        canisterLevel: "Canister level",
        changelog: "ÎÎ»Î»Î±Î³Î® ÎºÎ±ÏÎ±Î³ÏÎ±ÏÎ®Ï",
        closeTab: "ÎÎ»ÎµÎ¯ÏÎ¹Î¼Î¿ ÎºÎ±ÏÏÎ­Î»Î±Ï",
        colorDifference: "Color difference",
        colorPanelNavItem: "Color Palette",
        competitiveColorSearch: "ÎÎ½ÏÎ±Î³ÏÎ½Î¹ÏÏÎ¹ÎºÎ® Î­Î³ÏÏÏÎ¼Î· Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·",
        customBanner: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ banner",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "Dispensing History",
        dispensingNotes: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ·Î¼ÎµÎ¹ÏÏÎµÎ¹Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        enableCustomers: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ¿ÏÏ ÏÎµÎ»Î¬ÏÎµÏ",
        enableDeleteConfirmation: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ·Î½ ÎµÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ· Î´Î¹Î±Î³ÏÎ±ÏÎ®Ï",
        enableDispensing: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        enableLight: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· %{name}",
        enableMarginMarkup: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ¿ ÏÎµÏÎ¹Î¸ÏÏÎ¹Î¿ Î® ÏÎ· ÏÎ®Î¼Î±Î½ÏÎ·",
        enableNotes: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÎ·Î¼ÎµÎ¹ÏÏÎµÏÎ½",
        enableOrdering: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ·Î½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±",
        enableProductPreviewImage: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ·Î½ ÎµÎ¹ÎºÏÎ½Î± ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ·Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï",
        enableSpectro: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ¿ ÏÎ±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿",
        enableVirtualKeyboard: "ÎÏÎ®ÏÏÎµ ÎµÎ¹ÎºÎ¿Î½Î¹ÎºÏ ÏÎ»Î·ÎºÏÏÎ¿Î»ÏÎ³Î¹Î¿",
        environmentsSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÎµÏÎ¹Î²Î¬Î»Î»Î¿Î½ÏÎ¿Ï",
        exportTranslationKeys: "ÎÎ¾Î±Î³ÏÎ³Î® ÎºÎ»ÎµÎ¹Î´Î¹ÏÎ½ Î¼ÎµÏÎ¬ÏÏÎ±ÏÎ·Ï",
        formulaNotes: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ¹Ï ÏÎ·Î¼ÎµÎ¹ÏÏÎµÎ¹Ï ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        hintTooltips: "Î£ÏÎ¼Î²Î¿ÏÎ»Î­Ï Î¹Î´ÎµÏÎ½",
        image: "ÎÎ¹ÎºÏÎ½Î±",
        keyboardShortcuts: "Î£ÏÎ½ÏÎ¿Î¼ÎµÏÏÎµÎ¹Ï ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        languageBased: "Language based",
        lockYourComputer: "ÎÎ»ÎµÎ¹Î´ÏÏÏÎµ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® ÏÎ±Ï",
        machineReset: "Machine reset",
        manageTranslations: "ÎÎ¹Î±ÏÎµÎ¯ÏÎ¹ÏÎ· Î¼ÎµÏÎ±ÏÏÎ¬ÏÎµÏÎ½",
        margin: "ÎÏÎ½Î¿ ÏÎµÏÎ¹Î¸ÏÏÎ¹Î¿",
        markup: "ÎÏÎ½Î¿ ÏÎ®Î¼Î±Î½ÏÎ·",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "ÎÎ­Î³Î¹ÏÏÎ¿Ï Î±ÏÎ¹Î¸Î¼ÏÏ ÎºÎ±ÏÏÎµÎ»ÏÎ½ ÏÏÏÎ¼Î¿ÏÎ»Î±Ï",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "Î§ÏÏÎ¼Î± + ÎµÎ¹ÎºÏÎ½Î± + ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ",
        navigationItems: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï",
        newTab: "ÎÎ­Î± ÎºÎ±ÏÏÎ­Î»Î±",
        numberOfPriceGroups: "Number of price groups",
        order: "Î£ÎµÎ¹ÏÎ¬",
        orderId: "ÎÏÎ¹Î¸Î¼ÏÏ Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï",
        ordersHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        overwriteLastTab: "Overwrite last formula tab",
        priceCalculation: "Price calculation",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Purchase price only",
        priceDefSellOnly: "Sell price only",
        priceDefinition: "Price definition",
        priceGroupsEnabled: "Enable price groups",
        runLightAtStartUp: "ÎÎºÏÎµÎ»Î­ÏÏÎµ %{light} ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎºÎºÎ¯Î½Î·ÏÎ·",
        screenSaverTimeout: "Screensaver timeout",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "ÎÎºÏÎµÎ»Î­ÏÏÎµ %{name} ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        setCustomHomeButton: "ÎÏÎ¯ÏÏÎµ ÏÎ¿Î½ Î´Î¹Î±ÎºÏÏÏÎ· ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ·Ï",
        setDecimalPlaces: "ÎÏÎ¯ÏÏÎµ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ Î´ÎµÎºÎ±Î´Î¹ÎºÏÎ½ ÏÎ·ÏÎ¯ÏÎ½",
        setFormulaPreview: "ÎÏÎ¹Î»Î¿Î³Î® ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        setFormulaUnit: "ÎÏÎ¯ÏÏÎµ ÏÎ· Î¼Î¿Î½Î¬Î´Î± Î¼Î­ÏÏÎ·ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        setFts: "Î§ÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î®ÏÏÎµ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÎ»Î®ÏÎ¿ÏÏ ÎºÎµÎ¹Î¼Î­Î½Î¿Ï",
        setInfoItemInRgb: "Set visible information in the formula RGB preview",
        setKeyboardShortcuts: "ÎÏÎ¯ÏÏÎµ ÏÏÎ½ÏÎ¿Î¼ÎµÏÏÎµÎ¹Ï ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        setKioskMode: "Î¡ÏÎ¸Î¼Î¯ÏÏÎµ ÏÎ·Î½ ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÎ¿Ï ÎºÎ¹Î²ÏÏÎ¯Î¿Ï",
        setKioskModeOff: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ· Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÏÎ¿Ï ÏÎµÏÎ¯ÏÏÎµÏÎ¿",
        setKioskModeOn: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ· Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÏÎ¿Ï ÎºÎ¹Î²ÏÏÎ¯Î¿Ï",
        setNavigationItems: "ÎÏÎ¯ÏÏÎµ ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï",
        setNavigationItemsList: "ÎÏÎ¯ÏÏÎµ ÏÎ·Î½ Î¿ÏÎ±ÏÏÏÎ·ÏÎ± ÎºÎ±Î¹ ÏÎ· ÏÎµÎ¹ÏÎ¬ ÏÏÎ½ ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï",
        setOrderSearchItems: "ÎÏÎ¯ÏÏÎµ ÏÎ¹Ï ÏÎ±ÏÎ±Î¼Î­ÏÏÎ¿ÏÏ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·Ï ÎµÎ½ÏÎ¿Î»ÏÎ½",
        setRounding: "ÎÏÎ¯ÏÏÎµ ÏÏÏÎ¿Î³Î³ÏÎ»Î¿ÏÎ¿Î¯Î·ÏÎ·",
        setSearchParameters: "ÎÏÎ¹ÏÎ¼ÏÏ ÏÎ±ÏÎ±Î¼Î­ÏÏÏÎ½ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·Ï ÏÏÏÎ¿Ï",
        setTabLimit: "ÎÏÎ¯ÏÏÎµ ÏÎ¿ ÏÏÎ¹Î¿ ÎºÎ±ÏÏÎµÎ»ÏÎ½",
        setYourLanguage: "ÎÏÎ¹Î»Î¿Î³Î® Î³Î»ÏÏÏÎ±Ï",
        setZoom: "Î¡ÏÎ¸Î¼Î¹ÏÎ· Î¶Î¿ÏÎ¼",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "ÎÏÏÎ® Î· ÏÏÎ¸Î¼Î¹ÏÎ· Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î±Î»Î»Î¬Î¾ÎµÎ¹ ÎµÏÎµÎ¹Î´Î® ÏÎ¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î´Î¹Î±Î»ÏÎ³Î¿Ï Î¸Î­ÏÎ· Î´Î¿ÏÎµÎ¯Î¿Ï Î­ÏÎµÎ¹ Î½Î± Î±ÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ ÏÏÎ¹Ï Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¼Î·ÏÎ±Î½Î®Ï",
        sortItems: "Î¤Î±Î¾Î¹Î½ÏÎ¼Î·ÏÎ· ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï",
        startDispensing: "ÎÎµÎºÎ¹Î½Î®ÏÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        stir: "ÎÎ½Î¬Î´ÎµÏÏÎ·"
    },
    error: {
        errorDetail: "ÎÎµÏÏÎ¿Î¼Î­ÏÎµÎ¹ÎµÏ ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï",
        errorOccurred:
            "Î ÏÎ¿Î­ÎºÏÏÎµ Î­Î½Î± Î¼Î· Î±Î½Î±Î¼ÎµÎ½ÏÎ¼ÎµÎ½Î¿ ÏÏÎ¬Î»Î¼Î±. ÎÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î®ÏÏÎµ Î¼Îµ ÏÎ·Î½ ÏÏÎ¿ÏÏÎ®ÏÎ¹Î¾Î· Î¼Î±Ï ÏÏÎ¿ %{0} ÎºÎ±Î¹ Î¸Î± ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î®ÏÎ¿ÏÎ¼Îµ Î¼Î±Î¶Î¯ ÏÎ±Ï ÏÎ¿ ÏÏÎ½ÏÎ¿Î¼ÏÏÎµÏÎ¿ Î´ÏÎ½Î±ÏÏ.",
        hideDetail: "ÎÏÏÎºÏÏÏÎ· Î»ÎµÏÏÎ¿Î¼ÎµÏÎµÎ¹ÏÎ½"
    },
    favoritesTab: {
        addFolder: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÎ±ÎºÎ­Î»Î¿Ï",
        closeTabToLoadFormula: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÎºÎ»Î­Î¹ÏÏÎµ Î­Î½Î± tab ÏÏÎ½ ÏÏÎ½ÏÎ±Î³ÏÎ½.ÎÏÎµÏÎµ ÏÏÎ¬ÏÎµÎ¹ ÏÏÎ¿ Î¼Î­Î³Î¹ÏÏÎ¿ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ tab.",
        deleteFolder: "ÎÎ¹Î±Î³ÏÎ±ÏÎ® ÏÎ±ÎºÎ­Î»Î¿Ï",
        editFolder: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÎ±ÎºÎ­Î»Î¿Ï",
        favoriteFormulas: "ÎÎ³Î±ÏÎ·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï",
        formulaNotes: "Î£Î·Î¼ÎµÎ¹ÏÏÎµÎ¹Ï ÏÏÏÎ¿Ï",
        message: {
            formulasFromFolder: "Î£ÏÎ½ÏÎ±Î³Î­Ï Î±ÏÏ ÏÎ¬ÎºÎµÎ»Î¿",
            moveAllFormulas: "ÎÎµÏÎ±ÎºÎ¹Î½ÎµÎ¯ÏÏÎµ ÏÎ»ÎµÏ ÏÎ¹Ï ÏÏÎ½ÏÎ±Î³Î­Ï Î±ÏÏ Î±ÏÏÏ ÏÎ¿ ÏÎ¬ÎºÎµÎ»Î¿ ÏÏÎ¿Î½ ÏÏÎ¬ÏÏÏÎ½",
            removeAllFormulas: "ÎÏÎ±Î»Î¹ÏÎµÏÎ· ÏÎ»ÏÎ½ ÏÏÎ½ ÏÏÎ½ÏÎ±Î³ÏÎ½ Î±ÏÏ Î±ÏÏÏ ÏÎ¿ ÏÎ¬ÎºÎµÎ»Î¿",
            wantToDeleteFolder: "ÎÎ¯ÏÏÎµ ÏÎ¯Î³Î¿ÏÏÎ¿Î¹ Î³Î¹Î± ÏÎ· Î´Î¹Î±Î³ÏÎ±ÏÎ® ÏÎ¿Ï ÏÎ±ÎºÎ­Î»Î¿Ï?"
        },
        newFolder: "ÎÎ­Î¿Ï ÏÎ¬ÎºÎµÎ»Î¿Ï",
        packages: "Î£ÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ",
        pricePerPackage: "Î¤Î¹Î¼Î® Î±Î½Î¬ ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±",
        regularPrice: "Î¤Î¹Î¼Î® Î¤Î¹Î¼Î¿ÎºÎ±ÏÎ±Î»ÏÎ³Î¿Ï",
        removeFromFavorites: "ÎÏÎ±Î¯ÏÎµÏÎ· Î±ÏÏ ÏÎ± ÎÎ³Î±ÏÎ·Î¼Î­Î½Î±",
        specialPriceOff: "ÎÎ¹Î´Î¹ÎºÎ® ÏÎ¹Î¼Î® %{number}%",
        specialPriceVIP: "ÎÎ¹Î´Î¹ÎºÎ® ÏÎ¹Î¼Î® VIP"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Consumption type",
        filter: "Î¦Î¯Î»ÏÏÎ¿",
        from: "ÎÏÏ",
        to: "Î ÏÎ¿Ï"
    },
    findText: {
        findTextTitle: "Find text",
        removeMarks: "Remove marks",
        search: "Search word"
    },
    flashMessage: {
        VMNotAllowed: "VM not allowed",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Database autologin failed.",
        autotaskDuplicateName:
            "Database integrity error: %{0} item with %{1} %{2} already exists, please use different %{3}",
        barcodeIsUsed: "The barcode is already used.",
        barcodeNotFound: "The barcode was not found",
        bugReportSent: "Your bug report was sent.",
        cannoctConnectToServer: "Cannot connect to server",
        cannotWriteLicense: "Cannot write license",
        clientConnectionRejected: "Connection rejected",
        clientNotLoggedIn: "Client is not logged in",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "No competitive colors could be found. Change searching parameters or select a different color.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Computer backdated",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "License file corrupted",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "The customer was not found",
        dataNotAvailable: "Server cannot connect to database",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "An unexpected error occurred during the last server action",
        deleteAll: "Delete all",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "You can disable the winter plugin by using the drop-down list on the right side of the tab navigation",
        duplicateBarcode: "Duplicate barcode already exists.",
        duplicateName: "Duplicate name already exists",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "License has expired",
        exportSuccess: "Data have been exported successfully",
        fandeckExist: "ÎÏÏÏ ÏÎ¿ ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ ÏÎ½Î¿Î¼Î± fandeck ÏÏÎ¬ÏÏÎµÎ¹ Î®Î´Î·.",
        featureNotAutorized: "Feature not autorized",
        fileExportComplete: "Î¤Î¿ Î±ÏÏÎµÎ¯Î¿ ÎµÎ¾Î®ÏÎ¸ÎµÎ¹ Î¼Îµ ÎµÏÎ¹ÏÏÏÎ¯Î±.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Formula data is not available",
        helperDefaultMessage: "An unexpected error occurred during the last Helper Server action",
        helperServerError: "Helper Server error",
        importAborted: "Import process has been aborted",
        importSuccess: "Data have been imported successfully",
        incompatibleBaseCan: "Base can is not compatible with given product, base and package",
        incorrectPassword: "Your old password is not correct. Please enter a correct one.",
        invalidCurrency: "Currency code is not valid. Euro is set as a default currency.",
        invalidDatabaseName: "Database name is not valid",
        invalidEmail: "Your email is not valid",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Invalid company-user key",
        invalidLicenseFile: "Invalid license file",
        invalidLicenseIdentificationKeys: "Your license identification keys are not valid",
        invalidLicenseKey: "Your license key is not valid",
        invalidLicenseProduct: "License file does not match the product",
        invalidRccResponse: "An unexpected error occurred during processing of the last RCC response",
        invalidServerResponse: "An unexpected error occurred during processing of the last server response",
        invalidUrl: "URL is not valid",
        itemNotFound: "The item was not found",
        keyboardShortcutUsedInModal:
            "This keyboard shortcut cannot be used in the modal window. Please close the modal window.",
        keyboardShortcutValidation: "You cannot have same keyboard shortcut for two different actions",
        licenseHasBeenRevoked:
            "Î Î¬Î´ÎµÎ¹Î¬ ÏÎ±Ï Î­ÏÎµÎ¹ Î±Î½Î±ÎºÎ»Î·Î¸ÎµÎ¯. ÎÎ¹Î± Î½Î± ÏÎ¿ Î±Î½Î±Î½ÎµÏÏÎµÏÎµ, ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î®ÏÏÎµ Î¼Îµ ÏÎ¿Î½ ÏÏÎ¿Î¼Î·Î¸ÎµÏÏÎ® ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÏÎ±Ï.",
        licenseProlongationNeeded:
            "ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÏÎ±ÏÎ¬ÏÎ±ÏÎ· Î¬Î´ÎµÎ¹Î±Ï (ÏÏÎ½Î´Î­ÏÏÎµ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® ÏÏÎ¿ ÎÎ¹Î±Î´Î¯ÎºÏÏÎ¿ Î³Î¹Î± Î½Î± Î±ÏÎ¿ÎºÏÎ®ÏÎµÏÎµ Î½Î­Î± Î¬Î´ÎµÎ¹Î±)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Originally licensed on a different computer",
        logFileArchiveDownloadComplete: "Downloading of log archive was successfully completed",
        loginError: "An unexpected error occurred during logging in",
        logoutError: "An unexpected error occurred during logging out",
        machineIsConnecting: "Machine is connecting, please wait",
        machineIsNotConnected: "Your machine is NOT CONNECTED to RCC. Please check RCC configuration.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maximum amount of tabs, please close one.",
        noTemplate: "Î ÎµÎºÏÏÏÏÏÎ· Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ±Î³Î¼Î±ÏÎ¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯, ÎºÎ±Î¸ÏÏ Î´ÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î± ÏÏÏÏÏÏÎ±.",
        openNewTab: "Please open a new formula tab to load formula using barcode",
        orderAlreadyAcquired: "Order has been already acquired, it has to be released first",
        orderCreated: "Order was successfully sent",
        passwordIsNotUnique: "Old password must differ from the new one.",
        printCannotBeCarriedOut:
            "Î ÎµÎºÏÏÏÏÏÎ· Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ±Î³Î¼Î±ÏÎ¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ ÎºÎ±Î¸ÏÏ ÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÎ¿Ï ÎµÎºÏÏÏÏÏÎ® Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î­Î³ÎºÏÏÎ¿.",
        problemWithFileExport: "Unfortunately, a problem occurred while saving the file to disk.",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "Product is not licensed",
        rccDefaultMessage: "An unexpected error occurred during the last RCC action",
        rccError: "Î£ÏÎ¬Î»Î¼Î± RCC",
        rccNeedRestart: "Please restart your RCC",
        restoredSettings: "Settings have been restored.",
        revokedLicense: "License was revoked",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Formula was successfully saved into history.",
        savedLogArchive: "Log archive was successfully saved into your directory.",
        scanning: "Scanning in progress",
        serverError: "Î£ÏÎ¬Î»Î¼Î± ÎÎ¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
        setClientIdentifier: "Please set your client identifier",
        showLess: "ÎÎµÎ¯Î¾Îµ Î»Î¹Î³ÏÏÎµÏÎ¿",
        showMore: "ÎÎµÎ¯Î¾Îµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎ¿",
        spectroIsDisconnecting: "Spectro is disconnecting, please wait",
        spectroIsNotConnected: "Your spectro is NOT CONNECTED at this moment. Please check RCC configuration.",
        spectroIsNotSelected: "Your spectro is NOT SELECTED at this moment. Please check RCC configuration.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "ÎÎ³Î½ÏÏÏÎ¿ ÏÏÎ¬Î»Î¼Î±: %{0}",
        userAlreadyLoggedIn: "You are already logged in!",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Could not connect to Web Api server",
        webApiInternalError: "Web Api server internal error",
        webApiInvalidUser: "Web Api server invalid user",
        webApiNoLicenseAvailable: "Web Api server no license available",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "ÎÎ±Î½Î¸Î±ÏÎ¼Î­Î½Î· Î¼Î¿ÏÏÎ® ÎµÎ¹ÏÎ±Î³ÏÎ³Î®Ï %{0}.",
        wrongRccVersion: "ÎÎ»Î­Î³Î¾ÏÎµ ÏÎ·Î½ Î­ÎºÎ´Î¿ÏÎ· ÏÎ¿Ï RCC ÏÎ±Ï. Î ÏÎµÎ»Î¬ÏÎ·Ï ÏÎ±Ï ÎµÎ¯Î½Î±Î¹ ÏÏÎ¼Î²Î±ÏÏÏ Î¼ÏÎ½Î¿ Î¼Îµ RCC %{0}."
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "Active user",
        logOut: "ÎÏÎ¿ÏÏÎ½Î´ÎµÏÎ·",
        machineErrors: "Î£ÏÎ¬Î»Î¼Î±ÏÎ± Î¼Î·ÏÎ±Î½Î®Ï"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "All units available in the database",
        allowCustomFormulas: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ¹Ï ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï",
        allowCustomPackageSize: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ¿ ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ Î¼Î­Î³ÎµÎ¸Î¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï",
        allowFormulaAutomaticNaming: "ÎÎ± ÎµÏÎ¹ÏÏÎ­ÏÎµÏÎ±Î¹ Î· Î±ÏÏÏÎ¼Î±ÏÎ· Î¿Î½Î¿Î¼Î±ÏÎ¯Î±",
        automaticNaming: "ÎÏÏÏÎ¼Î±ÏÎ· Î¿Î½Î¿Î¼Î±ÏÎ¯Î± ÏÏÎ½ÏÎ±Î³Î®Ï",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Color palette",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "ÎÎ½ÏÎ±Î³ÏÎ½Î¹ÏÏÎ¹ÎºÎ® Î­Î³ÏÏÏÎ¼Î· Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Custom Formulas",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ Î¼Î­Î³ÎµÎ¸Î¿Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï",
        customUnits: "Choose custom units",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÏÏÏÎ¹ÎºÏÎ½",
        editColorantsAllowed: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ·Î½ ÎµÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÏÏÏÎ¹ÎºÏÎ½",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "ÎÎ³Î±ÏÎ·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï",
        formulaColorPreview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· Î±ÏÏÏÏÏÏÎ·Ï",
        formulaDataSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ½ÏÎ±Î³Î®Ï",
        formulaPanel: "Î Î¯Î½Î±ÎºÎ±Ï ÏÏÏÏÎ½",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Gravimetric units only",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Unit depends on the selected product",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Quick select",
        setAdditionalFormulaPanel: "ÎÏÎ¯ÏÏÎµ ÎµÏÎ¹ÏÎ»Î­Î¿Î½ ÏÎ¯Î½Î±ÎºÎ± ÏÏÎ½ÏÎ±Î³Î®Ï",
        setCompetitiveColorSearch: "Enable competitive color search",
        setInitialFormulaPanel: "ÎÏÎ¯ÏÏÎµ ÏÎ¿Î½ Î±ÏÏÎ¹ÎºÏ ÏÎ¯Î½Î±ÎºÎ± ÏÏÎ½ÏÎ±Î³Î®Ï",
        setMaxToleranceForCompetitiveColors: "ÎÏÎ¯ÏÏÎµ Î¼Î­Î³Î¹ÏÏÎ· Î±Î½Î¿ÏÎ® Î³Î¹Î± Î±Î½ÏÎ±Î³ÏÎ½Î¹ÏÏÎ¹ÎºÎ® Î­Î³ÏÏÏÎ¼Î· Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·",
        setNumberOfCompetitiveColors: "ÎÏÎ¯ÏÏÎµ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ Î±Î½ÏÎ±Î³ÏÎ½Î¹ÏÏÎ¹ÎºÏÎ½ ÏÏÏÎ¼Î¬ÏÏÎ½",
        setSearchPanel: "ÎÏÎ¹ÏÎ¼ÏÏ ÏÎ»Î±Î¹ÏÎ¯Î¿Ï Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·Ï",
        setVisibilityAndOrder: "ÎÏÎ¯ÏÏÎµ ÏÎ·Î½ Î¿ÏÎ±ÏÏÏÎ·ÏÎ± ÎºÎ±Î¹ ÏÎ· ÏÎµÎ¹ÏÎ¬ ÏÏÎ½ Î´Î¹Î±ÏÏÏÏÎ½ ÏÏÏÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ½ÏÎ±Î³Î®Ï",
        setVisibleUnit: "ÎÏÎ¯ÏÏÎµ Î¿ÏÎ±ÏÎ­Ï Î¼Î¿Î½Î¬Î´ÎµÏ",
        showColorPreview: "ÎÎ¼ÏÎ¬Î½Î¹ÏÎ· Î±ÏÏÏÏÏÏÎ·Ï",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "Use selection item for base",
        useBaseInProductPackage: "Use selection item for base in product package",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Use selection item for product",
        useProductCode: "Use product code",
        useProductGroups: "Use product groups",
        volumetricOnly: "Volumetric units only"
    },
    general: {
        accepted: "Accepted",
        active: "Î¤ÎµÎ»ÎµÏÏÎ±Î¯Î± Î´ÏÎ±ÏÏÎ·ÏÎ¹ÏÏÎ·ÏÎ±",
        actual: "Î¤ÏÎ­ÏÎ¿ÏÏÎ±",
        actualLevel: "Î¤ÏÎ­ÏÎ¿Î½ ÎµÏÎ¯ÏÎµÎ´Î¿",
        add: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ·",
        addColorant: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÏÏÏÎ¹ÎºÎ®Ï",
        addColorantForPackage: "Add colorant for package",
        addFile: "Add file",
        all: "ÎÎ»Î±",
        amount: "Î Î¿ÏÏ",
        applyNow: "Apply now",
        attachments: "Attachments",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "Available",
        back: "Î Î¯ÏÏ",
        base: "ÎÎ¬ÏÎ·",
        baseInProductPackage: "ÎÎ¬ÏÎ· ÏÏÎ¿ ÏÏÎ¿ÏÏÎ½ ÎºÎ±Î¹ ÏÏÎ· ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±",
        batchNumber: "Batch number",
        bottom: "ÎÎ¬ÏÏ Î¼Î­ÏÎ¿Ï",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "ÎÎ¿ÏÎµÎ¯Î¿",
        canSize: "Î¼Î­Î³ÎµÎ¸Î¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        cancel: "ÎÎºÏÏÏÏÎ·",
        canister: "Canister",
        canisterId: "ID ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        canisterIndex: "Canister Index",
        canisters: "ÎÎ¬Î½Î¹ÏÏÏÎ±",
        cap: "ÎÎ»ÎµÎ¯ÏÏÏÎ¿",
        capacity: "Î§ÏÏÎ·ÏÎ¹ÎºÏÏÎ·ÏÎ±",
        channels: "ÎÎ±Î½Î¬Î»Î¹Î±",
        choose: "ÎÏÎ¹Î»Î­Î³Ï",
        city: "Î ÏÎ»Î·",
        clean: "ÎºÎ±Î¸Î±ÏÏ",
        clear: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ",
        client: "Î ÎµÎ»Î¬ÏÎ·Ï",
        close: "ÎÎ»ÎµÎ¯ÏÎµ",
        closeAll: "Close all",
        collapseAll: "Collapse all",
        color: "ÎÏÏÏÏÏÏÎ·",
        colorCode: "ÎÏÎ´Î¹ÎºÏÏ ÏÏÏÎ¼Î±ÏÎ¿Ï",
        colorFile: "Colorfile",
        colorName: "ÎÎ½Î¿Î¼Î± ÏÏÏÎ¼Î±ÏÎ¿Ï",
        colorPreview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï",
        colorant: "Î§ÏÏÏÏÎ¹ÎºÎ®",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Î Î±ÎºÎ­ÏÎ¿ ÏÏÏÏÏÎ¹ÎºÏÎ½",
        colorants: "Î§ÏÏÏÏÎ¹ÎºÎ­Ï",
        colors: "Colors",
        company: "ÎÏÎ±Î¹ÏÎ¯Î±",
        competitiveColor: "Competitive color",
        confirm: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÎ½Ï",
        confirmDeletion: "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± Î´Î¹Î±Î³ÏÎ¬ÏÎµÏÎµ Î±ÏÏÏ ÏÎ¿ ÏÏÎ¿Î¹ÏÎµÎ¯Î¿ Î¼ÏÎ½Î¹Î¼Î±",
        confirmHelpSettings: "ÎÎ­Î»ÎµÏÎµ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÎ¬ Î½Î± Î±ÏÎ¿Î¸Î·ÎºÎµÏÏÎµÏÎµ ÏÎ· ÏÏÏÎ¼Î± ÎºÎ±Î¹ Î½Î± Î±ÏÎ®ÏÎµÏÎµ ÏÎ± ÏÎµÎ´Î¯Î± ÎºÎµÎ½Î¬",
        connect: "Î£ÏÎ½Î´Î­Ï",
        continue: "ÎÎ± ÏÏÎ½ÎµÏÎ¯ÏÎµÎ¹",
        correction: "Correction",
        country: "Country",
        created: "ÎÎ·Î¼Î¹Î¿ÏÏÎ³Î®Î¸Î·ÎºÎµ",
        creationDateOf: "Creation date of",
        criticalLevel: "ÎÏÎ¯ÏÎ¹Î¼Î¿ ÎµÏÎ¯ÏÎµÎ´Î¿",
        currency: "Currency",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿",
        customData: "Custom data",
        customFandeck: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        customFormula: "Custom formula",
        customPackage: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿",
        customPackageSettings: "Custom package settings",
        customer: "Î ÎµÎ»Î¬ÏÎ·Ï",
        customerVersion: "ÎÎºÎ´Î¿ÏÎ· ÏÎµÎ»Î¬ÏÎ·",
        customers: "Î ÎµÎ»Î¬ÏÎ·Ï",
        database: "ÎÎ¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        date: "ÎÎ¼ÎµÏÎ¿Î¼Î·Î½Î¯Î±",
        default: "Default",
        delete: "ÎÎ¹Î±Î³ÏÎ±ÏÎ®",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Î ÎµÏÎ¹Î³ÏÎ±ÏÎ®",
        disconnect: "ÎÏÎ¿ÏÏÎ½Î´Î­ÏÏÎµ",
        discount: "Discount",
        discover: "ÎÎ½Î±ÎºÎ±Î»ÏÏÏÏ",
        dispense: "ÎÎ¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·",
        dispensing: "ÎÎ¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·",
        doNotShowAgain: "Do not show this message again.",
        downloadingFile: "ÎÎ®ÏÎ· Î±ÏÏÎµÎ¯ÏÎ½",
        edit: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î±",
        email: "ÎÎ»ÎµÎºÏÏÎ¿Î½Î¹ÎºÎ® Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ·",
        enabled: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®Î¸Î·ÎºÎµ",
        error: "ÎÎ¬Î¸Î¿Ï",
        expandAll: "Expand all",
        exportData: "Export data",
        exportPdf: "Export PDF",
        fan: "Î§ÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        fandeck: "Î§ÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        fandeckCode: "Fandeck code",
        fandeckName: "ÎÎ½Î¿Î¼Î± ÏÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        fandecks: "Fandecks",
        favorite: "ÎÎ³Î±ÏÎ·Î¼Î­Î½Î¿",
        fileTransfer: "File transfer",
        filling: "Î Î»Î®ÏÏÏÎ·",
        fillingDate: "Filling date",
        find: "ÎÏÏÎµÏÎ·",
        finish: "Finish",
        finishedCorrection: "Finished correction",
        formula: "Î£ÏÎ½ÏÎ±Î³Î®",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "ÎÏÎ¿ÎºÏÎ®ÏÏÎµ ÏÎ¿Î½ ÎºÏÎ´Î¹ÎºÏ QR",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "ÎÏÏÎ¿ÏÎ¯Î±",
        hours: "Hou.",
        id: "Id",
        images: "Images",
        in: "In",
        index: "Index",
        insertBarcode: "ÎÎ¹ÏÎ±Î³Î¬Î³ÎµÏÎµ ÏÎ¿Î½ Î³ÏÎ±Î¼Î¼ÏÏÏ ÎºÏÎ´Î¹ÎºÎ±",
        install: "ÎÎ³ÎºÎ±Î¸Î¹ÏÏÏ",
        installed: "ÎÎ³ÎºÎ±ÏÎ±ÏÏÎ®Î¸Î·ÎºÎµ",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ· IP",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "Î¦ÏÏÏÏÏÎ· ÏÏÏÎ¼Î¿ÏÎ»Î±Ï",
        localVersion: "Î¤Î¿ÏÎ¹ÎºÎ® Î­ÎºÎ´Î¿ÏÎ·",
        machine: "ÎÎ·ÏÎ±Î½Î®",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "Î ÎµÏÎ¹Î¸ÏÏÎ¹Î¿",
        markup: "ÎÎ±ÏÎºÎ¬ÏÎ¹ÏÎ¼Î±",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "ÎÎ­Î³Î¹ÏÏÎ· ÏÏÎ¬Î¸Î¼Î·",
        maxValue: "Max value",
        maximum: "ÎÎ½ÏÏÎ±ÏÎ¿ ÏÏÎ¹Î¿",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "ÎÎ»Î¬ÏÎ¹ÏÏÎ¿",
        minutes: "Min.",
        missingItem: "ÎÎµÎ¯ÏÎµÎ¹ ÏÏÎ¿Î¹ÏÎµÎ¯Î¿",
        missingRequiredItems: "ÎÎ»Î± ÏÎ± Î±ÏÎ±Î¹ÏÎ¿ÏÎ¼ÎµÎ½Î± Î±Î½ÏÎ¹ÎºÎµÎ¯Î¼ÎµÎ½Î± (ÎµÏÎ¹ÏÎ·Î¼Î±Î¯Î½Î¿Î½ÏÎ±Î¹ Î¼Îµ Î±ÏÏÎµÏÎ¯ÏÎºÎ¿) ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸Î¿ÏÎ½",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Î ÎµÏÎ¹ÏÏÏÏÎµÏÎ¿",
        moreInfo: "Î ÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ",
        moveDown: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÎ¬Î½Ï",
        moveUp: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÎºÎ¬ÏÏ",
        myOrders: "ÎÎ¹ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯ÎµÏ Î¼Î¿Ï",
        name: "ÎÎ½Î¿Î¼Î±",
        nameTitle: "ÎÎ½Î¿Î¼Î±",
        new: "ÎÎ­Î¿Ï",
        next: "ÎÏÏÎ¼ÎµÎ½Î¿",
        no: "ÎÏÎ¹",
        noColorantsAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÏÏÏÏÏÎ¹ÎºÎ­Ï",
        noFormulas: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î±ÎºÏÎ¼Î· ÏÏÏÎ¿Î¹",
        noPricesAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÏÎ¹Î¼Î­Ï",
        nominalAmount: "ÎÎ½Î¿Î¼Î±ÏÏÎ¹ÎºÏ ÏÎ¿ÏÏ",
        notAvailable: "ÎÎ· Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿Ï",
        note: "Î£Î·Î¼ÎµÎ¹ÏÏÎµÎ¹Ï",
        numberOfCanisters: "ÎÏÎ¹Î¸Î¼ÏÏ ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "ÎÏÎ¹Î¸Î¼ÏÏ ÎµÏÎ¹ÎºÎµÏÏÎ½",
        numberOfPackages: "ÎÏÎ¹Î¸Î¼ÏÏ ÏÏÏÎºÎµÏÎ±ÏÎ¹ÏÎ½",
        off: "ÎÎ±ÎºÏÎ¹Î¬ Î±ÏÏ",
        ok: "ÎÎ½ÏÎ¬Î¾ÎµÎ¹",
        on: "ÎÎ½Î¿Î¹ÏÏÏ",
        onFocus: "On focus",
        open: "ÎÎ½Î¿Î¹Î¾Îµ",
        operator: "Operator",
        options: "ÎÏÎ¹Î»Î¿Î³Î­Ï",
        order: "Order",
        other: "ÎÎ»Î»Î¿",
        otherError: "ÎÎ»Î»Î¿ ÏÏÎ¬Î»Î¼Î±",
        out: "Out",
        overwrite: "Overwrite",
        package: "Î£ÏÏÎºÎµÏÎ±ÏÎ¯Î±",
        packagePreview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÎ±ÎºÎ­ÏÎ¿Ï",
        partialUpdates: "Partial updates",
        phone: "Î¤Î·Î»Î­ÏÏÎ½Î¿",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Î¤Î¹Î¼Î®",
        priceGroup: "Price group",
        print: "ÎÎºÏÏÏÏÏÎ·",
        printTask: "Print task",
        processingStep: "Processing %{step}",
        product: "Î ÏÎ¿ÎÏÎ½",
        productCode: "Product code",
        productName: "Product name",
        products: "Î ÏÎ¿ÏÏÎ½ÏÎ±",
        pump1: "ÎÎ½ÏÎ»Î¯Î± 1",
        pump2: "ÎÎ½ÏÎ»Î¯Î± 2",
        purchasePrice: "Purchase price",
        purge: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ",
        qualityControl: "Quality control",
        quantity: "Î Î¿ÏÏÏÎ·ÏÎ±",
        quantityQty: "QTY",
        quickTint: "ÎÏÎ®Î³Î¿ÏÎ· ÎÎ¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·",
        rccIsNotAvailable: "Î¤Î¿ RCC Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿",
        rccIsNotConnected: "Î¤Î¿ RCC Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿",
        rccNotLicensed: "Î¤Î¿ RCC Î´ÎµÎ½ Î´Î¹Î±Î¸Î­ÏÎµÎ¹ Î¬Î´ÎµÎ¹Î±",
        reconnect: "ÎÏÎ±Î½Î±ÏÏÎ½Î´ÎµÏÎ·",
        refill: "Î Î»Î®ÏÏÏÎ·",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬",
        restart: "ÎÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ·",
        restore: "Restore",
        retint: "Retint",
        revision: "ÎÎ½Î±Î¸ÎµÏÏÎ·ÏÎ·",
        safetySheet: "Safety sheet",
        save: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ·",
        saveAs: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏ",
        saveToDispensingHistory: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¿ Î¹ÏÏÎ¿ÏÎ¹ÎºÏ",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "ÎÏÎ¹Î»Î¿Î³Î® ÏÎ»ÏÎ½",
        selectChannels: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Sell price",
        settings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï",
        shelf: "Î¡Î¬ÏÎ¹",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Size",
        skip: "Î Î±ÏÎ±Î»ÎµÎ¯ÏÏ",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Î¦Î±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿",
        standardFormula: "Standard formula",
        status: "ÎÎ±ÏÎ¬ÏÏÎ±ÏÎ·",
        street: "ÎÏÏÎ¼Î¿Ï",
        sum: "Sum",
        summary: "Î ÎµÏÎ¯Î»Î·ÏÎ·",
        sync: "Î£ÏÎ³ÏÏÎ¿Î½Î¹ÏÎ¼ÏÏ",
        technicalSheet: "Technical sheet",
        templates: "Î ÏÏÏÏÏÎ±",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "To Dispense Orders",
        top: "ÎºÎ¿ÏÏÏÎ®",
        total: "Î£ÏÎ½Î¿Î»Î¿",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "UFI code",
        ufiThreshold: "UFI threshold",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "ÎÎ¿Î½Î¬Î´ÎµÏ",
        unknown: "Unknown",
        update: "ÎÎ½Î±Î²Î¬Î¸Î¼Î¹ÏÎ·",
        updated: "ÎÎ½Î±Î²Î±Î¸Î¼Î¹ÏÎ¼Î­Î½Î¿",
        user: "Î§ÏÎ®ÏÏÎ·Ï",
        value: "Value",
        vat: "Î¦Î Î ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï",
        verified: "Verified",
        version: "ÎÎºÎ´Î¿ÏÎ·",
        versionId: "ÎÎ½Î±Î³Î½ÏÏÎ¹ÏÏÎ¹ÎºÏ Î­ÎºÎ´Î¿ÏÎ·Ï",
        versionStructure: "ÎÎºÎ´Î¿ÏÎ·Ï Î´Î¿Î¼Î®Ï",
        volumetric: "Volumetric",
        warning: "Î ÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¯Î·ÏÎ·",
        warningLevel: "ÎÏÎ¯ÏÎµÎ´Î¿ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·Ï",
        withoutName: "(without name)",
        workingProperly: "Working properly",
        yes: "ÎÎ±Î¹",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Allows to add a new server manually if it could not be detected via the Discover function.",
            clientIdentifier:
                "The setting enables to identify this client if there are more clients connected to one server.",
            disconnect:
                "Information about the currently used server. The disconnect button allows to leave this server and switch to another one if available.",
            discover: "Discovers whether there are any other servers available in the network.",
            dropServers: "Deletes all previously detected servers from the list.",
            dropServersNotAvailable: "No server available",
            edit: "Allows to manually edit an already found server.",
            editDisabled: "No server selected."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿ ÏÎ½Î¿Î¼Î± ÎºÎµÎ½ÏÏÎ¹ÎºÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® Î® ÏÎ· Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ· IP ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®.",
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»Î± ÏÎ± Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ± Alfa. Windows ÎºÎ±Î¹ Linux."
            },
            corobDsProxy: {
                machineType:
                    "ÎÏÏÏÎµÎ¹ Î³Î¹Î± Î³ÎµÎ½Î¹Î­Ï Slave (D200, D600 ..), 4G (First One) ÎºÎ±Î¹ 5G (EvoFlx). Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÏÎ¿ DspProxy. ÎÏÎ½Î¿ Î³Î¹Î± Windows."
            },
            corobEvoDriver: {
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± Î³ÎµÎ½Î¹Î¬ 5G (EvoFlx). Î ÏÏÎ·ÏÎµÏÎ¯Î± EVO ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯. Windows ÎºÎ±Î¹ Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î±. Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿.",
                hldRootDir: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿Î½ ÎºÏÏÎ¹Î¿ ÏÎ¬ÎºÎµÎ»Î¿ ÏÎ¿Ï HLD. Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿.",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "ÎÏÏÏÎµÎ¹ Î³Î¹Î± Î³ÎµÎ½Î¹Î­Ï Slave (D200, D600 ..), 4G (First One) ÎºÎ±Î¹ 5G (EvoFlx). Î¤Î¿ NextDriver ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯. ÎÏÎ½Î¿ Linux."
            },
            dromontDDrv: {
                databasePath:
                    "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î¼Îµ Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î²Î±Î¸Î¼Î¿Î½ÏÎ¼Î·ÏÎ·Ï. Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿.",
                driverPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿Ï ÏÎ¿ ÏÏÏÎ³ÏÎ±Î¼Î¼Î± Î¿Î´Î®Î³Î·ÏÎ·Ï (D_DRV.exe). Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿.",
                machineType:
                    "ÎÎ¼Î¼ÎµÏÎ· ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î± Î´Î¹Î±Î½Î¿Î¼Î­Î± Î¼Î­ÏÏ ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½ÏÎ½ Î´Î¹Î±Î´ÏÎ¿Î¼ÏÎ½. ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ¹Ï Î³ÎµÎ½Î¹Î­Ï V1 ÎºÎ±Î¹ V2. Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÏÎ¿ D_SET. Windows ÎºÎ±Î¹ Linux.",
                resultPath:
                    "Î Î´Î¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿Ï ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î±ÏÎ¿ÏÎµÎ»ÎµÏÎ¼Î¬ÏÏÎ½ ÏÎ¿Ï Î´Î·Î¼Î¹Î¿ÏÏÎ³Î®Î¸Î·ÎºÎµ Î¼ÎµÏÎ¬ ÏÎ·Î½ Î¿Î»Î¿ÎºÎ»Î®ÏÏÏÎ· ÏÎ·Ï Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î±Ï. Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿.",
                serviceSoftwarePath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ ÏÏÎ·ÏÎµÏÎ¯Î±Ï Dromont (D_SET.exe). Î ÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿ Defalut."
            },
            dromontDirect: {
                machineType:
                    "ÎÎ¼ÎµÏÎ· ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î± Î´Î¹Î±Î½Î¿Î¼Î­Î±. ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ¹Ï Î³ÎµÎ½Î¹Î­Ï V1 ÎºÎ±Î¹ V2. Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÏÎ¿ D_SET. Windows ÎºÎ±Î¹ Linux.",
                rootDir: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ¿Î½ ÎºÏÏÎ¹Î¿ ÏÎ¬ÎºÎµÎ»Î¿ Dromont"
            },
            dromontMisura: {
                driverPath:
                    "Î Î´Î¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿Ï ÏÎ¿ ÏÏÏÎ³ÏÎ±Î¼Î¼Î± Î¿Î´Î®Î³Î·ÏÎ·Ï (MisuraRetail.exe) ÎµÎ½Î´Î­ÏÎµÏÎ±Î¹ Î½Î± Î±Î»Î»Î¬Î¾ÎµÎ¹ Î²Î¬ÏÎµÎ¹ ÏÎ·Ï Î­ÎºÎ´Î¿ÏÎ·Ï Misura Retail. Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÎ¿ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î¿.",
                extensionPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿Ï Î±ÏÏÎµÎ¯Î¿ ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î±Ï Î³Î¹Î± ÎµÎ½Î­ÏÎ³ÎµÎ¹ÎµÏ ÏÏÎ·ÏÎµÏÎ¯Î±Ï.",
                formulaPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿Ï Î±ÏÏÎµÎ¯Î¿ ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î±Ï Î³Î¹Î± Î´Î¹Î±Î½Î¿Î¼Î®.",
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ· Î³ÎµÎ½Î¹Î¬ V3. Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÏÎ¿ Dromont Misura. ÎÏÎ½Î¿ Î³Î¹Î± Windows."
            },
            fastAndFluidIDD: {
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»Î± ÏÎ± Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ± F & F. ÎÏÎ½Î¿ Î³Î¹Î± Windows.",
                path: "Î¥ÏÎ¿ÏÏÎ·ÏÎ¯Î¶Î¿Î½ÏÎ±Î¹ Î¿Î¹ IDD2 (HA 450, HA 650, X-smart Îº.Î»Ï.) - ÏÏÎ­ÏÎµÎ¹ Î½Î± Î´Î¹Î±Î¸Î­ÏÎ¿ÏÎ½ Î¬Î´ÎµÎ¹Î±, IDD3 (HP 500, Îº.Î»Ï.), IDD4 (HA 180, HA 480, HA 680, Xprotint Îº.Î»Ï.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»Î± ÏÎ± Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ± F & F. Windows ÎºÎ±Î¹ Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï Î¼Î·ÏÎ±Î½Î­Ï Hero. ÎÏÎ½Î¿ Î³Î¹Î± Windows."
            },
            italtinto: {
                machineType:
                    "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï Î¼Î·ÏÎ±Î½Î­Ï Italtinto. Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÏÎ¿ Wcal Î® ÏÎ¿ ItaltintoCal. ÎÏÎ½Î¿ Î³Î¹Î± Windows.",
                path: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ Î±ÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï Italtinto."
            },
            manualAdvanced: {
                machineType:
                    "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï Î¼Î· Î±ÏÏÏÎ¼Î±ÏÎµÏ Î¼Î·ÏÎ±Î½Î­Ï, ÏÎµÏÎ¹Î»Î±Î¼Î²Î¬Î½ÎµÏÎ±Î¹ ÏÏÎ¿ÏÏÎ®ÏÎ¹Î¾Î· Î¼ÎµÏÎ±Î»Î»Î¹ÎºÏÎ½ ÎºÎ¿ÏÏÎ¹ÏÎ½. Windows ÎºÎ±Î¹ Linux.",
                path: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï Î¼Îµ Î´ÎµÎ´Î¿Î¼Î­Î½Î± ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ¿ Î´Î¹Î±Î½Î¿Î¼Î­Î± ÎºÎ±Î¹ ÏÎ± Î´Î¿ÏÎµÎ¯Î±."
            },
            manualSimple: {
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ± Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ±. Windows ÎºÎ±Î¹ Linux.",
                path: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï Î¼Îµ Î´ÎµÎ´Î¿Î¼Î­Î½Î± ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ¿ Î´Î¹Î±Î½Î¿Î¼Î­Î±."
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "ÎÏÏÏÎµÎ¹ Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï Î¼Î·ÏÎ±Î½Î­Ï Santint. ÎÏÎ½Î¿ Î³Î¹Î± Windows."
            },
            simulation: {
                machineType:
                    "ÎÏÏÏÎµÎ¹ Î³Î¹Î± Î´Î¹Î±Î½Î¿Î¼Î­Î± ÏÏÎ¿ÏÎ¿Î¼Î¿Î¯ÏÏÎ·Ï ÎµÎ¬Î½ Î´ÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ ÏÏÎ±Î³Î¼Î±ÏÎ¹ÎºÏÏ Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿Ï ÏÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®.",
                path: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿Ï ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï ÏÏÎ¿ÏÎ¿Î¼Î¿Î¯ÏÏÎ·Ï ÏÎ¿Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ¼ÏÏÎ½Î¿ Î¼Îµ ÏÎ·Î½ ÎµÎ¹ÏÎ±Î³ÏÎ¼ÎµÎ½Î· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart:
                "ÎÎµ Î±ÏÏÎ®Î½ ÏÎ· ÏÏÎ¸Î¼Î¹ÏÎ·, ÏÎ¿ %{name} Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î±ÏÏÏÎ¼Î±ÏÎ± Î¼ÎµÏÎ¬ ÏÎ·Î½ ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®.",
            allowAutomaticPrint:
                "Î ÎµÏÎ¹ÎºÎ­ÏÎ± Î¸Î± ÎµÎºÏÏÏÏÎ¸ÎµÎ¯ Î±ÏÏÏÎ¼Î±ÏÎ±. ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÏÎµÏÎ±Î¹ÏÎ­ÏÏ ÏÏÎ¸Î¼Î¹ÏÎ· ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ· ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®, Î¼ÎµÏÎ¬ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® Î® ÎºÎ±Î¹ ÏÎ± Î´ÏÎ¿.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Î£ÏÎ¿ ÏÎ¼Î®Î¼Î± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î· ÎµÎ½ÏÏÎ·ÏÎ± ÏÏÎ½ ÏÎµÎ»Î±ÏÏÎ½ Î¸Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ¿ÏÎ²Î¬ÏÎ¹Î¼Î·.",
            allowDispensing: "On Formula panel, Dispense button  will be activated.",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} will be accessible..",
            allowOrdering: "Î£ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î¸Î± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï.",
            allowPricing:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Formula, Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î·Î¸Î¿ÏÎ½ Î¿Î¹ ÏÎ¹Î¼Î­Ï. Î ÏÏÎ¿Î²Î¿Î»Î® ÏÏÎ½ ÏÎ¹Î¼ÏÎ½ Î¿ÏÎ¯Î¶ÎµÏÎ±Î¹ ÏÏÎ¹Ï ÎÎ¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ Î¤Î¹Î¼Î­Ï. ÎÎ¹ ÏÎ¹Î¼Î­Ï ÎºÎ±Î¸Î¿ÏÎ¯Î¶Î¿Î½ÏÎ±Î¹ ÏÏÎ¹Ï Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¤Î¹Î¼Î®Ï.",
            allowProductPreviewImage: "Î ÎµÎ¹ÎºÏÎ½Î± ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î¸Î± ÎµÎ¼ÏÎ±Î½Î¹ÏÏÎµÎ¯ ÎºÎ±ÏÎ¬ ÏÎ· Î´Î¹Î¬ÏÎºÎµÎ¹Î± ÏÎ·Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification:
                "Î ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ· ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·Ï Î®ÏÎ¿Ï Î±Î½Î±ÏÎ±ÏÎ¬Î³ÎµÎ¹ Î¼Î¿ÏÏÎ¹ÎºÎ® Î¼ÎµÎ»ÏÎ´Î¯Î± ÏÏÎ±Î½ ÏÎ±ÏÎ±Î»Î±Î¼Î²Î¬Î½ÎµÏÎ±Î¹ Î¼Î¹Î± ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±.",
            allowSpectro: "Î¤Î¿ ÏÎ¼Î®Î¼Î± Spectro Î¸Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ¿ÏÎ²Î¬ÏÎ¹Î¼Î¿.",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom:
                "Î¤Î¿ Î¶Î¿ÏÎ¼ Î¼ÎµÎ³ÎµÎ¸ÏÎ½ÎµÎ¹ Î® Î¼ÎµÎ¹ÏÎ½ÎµÎ¹ ÏÎ·Î½ Î±Î½Î¬Î»ÏÏÎ·. ÎÎ¹ ÏÏÎ½ÏÎ¿Î¼ÎµÏÏÎµÎ¹Ï ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï CTRL + ÎºÎ±Î¹ CTRL - Î¹ÏÏÏÎ¿ÏÎ½ ÎµÏÎ¯ÏÎ·Ï.",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases:
                "ÎÎ¹ ÏÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎµÏÎ¹ÏÏÎ­ÏÎ¿ÏÎ½ ÏÎ·Î½ ÎµÎ½Î±Î»Î»Î±Î³Î® Î¼ÎµÏÎ±Î¾Ï Î²Î¬ÏÎµÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÎµÎ¬Î½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ Î±ÏÏ Î¼Î¯Î± Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Î¤Î¿ ÏÎµÏÎ¹Î²Î¬Î»Î»Î¿Î½ Î´Î¿ÎºÎ¹Î¼ÏÎ½ barcode ÏÏÎ·ÏÎ¹Î¼ÎµÏÎµÎ¹ ÏÏÎ¿Î½ Î­Î»ÎµÎ³ÏÎ¿ ÏÎ·Ï Î¿ÏÎ¸ÏÏÎ·ÏÎ±Ï ÏÎ¿Ï ÏÎ±ÏÏÎ¼Î­Î½Î¿Ï Î³ÏÎ±Î¼Î¼Î¹ÎºÎ¿Ï ÎºÏÎ´Î¹ÎºÎ± ÏÏÎ³ÎºÏÎ¯Î½Î¿Î½ÏÎ¬Ï ÏÎ¿Î½ Î¼Îµ ÏÎ¿ÏÏ Î³ÏÎ±Î¼Î¼ÏÏÎ¿ÏÏ ÎºÏÎ´Î¹ÎºÎ¿ÏÏ ÏÎ¿Ï Î­ÏÎ¿ÏÎ½ ÎµÎ¹ÏÎ±ÏÎ¸ÎµÎ¯ ÏÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½.",
            customBanner: "ÎÏÎ¯ÏÏÎµ ÏÎ¿ Î´Î¹ÎºÏ ÏÎ±Ï Î»Î¿Î³ÏÏÏÏÎ¿ Î® banner ÎºÎ±Î¹ ÏÎ· Î¸Î­ÏÎ· ÏÎ¿Ï.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "Î ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿Ï ÎµÎºÏÏÏÏÏÎ®Ï Î¸Î± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ· ÎµÏÎ¹ÎºÎµÏÏÎ½ ÎµÎºÏÏÏ Î±Î½ Î±Î»Î»Î¬Î¾ÎµÎ¹ ÏÏÎ¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ ÎµÏÎ¹Î»Î¿Î³ÏÎ½ ÎµÎºÏÏÏÏÏÎ®.",
            defaultTemplate:
                "Î¤Î¿ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÏÏÏÏÎ¿ Î¸Î± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ· ÎµÏÎ¹ÎºÎµÏÏÎ½ ÎµÎºÏÏÏ Î±Î½ Î±Î»Î»Î¬Î¾ÎµÎ¹ ÏÏÎ¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ ÎµÏÎ¹Î»Î¿Î³ÏÎ½ ÎµÎºÏÏÏÏÏÎ®.",
            deleteImportedData:
                "ÎÎ¹Î±Î³ÏÎ¬ÏÎµÎ¹ ÏÎ± ÏÏÎ¿Î·Î³Î¿ÏÎ¼ÎµÎ½Î± ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î± Î´ÎµÎ´Î¿Î¼Î­Î½Î±. Î¤Î± Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± ÎµÎ¹ÏÎ±ÏÎ¸Î¿ÏÎ½ Î¾Î±Î½Î¬ Î¼ÎµÏÎ¬ ÏÎ· Î´Î¹Î±Î³ÏÎ±ÏÎ®.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "Î£ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î¸Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ¿ÏÎ²Î¬ÏÎ¹Î¼Î· Î· ÎµÎ½ÏÏÎ·ÏÎ± ÏÎ·Î¼ÎµÎ¹ÏÏÎµÏÎ½ Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "Î£ÏÎ¿ %{name}, ÏÎ¿ ÎµÎ¹ÎºÎ¿Î½Î¹ÎºÏ ÏÎ»Î·ÎºÏÏÎ¿Î»ÏÎ³Î¹Î¿ Î¸Î± ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î· ÎµÎ½ÏÏÎ·ÏÎ± ÏÎ·Î¼ÎµÎ¹ÏÏÎµÏÎ½ ÏÏÏÎ¼Î¿ÏÎ»Î±Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ¿ÏÎ²Î¬ÏÎ¹Î¼Î·.",
            helpSettings: "ÎÎ¹ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ­Ï ÏÏÎ·Î½ ÎµÎ½ÏÏÎ·ÏÎ± ÎÎ¿Î®Î¸ÎµÎ¹Î± ÏÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î³ÏÎ®Î³Î¿ÏÎ·Ï ÏÏÏÏÎ²Î±ÏÎ·Ï.",
            importCustomData: "ÎÎ¹ÏÎ¬Î³ÎµÎ¹ ÏÎ± ÏÎ¿ÏÎ¹ÎºÎ¬ ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î± Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î¼Îµ Î²Î¬ÏÎ· ÏÎ·Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· Î¼Î¿ÏÏÎ®.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "ÎÎ¹ ÏÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î´Î¹Î±ÏÏÎ±Î»Î¯Î¶Î¿ÏÎ½ ÏÏÎ¹ ÏÎ¿ ÏÎµÏÎ¹Î²Î¬Î»Î»Î¿Î½ ÏÎ¿Ï %{name} Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î±ÏÎµÎ¸ÎµÎ¯ - ÎµÏÎ¹ÏÏÎ­ÏÎµÎ¹ ÏÎ·Î½ Î±ÏÏÎ»ÏÏÎ· ÎµÎ¼ÏÎµÎ¹ÏÎ¯Î± Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î±Ï kiosk. ÎÏÏÏÎµÎ¹ Î¼ÏÎ½Î¿ Î³Î¹Î± Windows.",
            maxNumberTabs: "Î¤Î¿ ÏÏÎ¹Î¿ ÎºÎ±ÏÏÎµÎ»ÏÎ½ ÎºÎ±Î¸Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÏÏÎµÏ ÎºÎ±ÏÏÎ­Î»ÎµÏ ÏÏÏÏÎ½ Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± Î±Î½Î¿Î¯Î¾Î¿ÏÎ½ Î¼Îµ ÏÏÎ¿ÏÎ¿ÏÎ®.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· Î±ÏÎ±Î¹ÏÎµÎ¯ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ Î±Î½ÏÎ¹Î³ÏÎ¬ÏÏÎ½ ÏÎ·Ï ÎµÏÎ¹ÎºÎ­ÏÎ±Ï ÏÎ¿Ï Î¸Î± ÎµÎºÏÏÏÏÎ¸Î¿ÏÎ½ Î¼ÎµÏÎ¬ ÏÎ· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            printAsImage:
                "Î ÎµÎºÏÏÏÏÏÎ· ÏÏ ÎµÎ¹ÎºÏÎ½Î± Î²Î¿Î·Î¸Î¬ ÏÏÎ·Î½ ÎµÏÎ¯Î»ÏÏÎ· ÏÏÎ½ ÏÏÎ¿Î²Î»Î·Î¼Î¬ÏÏÎ½ ÏÏÎ±Î½ Î±ÏÎ¿ÏÏÏÎµÎ¹ Î¿ ÏÏÏÎ¹ÎºÏÏ ÏÏÏÏÎ¿Ï ÎµÎºÏÏÏÏÏÎ·Ï. ÎÎ·Î½ ÏÎ¿ ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎµ ÏÏÎ±Î½ Î· ÏÏÏÎ¹ÎºÎ® ÎµÎºÏÏÏÏÏÎ· Î»ÎµÎ¹ÏÎ¿ÏÏÎ³ÎµÎ¯ ÏÏÏÏÎ¬. Î£ÏÎ¼Î²Î±ÏÏ Î¼ÏÎ½Î¿ Î¼Îµ ÏÎ¿ Linux.",
            printBeforeDispensing:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· Î±ÏÎ±Î¹ÏÎµÎ¯ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÏÎ½ Î±Î½ÏÎ¹Î³ÏÎ¬ÏÏÎ½ ÎµÏÎ¹ÎºÎ­ÏÎ±Ï ÏÎ¿Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎºÏÏÏÏÎ¸Î¿ÏÎ½ ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "Î£ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±, ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ ÎÎºÏÏÏÏÏÎ· Î¸Î± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "Î¤Î¿ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÏÏÏÏÎ¿ Î¸Î± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ· ÎµÏÎ¹ÎºÎµÏÏÎ½ ÏÎ±ÏÎµÎ¯Î±Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "Î¤Î¿ %{light} Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î±Î½ÏÎ¯ ÏÎ¿Ï %{name}.",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ· Î¼Î¿ÏÏÎ® ÏÏÎ½ Î±ÏÏÎ¹ÎºÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ¿Ï Î¸Î± ÎµÎ¹ÏÎ±ÏÎ¸Î¿ÏÎ½. ÎÎ¬Î¸Îµ Î¼Î¿ÏÏÎ® ÎµÎ½Î´Î­ÏÎµÏÎ±Î¹ Î½Î± Î±ÏÎ±Î¹ÏÎµÎ¯ Î´Î¹Î±ÏÎ¿ÏÎµÏÎ¹ÎºÎ¬ Î±ÏÏÎµÎ¯Î± ÎºÎ±Î¹ ÏÏÎ¸Î¼Î¯ÏÎµÎ¹Ï.",
            setCustomHomeButton: "Î¤Î¿ ÎºÎ¿ÏÎ¼ÏÎ¯ ÎÏÏÎ¹ÎºÎ® ÏÎµÎ»Î¯Î´Î± ÏÏÎ¿ %{name} Î¸Î± Î±Î½Î±ÎºÎ±ÏÎµÏÎ¸ÏÎ½ÎµÎ¹ ÏÏÎ¿Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÎ¯Î½Î±ÎºÎ±.",
            setFts: "Î Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÎ»Î®ÏÎ¿ÏÏ ÎºÎµÎ¹Î¼Î­Î½Î¿Ï ÎµÏÎ¹ÏÏÎ­ÏÎµÎ¹ ÏÎ·Î½ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÏÏÎ¿Ï ÏÎ»Î®ÏÎ¿ÏÏ ÎºÎµÎ¹Î¼Î­Î½Î¿Ï (ÎµÏÎ¯ÏÎ·Ï Î±ÏÏ ÏÎ· Î¼Î­ÏÎ· ÏÎ·Ï Î»Î­Î¾Î·Ï, Îº.Î»Ï.).",
            setKeyboardShortcuts:
                "ÎÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´ÏÎ½Î±ÏÏ Î½Î± Î¿ÏÎ¯ÏÎµÏÎµ ÏÎ·Î½ Î¯Î´Î¹Î± ÏÏÎ½ÏÏÎ¼ÎµÏÏÎ· ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï Î³Î¹Î± Î´ÏÎ¿ Î´Î¹Î±ÏÎ¿ÏÎµÏÎ¹ÎºÎ­Ï ÎµÎ½Î­ÏÎ³ÎµÎ¹ÎµÏ.",
            setNumberOfDecimalPlaces:
                "Î ÏÏÏÎ¿Î³Î³ÏÎ»Î¿ÏÎ¿Î¯Î·ÏÎ· Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÏÏÎ± Î´ÎµÎºÎ±Î´Î¹ÎºÎ¬ ÏÎ·ÏÎ¯Î± ÏÏÏÏÏÎ¹ÎºÏÎ½ ÏÎ¿Ï ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î¿ÏÎ½ÏÎ±Î¹ ÏÏÎ· ÏÏÏÎ¼Î¿ÏÎ»Î± Î¸Î± ÎµÎ¼ÏÎ±Î½Î¯Î¶Î¿Î½ÏÎ±Î¹.",
            setOrderSearchParameters:
                "Î Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½ ÎºÎ±Î¸Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÎ¿Î¹ÎµÏ ÏÎ±ÏÎ±Î¼Î­ÏÏÎ¿ÏÏ ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î¿ÏÎ½ÏÎ±Î¹ ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· Î¼ÎµÏÎ±Î¾Ï ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½. ÎÏÎ½Î¿ ÏÏÎ¿ÏÎ²Î¬ÏÎ¹Î¼Î· ÏÏÎ¿ %{name}.",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel:
                "ÎÏÎ¯ÏÏÎµ ÏÎ· Î´Î¹ÎºÎ® ÏÎ±Ï Î¿ÏÎ±ÏÏÏÎ·ÏÎ± ÎºÎ±Î¹ ÏÎ· ÏÎµÎ¹ÏÎ¬ ÏÏÎ½ Î±Î½ÏÎ¹ÎºÎµÎ¹Î¼Î­Î½ÏÎ½ ÏÎ¿Ï ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î¿ÏÎ½ÏÎ±Î¹ ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÎµÎ½ÏÏ Î½Î­Î¿Ï ÏÏÏÎ¿Ï.",
            setVisibilityAndOrder:
                "Î¤Î± ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î± ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ¬ ÏÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î³ÏÎ®Î³Î¿ÏÎ·Ï ÏÏÏÏÎ²Î±ÏÎ·Ï. Î ÏÏÎ·Î»ÏÏÎµÏÎ· Î¸Î­ÏÎ· ÎµÎ´Ï Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÎ·Î½ Î±ÏÎ¹ÏÏÎµÏÎ® Î¸Î­ÏÎ· ÏÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ±. Î¤Î¿ Î¼Î­Î³Î¹ÏÏÎ¿ ÎµÏÎ¹ÏÏÎµÏÏÎ¼ÎµÎ½Î¿ ÏÎ¿ÏÏ ÏÏÎ½ ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï ÎµÎ¯Î½Î±Î¹ 6.",
            setYourLanguage: "Î Î±Î»Î»Î±Î³Î® Î³Î»ÏÏÏÎ±Ï Î±ÏÎ±Î¹ÏÎµÎ¯ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï.",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "Î ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï ÎµÎ¯Î½Î±Î¹ Î­Î½Î± Î±Î½Î±Î´ÏÏÎ¼ÎµÎ½Î¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ ÏÎ¿Ï Î±Î½Î±Î³Î³Î­Î»Î»ÎµÎ¹ ÏÏÎ¹ Î­ÏÎµÎ¹ ÏÎ±ÏÎ±Î»Î·ÏÎ¸ÎµÎ¯ Î½Î­Î± ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±.",
            sorting:
                "Î ÏÎ±ÏÎµÎ¯Î± Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ· Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î­ÏÎµÎ¹ ÏÎ± ÎºÎ¬Î½Î¹ÏÏÏÎ± ÏÎ¿Ï Î­ÏÎ¿ÏÎ½ ÏÎ±Î¾Î¹Î½Î¿Î¼Î·Î¸ÎµÎ¯ ÏÏÎ¼ÏÏÎ½Î± Î¼Îµ ÏÎ± Î¿Î½ÏÎ¼Î±ÏÎ± ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ Î® Î¼Îµ ÏÎ± Î±Î½Î±Î³Î½ÏÏÎ¹ÏÏÎ¹ÎºÎ¬ ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½.",
            turnOnKioskMode: "ÎÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÏÎµÏÎ¹ÏÏÎ­ÏÎ¿Ï Î³Î¹Î± ÏÎ·Î½ Î±ÏÏÎºÏÏÏÎ· ÏÎ·Ï Î³ÏÎ±Î¼Î¼Î®Ï ÎµÏÎ³Î±ÏÎ¹ÏÎ½.",
            windowClosingRules:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· ÎºÎ±Î¸Î¿ÏÎ¯Î¶ÎµÎ¹ ÎµÎ¬Î½ ÏÎ¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î³ÏÎ®Î³Î¿ÏÎ·Ï Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·Ï ÎºÎ»ÎµÎ¯Î½ÎµÎ¹ ÏÏÎ¹Î½ Î® Î¼ÎµÏÎ¬ ÏÎ·Î½ Î­Î½Î±ÏÎ¾Î· ÏÎ·Ï Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î±Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï."
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "ÎÎ± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ Î· Î´Î·Î¼Î¹Î¿ÏÏÎ³Î¯Î± ÎºÎ±Î¹ Î· Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½ÏÎ½ ÏÏÎ½ÏÎ±Î³ÏÎ½.",
            allowCustomPackageSize:
                "Î£ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î¸Î± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ Î· ÎµÏÎ¹Î»Î¿Î³Î® ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿Ï Î¼ÎµÎ³Î­Î¸Î¿ÏÏ ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï.",
            allowEditingColorants:
                "Î£ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±, ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÏÏÏÎ¹ÎºÎ¿Ï Î¸Î± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ (ÎµÎ¼ÏÎ±Î½Î¯Î¶ÎµÏÎ±Î¹ Î¼ÎµÏÎ¬ ÏÎ·Î½ ÎµÏÎ¹Î»Î¿Î³Î® ÎµÎ½ÏÏ ÏÏÏÎ¼Î±ÏÎ¿Ï).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î· ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ Î· Î¼ÏÎ½Î· Î¿ÏÎ±ÏÎ® ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯Î±.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Î ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· Î±ÏÏÎ®Ï ÏÎ·Ï ÏÏÎ¸Î¼Î¹ÏÎ·Ï Î¸Î± Î­ÏÎµÎ¹ ÏÏ Î±ÏÎ¿ÏÎ­Î»ÎµÏÎ¼Î± ÏÎ± Î±Î½Î±Î´ÏÏÎ¼ÎµÎ½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ± Î½Î± ÎµÏÎ¹Î²ÎµÎ²Î±Î¹ÏÎ½Î¿ÏÎ½ ÏÎ· Î´Î¹Î±Î³ÏÎ±ÏÎ® ÎµÎ½ÏÏ ÏÏÎ¿Î¹ÏÎµÎ¯Î¿Ï.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "ÎÏÎ±Î½ Î¾ÎµÎºÎ¹Î½Î¬ÏÎµ ÏÎ¿ %{name}, Î¸Î± ÎµÎ¼ÏÎ±Î½Î¹ÏÏÎµÎ¯ ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ ÎÎ³Î±ÏÎ·Î¼Î­Î½Î±.",
            formulaAutomaticNaming:
                "ÎÎ¹Î± Î±Î»Î»Î±Î³Î¼Î­Î½Î· ÏÏÏÎ¼Î¿ÏÎ»Î± Î¸Î± Î¿Î½Î¿Î¼Î¬Î¶ÎµÏÎ±Î¹ Î±ÏÏÏÎ¼Î±ÏÎ± Î¼Îµ Î²Î¬ÏÎ· ÏÎ¹Ï ÏÏÎ±Î³Î¼Î±ÏÎ¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯ÏÎµÏ ÏÏÎ¿ÏÎ¿ÏÎ¿Î¹Î®ÏÎµÎ¹Ï ÏÏÏÏÏÎ¹ÎºÏÎ½.",
            formulaPanel: "ÎÏÎ±Î½ Î±Î½Î¿Î¯Î³ÎµÏÎµ Î¼Î¹Î± Î½Î­Î± ÎºÎ±ÏÏÎ­Î»Î±, ÎµÎ¼ÏÎ±Î½Î¯Î¶ÎµÏÎ±Î¹ ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±.",
            formulaPanelInitial: "ÎÏÎ±Î½ Î¾ÎµÎºÎ¹Î½Î¬ÏÎµ ÏÎ¿ %{name}, ÎµÎ¼ÏÎ±Î½Î¯Î¶ÎµÏÎ±Î¹ Î¿ ÏÎ¯Î½Î±ÎºÎ±Ï Î¦ÏÏÎ¼Î¿ÏÎ»Î±.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î· ÎµÎ¹ÎºÏÎ½Î± ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ® Î´Î¯ÏÎ»Î± ÏÏÎ·Î½ ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î¬ÏÏÎ½ Î¼Îµ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î½Î± Î±Î½Î¿Î¯Î¾ÎµÎ¹ Î¿ ÏÎ¯Î½Î±ÎºÎ±Ï Î¼Îµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo:
                "Î£ÏÎ¿ ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î¿ ÏÎ¯Î½Î±ÎºÎ±Ï ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¹ÏÎ½ Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÏÏ Î´Î¯ÏÎ»Î± ÏÏÎ·Î½ ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î¬ÏÏÎ½ ÎºÎ±Î¹ ÏÎ·Î½ ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÎµÎ¹ÎºÏÎ½Î±Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "ÎÏÎ±Î½ Î±Î½Î¿Î¯Î³ÎµÏÎµ Î¼Î¹Î± Î½Î­Î± ÎºÎ±ÏÏÎ­Î»Î±, Î¸Î± ÎµÎ¼ÏÎ±Î½Î¹ÏÏÎµÎ¯ Î· Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· Î½Î­Î±Ï ÏÏÎ½ÏÎ±Î³Î®Ï (ÏÎµÏÎ¹Î­ÏÎµÎ¹ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ¹Ï ÏÎµÎ»ÎµÏÏÎ±Î¯ÎµÏ Î´Î¹Î±Î½ÎµÎ¼Î·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï ÎºÎ±Î¹ ÏÎ¹Ï Î±Î³Î±ÏÎ·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï).",
            searchNewFormulaInitial:
                "ÎÏÎ±Î½ Î¾ÎµÎºÎ¹Î½Î¬ÏÎµ ÏÎ¿ %{name}, Î¸Î± ÎµÎ¼ÏÎ±Î½Î¹ÏÏÎµÎ¯ Î· Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· Î½Î­Î±Ï ÏÏÎ½ÏÎ±Î³Î®Ï (ÏÎµÏÎ¹Î­ÏÎµÎ¹ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÏÏÎµÏÎ¹ÎºÎ¬ Î¼Îµ ÏÎ¹Ï ÏÎµÎ»ÎµÏÏÎ±Î¯ÎµÏ Î´Î¹Î±Î½ÎµÎ¼Î·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï ÎºÎ±Î¹ ÏÎ¹Ï Î±Î³Î±ÏÎ·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "Î£ÏÎ·Î½ Î¿Î¸ÏÎ½Î· Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î¿ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿Ï ÏÏÏÎ¿Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î¸Î± ÎµÎ¯Î½Î±Î¹ ÏÎ¬Î½ÏÎ± Î¿ÏÎ±ÏÏÏ ÏÎµ ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î¬ÏÏÎ½.",
            setFormulaUnit:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î±ÏÏÎ® Î· ÏÏÎ¸Î¼Î¹ÏÎ· Î±ÏÎ¿ÏÎ±ÏÎ¯Î¶ÎµÎ¹ ÏÎ¿Î¹Î± Î¼Î¿Î½Î¬Î´Î± ÏÏÏÏÏÎ¹ÎºÎ®Ï Î±Î½Î¿Î¯Î³ÎµÎ¹ ÏÏ ÏÏÏÏÎ· Î¼ÎµÏÎ¬ ÏÎ·Î½ ÎµÏÎ¹Î»Î¿Î³Î® ÎµÎ½ÏÏ ÏÏÏÎ¼Î±ÏÎ¿Ï. ÎÏÎ¯ÏÎ·Ï ÎµÏÎ±ÏÎ¼ÏÎ¶ÎµÏÎ±Î¹ ÏÎµ Î¤Î±ÏÎµÎ¯Î± ÎÎ¹Î±Î½Î¿Î¼Î®.",
            setFormulaVisibilityAndOrder:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, ÏÎ± ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î± Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ¬ ÏÏÎ·Î½ ÎµÎ½ÏÏÎ·ÏÎ± Î ÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ (Î¹ÏÏÏÎµÎ¹ Î¼ÏÎ½Î¿ ÎµÎ¬Î½ Î¿ÏÎ¯ÏÎµÏÎµ ÏÎ·Î½ ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î¿ÏÎ»Î±Ï ÏÏÎ· ÏÏÎ¸Î¼Î¹ÏÎ· Î¦ÏÏÎ¼Î¿ÏÎ»Î± ÎµÎ¯Î½Î±Î¹ ÎÎ¹ÎºÏÎ½Î± Î® ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ.",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î±ÏÏÎ® Î· ÏÏÎ¸Î¼Î¹ÏÎ· Î±ÏÎ¿ÏÎ±ÏÎ¯Î¶ÎµÎ¹ ÏÎ¿Î¹ÎµÏ ÏÏÏÏÏÎ¹ÎºÎ­Ï ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ­Ï Î¼ÎµÏÎ¬ ÏÎ·Î½ ÎµÏÎ¹Î»Î¿Î³Î® ÎµÎ½ÏÏ ÏÏÏÎ¼Î±ÏÎ¿Ï. ÎÏÎ¯ÏÎ·Ï ÎµÏÎ±ÏÎ¼ÏÎ¶ÎµÏÎ±Î¹ ÏÎµ Î¤Î±ÏÎµÎ¯Î± ÎÎ¹Î±Î½Î¿Î¼Î®.",
            showColorPreview:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, ÎµÎ¼ÏÎ±Î½Î¯Î¶ÎµÏÎ±Î¹ Î¼Î¹ÎºÏÎ® ÏÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï Î´Î¯ÏÎ»Î± ÏÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÏÏÎ¼Î±ÏÎ¿Ï ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· Î¼Î¹Î¬Ï Î½Î­Î±Ï ÏÏÎ½ÏÎ±Î³Î®Ï.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "ÎÎ¿Î®Î¸ÎµÎ¹Î±",
        helpLink: "ÎÎ­Î½ÏÏÎ¿ Î²Î¿Î·Î¸ÎµÎ¯Î±Ï",
        helper: {
            automaticallyCheckForUpdates:
                "ÎÎ± ÎµÎ»ÎµÎ³ÏÎ¸ÎµÎ¯ Î±ÏÏÏÎ¼Î±ÏÎ± ÎµÎ¬Î½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· ÎµÎ½Î·Î¼Î­ÏÏÏÎ· Î³Î¹Î± ÏÎ¿ %{name} Î® ÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ¿ Î´ÎµÎ´Î¿Î¼Î­Î½Î¿ ÏÏÎ¿Î½Î¹ÎºÏ Î´Î¹Î¬ÏÏÎ·Î¼Î±.",
            automaticallyDownloadUpdates:
                "ÎÎ¬Î½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· ÎµÎ½Î·Î¼Î­ÏÏÏÎ·, Î¸Î± Î»Î·ÏÎ¸ÎµÎ¯ Î±ÏÏÏÎ¼Î±ÏÎ± ÏÏÏÎ¯Ï Î½Î± Î±ÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÎµÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ·.",
            automaticallyInstallNewDatabases:
                "ÎÎ¬Î½ Î±ÏÎ¿ÏÏÎ­Î»Î»ÎµÏÎ±Î¹ Î¼Î­ÏÏÎ¹ ÏÏÏÎ± DB, Î¸Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÏÏ Î½Î­Î¿ DB. Î£ÏÎ· ÏÏÎ½Î­ÏÎµÎ¹Î±, ÏÎ¿ DB Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î·Î¸ÎµÎ¯.",
            automaticallyInstallUpdates:
                "ÎÎ¬Î½ Î­ÏÎµÎ¹ Î»Î·ÏÎ¸ÎµÎ¯ Î¼Î¹Î± ÎµÎ½Î·Î¼Î­ÏÏÏÎ·, Î¸Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ Î±ÏÏÏÎ¼Î±ÏÎ± ÏÏÏÎ¯Ï Î½Î± ÏÏÎµÎ¹Î¬Î¶ÎµÏÎ±Î¹ ÎµÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ·.",
            canBrowseChangeLog:
                "ÎÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎ½Î·Î¼Î­ÏÏÏÎ· ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï, ÏÎ¿ ÎµÏÎ¯ÏÎ·Î¼Î¿ %{name} changelog Î¸Î± ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿ Î³Î¹Î± ÏÏÎ¿Î²Î¿Î»Î®",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "Î ÎµÎ½Î·Î¼Î­ÏÏÏÎ· Î¸Î± ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÎºÎ±ÏÎ¬ ÏÎ· Î´Î¹Î¬ÏÎºÎµÎ¹Î± ÏÎ·Ï Î½ÏÏÏÎ±Ï ÎµÎ¬Î½ Î¿ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®Ï Î»ÎµÎ¹ÏÎ¿ÏÏÎ³ÎµÎ¯."
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "ÎÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´ÏÎ½Î±ÏÎ® Î· ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ±Î»Î¼Î¬ÏÏÎ½ ÎºÎ±Î¸ÏÏ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÏÎ¿Î»Î·Î¼Î­Î½Î¿.",
        machineSettings: {
            allowManualColorantAddition:
                "ÎÎ¬Î½ Î· Î±ÏÎ±Î¹ÏÎ¿ÏÎ¼ÎµÎ½Î· ÏÎ¿ÏÏÏÎ·ÏÎ± ÏÏÏÏÏÎ¹ÎºÎ®Ï ÏÏÎµÏÎ²Î±Î¯Î½ÎµÎ¹ ÏÎ· Î¼Î­Î³Î¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î®Ï, Î· ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÏÎ¹ÏÏÎ­ÏÎµÎ¹ ÏÎ·Î½ ÏÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ± Î¼ÎµÏÎ¬ ÏÎ· Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·.",
            autotasks:
                "ÎÎ¹ Î±ÏÏÏÎ¼Î±ÏÎµÏ Î´Î¹ÎµÏÎ³Î±ÏÎ¯ÎµÏ ÎµÎ¯Î½Î±Î¹ Î±ÏÏÏÎ¼Î±ÏÎµÏ ÎºÎ±Î¹ ÏÎ± ÏÏÎ¼Î²Î¬Î½ÏÎ± ÏÏÎ½ÏÎ®ÏÎ·ÏÎ·Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® ÏÎ± Î¿ÏÎ¿Î¯Î± Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± ÏÏÎ¸Î¼Î¹ÏÏÎ¿ÏÎ½ ÏÏÏÎµ Î½Î± ÎµÎºÏÎµÎ»Î¿ÏÎ½ÏÎ±Î¹ ÏÎµ ÏÏÎ³ÎºÎµÎºÏÎ¹Î¼Î­Î½Î¿ ÏÏÏÎ½Î¿ Î® ÏÏÎ¿Î½Î¹ÎºÏ Î´Î¹Î¬ÏÏÎ·Î¼Î±.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense: "The setting is only valid for Fast & Fluid simulation.",
            checkOverfill:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÎ»Î­Î³ÏÎµÎ¹ ÎµÎ¬Î½ ÏÏÎ¬ÏÏÎµÎ¹ Î±ÏÎºÎµÏÏÏ ÏÏÏÎ¿Ï ÏÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î³Î¹Î± ÏÎ¹Ï ÏÏÏÏÏÎ¹ÎºÎ­Ï ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®.",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÏÎ¹ÏÏÎ­ÏÎµÎ¹ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® ÏÏÏÏÏÎ¹ÎºÏÎ½ ÏÎ¿Ï Î´ÎµÎ½ ÎºÎ±Î¸Î¿ÏÎ¯Î¶Î¿Î½ÏÎ±Î¹ ÏÏÎ· Î´Î¹Î±Î¼ÏÏÏÏÏÎ· ÏÎ¿Ï Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ¿Ï ÏÏÎ¿ÏÏÎ­ÏÎ¿Î½ÏÎ±Ï ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· ÏÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÏÏÏÎ¹ÎºÏÎ½.",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "Î ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÏÎ¹ÏÏÎ­ÏÎµÎ¹ ÏÎ·Î½ Î±ÏÎ¿ÏÏÎ¿Î»Î® Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ¿ TMC.",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "Î Î¼Î·ÏÎ±Î½Î® Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÎ· Î¼Î¿Î½Î¬Î´Î± Î¼Î­ÏÏÎ·ÏÎ·Ï ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÏÏÎ± ÎºÎ¬Î½Î¹ÏÏÏÎ±.",
            minDispensedAmount:
                "Î ÎµÎ»Î¬ÏÎ¹ÏÏÎ· Î´Î¹Î±ÏÎ¹Î¸Î­Î¼ÎµÎ½Î· ÏÎ¿ÏÏÏÎ·ÏÎ± ÎºÎ±Î¸Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÏÏÎ± ÏÏÏÏÏÎ¹ÎºÎ¬ ÏÏÎ­ÏÎµÎ¹ Î½Î± Î­ÏÎ¿ÏÎ½ Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯ Î³Î¹Î± Î½Î± Î»Î·ÏÎ¸ÎµÎ¯ ÏÏÏÏÎ· Î¿ ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÏÎ¿Ï Î­Î³Î¹Î½Îµ (Î³Î¹Î± Î½Î± Î±ÏÎ¿ÏÎµÏÏÎ¸ÎµÎ¯ ÎµÏÎ¹ÏÎ»Î­Î¿Î½ ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ).",
            minimalDispenseAmount:
                "Î ÎµÎ»Î¬ÏÎ¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î®Ï ÎµÎ¯Î½Î±Î¹ Î· Î¼Î¹ÎºÏÏÏÎµÏÎ· ÏÏÎ½Î¹ÏÏÏÎ¼ÎµÎ½Î· ÏÎ¿ÏÏÏÎ·ÏÎ± ÏÏÏÏÏÎ¹ÎºÎ®Ï ÏÎ¿Ï Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯. ÎÎ¬Î½ ÏÎ±ÏÎ±Î²Î¹Î±ÏÏÎµÎ¯, Î¸Î± ÎµÎ¼ÏÎ±Î½Î¹ÏÏÎµÎ¯ Î­Î½Î± Î¼Î®Î½ÏÎ¼Î± (Î· Î´Î¹Î±Î½Î¿Î¼Î® ÎµÎ¯Î½Î±Î¹ Î±ÎºÏÎ¼Î± Î´ÏÎ½Î±ÏÎ®).",
            missingAutotaskCanisters: "Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÏÎ¹Î»Î­Î¾ÎµÏÎµ ÏÎ¿ÏÎ»Î¬ÏÎ¹ÏÏÎ¿Î½ 1 Î´Î¿ÏÎµÎ¯Î¿",
            missingAutotaskChannels: "Î ÏÎ­ÏÎµÎ¹ Î½Î± ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÎ¿ÏÎ»Î¬ÏÎ¹ÏÏÎ¿Î½ 1 ÎºÎ±Î½Î¬Î»Î¹",
            missingAutotaskChannelsValue: "Î ÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸ÎµÎ¯ Î¿ ÏÎ³ÎºÎ¿Ï ÏÎ»ÏÎ½ ÏÏÎ½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½ÏÎ½ ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
            missingAutotaskCleanTime: "Î ÏÏÏÎ½Î¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸ÎµÎ¯",
            missingAutotaskName: "Î¤Î¿ ÏÎ½Î¿Î¼Î± ÏÎ·Ï Î±ÏÏÏÎ¼Î±ÏÎ·Ï ÎµÏÎ³Î±ÏÎ¯Î±Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸ÎµÎ¯",
            missingAutotaskRecirculation: "Î ÏÏÏÎ½Î¿Ï ÎºÎ±Î¹ Î· ÏÎ±ÏÏÏÎ·ÏÎ± ÏÎ·Ï Î±Î½Î±ÎºÏÎºÎ»Î¿ÏÎ¿ÏÎ¯Î±Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸Î¿ÏÎ½",
            missingAutotaskStirring: "Î ÏÏÏÎ½Î¿Ï ÎºÎ±Î¹ Î· ÏÎ±ÏÏÏÎ·ÏÎ± Î±Î½Î¬Î´ÎµÏÏÎ·Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸Î¿ÏÎ½",
            missingAutotaskVolume: "Î ÏÎ³ÎºÎ¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸ÎµÎ¯",
            placeCanSensor:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹ÎµÎ¯ ÏÎ¿Î½ Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î³Î¹Î± ÏÎ·Î½ ÏÎ¿ÏÎ¿Î¸Î­ÏÎ·ÏÎ· ÏÎ¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï - Î· Î´Î¹Î±Î½Î¿Î¼Î® Î´ÎµÎ½ Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ ÏÎ±ÏÎ¬ Î¼ÏÎ½Î¿ Î±Î½ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î­ÏÎµÎ¹ ÏÎ¿ÏÎ¿Î¸ÎµÏÎ·Î¸ÎµÎ¯ ÏÏÏÏÎ¬.",
            placeCanSensorDelay:
                "Î ÏÏÎ¿ÏÎµÎ¹Î½ÏÎ¼ÎµÎ½Î· ÏÏÎ¸Î¼Î¹ÏÎ· ÏÏÎ½Î´Î­ÎµÏÎ±Î¹ Î¼Îµ ÏÎ¿Î½ Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î´Î¿ÏÎµÎ¯Î¿Ï. ÎÎ¾Î±ÏÏÎ±Î»Î¯Î¶ÎµÎ¹ ÏÏÎ¹ Î· Î´Î¹Î±Î½Î¿Î¼Î® Î±ÏÏÎ¯Î¶ÎµÎ¹ Î¼ÏÎ½Î¿ Î¼ÎµÏÎ¬ ÏÎ·Î½ ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î· ÏÏÎ¿Î½Î¹ÎºÎ® ÏÎµÏÎ¯Î¿Î´Î¿ ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î¿ÏÎ¿Î¯Î± ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î­ÏÎµÎ¹ ÏÎ¿ÏÎ¿Î¸ÎµÏÎ·Î¸ÎµÎ¯ ÏÏÏÏÎ¬.",
            purgeVolume: "Î Î­Î½Î´ÎµÎ¹Î¾Î· ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÏÏÎ¸Î¼Î¯Î¶ÎµÎ¹ ÏÏÏÎ¿ ÏÏÏÏÏÎ¹ÎºÏ ÎºÎ±Î¸Î±ÏÎ¯Î¶ÎµÏÎµ ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÎºÏÎ­Î»ÎµÏÎ· Î­Î¾ÏÏÎ½Î·Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Î ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹ÎµÎ¯ ÏÎ¿Î½ Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î³Î¹Î± ÏÎ·Î½ Î±ÏÎ±Î¯ÏÎµÏÎ· ÏÎ¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï - Î· Î´Î¹Î±Î½Î¿Î¼Î® Î´ÎµÎ½ Î¸ÎµÏÏÎµÎ¯ÏÎ±Î¹ ÏÏÎ¹ Î­ÏÎµÎ¹ Î³Î¯Î½ÎµÎ¹ ÎµÎºÏÏÏ ÎµÎ¬Î½ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î­ÏÎµÎ¹ Î±ÏÎ±Î¹ÏÎµÎ¸ÎµÎ¯.",
            removeCanSensorDelay:
                "Î£ÏÎ½Î¹ÏÏÏÎ¼ÎµÎ½Î· ÏÏÎ¸Î¼Î¹ÏÎ· ÏÎ¿Ï ÏÏÎ½Î´Î­ÎµÏÎ±Î¹ Î¼Îµ ÏÎ·Î½ Î±ÏÎ±Î¯ÏÎµÏÎ· ÏÎ¿Ï Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î´Î¿ÏÎµÎ¯Î¿Ï. ÎÎ¾Î±ÏÏÎ±Î»Î¯Î¶ÎµÎ¹ ÏÏÎ¹ Î· Î´Î¹Î±Î½Î¿Î¼Î® Î­ÏÎµÎ¹ Î¿Î»Î¿ÎºÎ»Î·ÏÏÎ¸ÎµÎ¯ Î¼ÏÎ½Î¿ Î¼ÎµÏÎ¬ ÏÎ·Î½ ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Î­Î½Î· ÏÏÎ¿Î½Î¹ÎºÎ® ÏÎµÏÎ¯Î¿Î´Î¿ ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î¿ÏÎ¿Î¯Î± ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î­ÏÎµÎ¹ Î±ÏÎ±Î¹ÏÎµÎ¸ÎµÎ¯.",
            skipPlaceCanDialog:
                "ÎÎµ ÏÎ·Î½ ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· Î±ÏÏÎ®, Î¿ Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï Î´ÎµÎ½ Î¸Î± ÏÎµÏÎ¹Î¼Î­Î½ÎµÎ¹ ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÏÎ¿ÏÎ¿Î¸Î­ÏÎ·ÏÎ· ÎµÎ½ÏÏ Î´Î¿ÏÎµÎ¯Î¿Ï Î¼Î­ÏÏÎ¹ Î½Î± ÏÎ±ÏÎ·Î¸ÎµÎ¯ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ OK, Î±Î»Î»Î¬ Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î±ÏÏÏÎ¼Î±ÏÎ± ÏÎ· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            skipRemoveCanDialog:
                "ÎÎµ ÏÎ·Î½ ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· Î±ÏÏÎ®, Î¿ Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï Î´ÎµÎ½ Î¸Î± ÏÎµÏÎ¹Î¼Î­Î½ÎµÎ¹ ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î±ÏÎ±Î¯ÏÎµÏÎ· ÎµÎ½ÏÏ Î´Î¿ÏÎµÎ¯Î¿Ï Î­ÏÏ ÏÏÎ¿Ï ÏÎ±ÏÎ·Î¸ÎµÎ¯ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ OK, Î±Î»Î»Î¬ Î¸Î± ÎµÎ¾ÎµÏÎ¬ÏÎµÎ¹ Î±ÏÏÏÎ¼Î±ÏÎ± ÏÎ· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            smartPurgeType:
                "Î ÏÏÏÎ¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÎµÎ¾ÎµÏÎ¬ÏÎµÎ¹ ÎµÎ¯ÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® Î¼ÏÎ½Î¿ ÎµÎ¯ÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® Î¼Î±Î¶Î¯ Î¼Îµ Î¬Î»Î»Î± Î³ÎµÎ³Î¿Î½ÏÏÎ± ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÎºÎ±ÏÎ¬ ÏÎ·Î½ ÎµÏÎ¹ÎºÏÏÏÏÎ·, ÎµÎ¬Î½ Î±ÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ Î­Î¾ÏÏÎ½Î¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ.",
            splitFormula:
                "ÎÎ¬Î½ Î· Î±ÏÎ±Î¹ÏÎ¿ÏÎ¼ÎµÎ½Î· ÏÎ¿ÏÏÏÎ·ÏÎ± ÏÏÏÏÏÎ¹ÎºÎ®Ï ÏÏÎµÏÎ²Î±Î¯Î½ÎµÎ¹ ÏÎ· Î¼Î­Î³Î¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î®Ï, Î· ÏÏÎ¸Î¼Î¹ÏÎ· ÎµÏÎ¹ÏÏÎ­ÏÎµÎ¹ Î½Î± Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯ Î­Î½Î± ÎºÎ¿Î¼Î¼Î¬ÏÎ¹ ÏÏÏÏÏÎ¹ÎºÎ®Ï, Î½Î± Î¾Î±Î½Î±Î³ÎµÎ¼Î¹ÏÏÎµÎ¯ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ ÎºÎ±Î¹ ÏÏÎ· ÏÏÎ½Î­ÏÎµÎ¹Î± Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÎ¹ Î½Î± Î´Î¹Î±Î½Î­Î¼ÎµÏÎ±Î¹ ÏÎ¿ ÏÏÏÎ»Î¿Î¹ÏÎ¿.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Î¤Î¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÏÎ¹ÎºÏÏÏÎ¸ÎµÎ¯ Î¼Î­ÏÏ barcode ÏÏÎ¹Î½ ÎµÏÎ¹ÏÏÎ±ÏÎµÎ¯ Î· Î´Î¹Î±Î½Î¿Î¼Î®. Î ÏÏÎ¸Î¼Î¹ÏÎ· Î´Î¹Î±ÏÏÎ±Î»Î¯Î¶ÎµÎ¹ ÏÎ· ÏÏÎ®ÏÎ· ÏÎ·Ï ÏÏÏÏÎ®Ï Î²Î¬ÏÎ·Ï.",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· barcode Î´Î¿ÏÎµÎ¯Î¿Ï ÎºÎ±Î¹ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î¿ÏÎ¹ÏÎ¼Î¿Ï barcode.",
            canisterLevel:
                "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÎµÏÎ¹ÏÎ­Î´ÏÎ½ Î´Î¿ÏÎµÎ¯Î¿Ï ÎºÎ±Î¹ Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± ÏÏÎ¸Î¼Î¹ÏÎ·Ï ÏÏÎ¬Î¸Î¼Î·Ï Î´Î¿ÏÎµÎ¯Î¿Ï.",
            canisters: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¼Îµ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÎµÏÎ¹ÏÎ­Î´ÏÎ½ Î´Î¿ÏÎµÎ¯Î¿Ï ÎºÎ±Î¹ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± ÏÏÎ¸Î¼Î¹ÏÎ·Ï ÏÏÎ¬Î¸Î¼Î·Ï Î´Î¿ÏÎµÎ¯Î¿Ï.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ¬Î½ÎµÎ» Î¼Îµ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·Ï Î½Î­Î±Ï ÏÏÏÎ¼Î¿ÏÎ»Î±Ï ÏÎµ Î·Î»ÎµÎºÏÏÎ¿Î½Î¹ÎºÏ fandeck.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ ÏÎ·Î½ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÎ½ Î¾Î±Î½Î±Î³ÎµÎ¼Î¹ÏÎ¼Î­Î½ÏÎ½ Î¼ÎµÏÎ±Î»Î»Î¹ÎºÏÎ½ ÎºÎ¿ÏÏÎ¹ÏÎ½.",
            customFormula: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î±Î½ ÏÎ¯Î½Î±ÎºÎ± Î¼Îµ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î´Î·Î¼Î¹Î¿ÏÏÎ³Î¯Î±Ï ÎµÎ½ÏÏ Î½Î­Î¿Ï ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿Ï ÏÏÏÎ¿Ï.",
            customers:
                "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¼Îµ ÏÎ·Î½ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÎ½ ÏÎµÎ»Î±ÏÏÎ½ ÎºÎ±Î¹ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± ÏÏÎ¿ÏÎ¸Î®ÎºÎ·Ï / ÎµÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î±Ï / Î´Î¹Î±Î³ÏÎ±ÏÎ®Ï ÏÎ¿ÏÏ.",
            dispensingHistory: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ¬Î½ÎµÎ» Î¼Îµ ÏÎ·Î½ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÎ½ ÎµÎºÏÎµÎ»Î¿ÏÎ¼ÎµÎ½ÏÎ½ Î´Î¹Î±Î½Î¿Î¼ÏÎ½.",
            favorites: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ¬Î½ÎµÎ» Î¼Îµ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î½Î± ÎµÏÎ¹Î»Î­Î¾ÎµÏÎµ Î­Î½Î±Î½ Î±Î³Î±ÏÎ·Î¼Î­Î½Î¿ ÏÏÏÎ¿.",
            help: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ ÎµÎ¾ÏÏÎ·ÏÎ­ÏÎ·ÏÎ·Ï ÏÎµÎ»Î±ÏÏÎ½, ÎµÎ¬Î½ ÏÎ±ÏÎ­ÏÎ¿Î½ÏÎ±Î¹ Î±ÏÏ ÏÎ¿Î½ ÏÏÎ¿Î¼Î·Î¸ÎµÏÏÎ®.",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders:
                "ÎÏÏÏÎµÎ¹ Î±ÏÎ¿ÎºÎ»ÎµÎ¹ÏÏÎ¹ÎºÎ¬ Î³Î¹Î± ÏÎ¿ %{name}, Î±Î½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¼Îµ ÏÎ·Î½ ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÏÎ½ ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½.",
            machineReset: "ÎÎµÎºÎ¹Î½Î¬ ÏÎ·Î½ ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î±.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯ÎµÏ ÏÎ¿Ï Î±ÏÎ¿ÏÏÎ­Î»Î»Î¿Î½ÏÎ±Î¹ Î±ÏÏ Î±ÏÏÏÎ½ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
            purge: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± ÏÏÎ¸Î¼Î¹ÏÎ·Ï ÏÎ·Ï ÎºÎ¬Î¸Î±ÏÏÎ·Ï.",
            quickTint: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± ÎµÎºÏÎ­Î»ÎµÏÎ·Ï Î¼Î· Î±ÏÏÏÎ¼Î±ÏÎ·Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï.",
            searchFormula: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ»Î±Î¯ÏÎ¹Î¿ Î¼Îµ ÏÎ· Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·Ï ÎµÎ½ÏÏ Î½Î­Î¿Ï ÏÏÏÎ¿Ï.",
            spectro: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ¬Î½ÎµÎ» Î¼Îµ Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± Î¼Î­ÏÏÎ·ÏÎ·Ï Î¼Îµ Î­Î½Î± spectro.",
            stir: "ÎÎ½Î¿Î¯Î³ÎµÎ¹ Î­Î½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ Î¼Îµ Î´ÏÎ½Î±ÏÏÏÎ·ÏÎ± ÏÏÎ¸Î¼Î¹ÏÎ·Ï ÏÎ·Ï Î±Î½Î¬Î´ÎµÏÏÎ·Ï ÏÎ¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯ÎµÏ ÏÎ¿Ï ÎµÎ»Î®ÏÎ¸Î·ÏÎ±Î½ Î±ÏÏ Î±ÏÏÏÎ½ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®"
        },
        noHelpForLicense:
            "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î²Î¿Î®Î¸ÎµÎ¹Î± Î³Î¹Î± ÏÎ· Î´Î¹Î±Î¸ÎµÏÎ¹Î¼ÏÏÎ·ÏÎ± ÏÎ·Ï Î¬Î´ÎµÎ¹Î±Ï ÏÏÎ®ÏÎ·Ï, Î¶Î·ÏÎ®ÏÏÎµ Î±ÏÏ ÏÎ¿Î½ ÏÏÎ¿Î¼Î·Î¸ÎµÏÏÎ® ÏÎ±Ï Î½Î± ÏÎ·Î½ ÏÏÎ¿ÏÎ¸Î­ÏÎµÎ¹.",
        posInfo: {
            sync: "Î£ÏÎ³ÏÏÎ¿Î½Î¯Î¶ÎµÎ¹ Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î¼Îµ ÏÎ·Î½ ÎµÎ½ÏÏÎ·ÏÎ± ÎÎ³Î³ÏÎ±ÏÎ®"
        },
        poweredByDeso: "Powered by %{name}",
        priceSettings: {
            VatPrice: "Î§ÏÏÏÏÎ¹ÎºÎ® Î¦Î Î Î±Î¾Î¯Î± ÏÎµ%.",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "Î¤Î¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î³Î¹Î± ÏÎ· Î²Î¬ÏÎ· (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï Î±ÏÎ¿ÎºÎ»ÎµÎ¹ÏÏÎ¹ÎºÎ¬).",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î¼ÏÎ½Î¿ Î³Î¹Î± ÏÎ· Î²Î¬ÏÎ· (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï ÎºÎ±Î¹ ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "Î¤Î¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½ÏÎ½ Î±ÏÎ¿ÎºÎ»ÎµÎ¹ÏÏÎ¹ÎºÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½).",
            cntPurchaseByName:
                "Î¤Î¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¯Î¶ÎµÏÎ±Î¹ Î¾ÎµÏÏÏÎ¹ÏÏÎ¬ Î³Î¹Î± ÎºÎ¬Î¸Îµ Î¼Î¯Î± (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ Î±ÏÎ¿ÎºÎ»ÎµÎ¹ÏÏÎ¹ÎºÎ¬).",
            cntPurchasePricePerLiter: "Î ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ ÏÎ¿Ï ÏÏÏÏÏÎ¹ÎºÎ¿Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿ (ÏÏÏÎ¯Ï ÏÎµÏÎ¹Î¸ÏÏÎ¹Î¿ Î® ÏÎ·Î¼ÎµÎ¯ÏÏÎ·).",
            cntSell: "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î¼ÏÎ½Î¿ Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÎºÎ±Î¹ ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            cntSellByName:
                "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï ÏÎ»ÏÎ½ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÏÎ¿Ï ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î¿ÏÎ½ÏÎ±Î¹ ÏÏÎ¿ ÏÏÎ¿ÏÏÎ½ ÏÏÎ¿Î»Î¿Î³Î¯Î¶ÎµÏÎ±Î¹ Î¾ÎµÏÏÏÎ¹ÏÏÎ¬ Î³Î¹Î± ÎºÎ¬Î¸Îµ Î¼Î¯Î± (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½ÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÎºÎ±Î¹ ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants:
                "ÎÎ¹ Î³ÎµÎ½Î¹ÎºÎ­Ï ÏÎ¹Î¼Î­Ï ÏÏÏÏÏÎ¹ÎºÏÎ½ Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿Î¹ Î¯Î´Î¹ÎµÏ Î³Î¹Î± ÎºÎ¬Î¸Îµ ÏÏÏÏÏÎ¹ÎºÎ®. ÎÏÏÎ® Î· Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ®ÏÎ¹Î¼Î· ÎµÎ¹Î´Î¹ÎºÎ¬ Î³Î¹Î± ÏÎ¿Î½ ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Ï ÏÎ¿Ï Î¦Î Î.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Î ÎºÏÎ´Î¹ÎºÏÏ Î½Î¿Î¼Î¯ÏÎ¼Î±ÏÎ¿Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ¯Î½Î±Î¹ ÏÏo ÎµÏÎ¯ÏÎ·Î¼o Î´ÎµÎ»ÏÎ¯Î¿ ÏÏÏÎ¿Ï, Î³Î¹Î± ÏÎ±ÏÎ¬Î´ÎµÎ¹Î³Î¼Î± EUR.",
            currencyNameNew: "Î¤Î¿ ÏÎ½Î¿Î¼Î± ÏÎ¿Ï Î½Î¿Î¼Î¯ÏÎ¼Î±ÏÎ¿Ï, Î³Î¹Î± ÏÎ±ÏÎ¬Î´ÎµÎ¹Î³Î¼Î± ÏÎ¿ ÎµÏÏÏ.",
            currencyRateNew:
                "Î ÏÎ¹Î¼Î® ÏÏÎ½Î±Î»Î»Î¬Î³Î¼Î±ÏÎ¿Ï ÏÏÎ¿Ï ÏÎ¿ ÎºÏÏÎ¹Î¿ Î½ÏÎ¼Î¹ÏÎ¼Î±, Î³Î¹Î± ÏÎ±ÏÎ¬Î´ÎµÎ¹Î³Î¼Î± 25,855 CZK Î³Î¹Î± 1 ?. Î ÏÎ¹Î¼Î® ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¿ÏÎ¿ÏÎ¿Î¹ÎµÎ¯ÏÎ±Î¹ ÏÏÎ½ÎµÏÏÏ ÏÏÏÎµ Î½Î± ÎµÎ½Î·Î¼ÎµÏÏÎ½ÎµÏÎ±Î¹ ÏÏÎ½ÎµÏÏÏ.",
            currencyRoundingNew:
                "Î ÏÏÏÎ¿Î³Î³ÏÎ»Î¿ÏÎ¿Î¯Î·ÏÎ· Î¸Î­ÏÎµÎ¹ ÏÎ· Î¼Î¹ÎºÏÏÏÎµÏÎ· Î´ÏÎ½Î±ÏÎ® ÏÎ»Î·ÏÏÏÎ­Î± Î±Î¾Î¯Î± ÏÎ¿Ï Î½Î¿Î¼Î¯ÏÎ¼Î±ÏÎ¿Ï, Î³Î¹Î± ÏÎ±ÏÎ¬Î´ÎµÎ¹Î³Î¼Î± ÏÎ¿ ÎÏÏÏ Î­ÏÎµÎ¹ ÏÏÏÎ¿Î³Î³ÏÎ»Î¿ÏÎ¿Î¯Î·ÏÎ· 0,01 ÎµÏÎµÎ¹Î´Î® Î· Î¼Î¹ÎºÏÏÏÎµÏÎ· Î´ÏÎ½Î±ÏÎ® ÏÎ¹Î¼Î® ÎµÎ¯Î½Î±Î¹ 1 Î»ÎµÏÏÏ.",
            currencySymbolNew: "Î¤Î¿ ÎµÏÎ¯ÏÎ·Î¼Î¿ ÏÏÎ¼Î²Î¿Î»Î¿ ÏÎ¿Ï Î½Î¿Î¼Î¯ÏÎ¼Î±ÏÎ¿Ï, Î³Î¹Î± ÏÎ±ÏÎ¬Î´ÎµÎ¹Î³Î¼Î± ? Î³Î¹Î± ÏÎ¿ ÎµÏÏÏ.",
            defaultPrice: "Î¤Î¹Î¼Î® ÏÏÏÏÏÎ¹ÎºÎ®Ï ÏÎ¿Ï Î­ÏÎµÎ¹ Î¿ÏÎ¹ÏÏÎµÎ¯ ÏÏÎ·Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ (ÏÏÏÎ¯Ï Î¦Î Î).",
            defaultPriceGroup:
                "Î¤Î¹Î¼Î® ÏÏÏÏÏÎ¹ÎºÎ®Ï Î³Î¹Î± ÏÎ·Î½ Î¿Î¼Î¬Î´Î± ÏÎ¹Î¼ÏÎ½ ÏÎ¿Ï Î­ÏÎµÎ¹ Î¿ÏÎ¹ÏÏÎµÎ¯ ÏÏÎ·Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ (ÏÏÏÎ¯Ï Î¦Î Î).",
            defaultVatPrice: "Î¤Î¿ Î¦Î Î ÏÎ·Ï ÏÏÏÏÏÎ¹ÎºÎ®Ï ÎºÎ±Î¸Î¿ÏÎ¯Î¶ÎµÏÎ±Î¹ ÏÏÎ·Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½.",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "Î ÏÎ¹Î¼Î® ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ®Î¼Î±Î½ÏÎ·Ï Î³Î¹Î± ÏÎ¿Î»Î»Î±ÏÎ»Î¬ ÏÎ±ÎºÎ­ÏÎ± (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î¿Ï ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "Î ÏÎ¹Î¼Î® ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ·Î¼ÎµÎ¯ÏÏÎ·Ï Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î¿Ï ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ·Î¼ÎµÎ¯ÏÏÎ·Ï).",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "ÎÏÎ¹ÏÎ»Î­Î¿Î½ ÏÏÎ¿ÏÎ±ÏÎ¾Î·ÏÎ· ÏÎ¿Ï Î¿ÏÎ¯Î¶ÎµÏÎ±Î¹ Î¾ÎµÏÏÏÎ¹ÏÏÎ¬ Î³Î¹Î± ÎºÎ¬Î¸Îµ Î¼Î­Î³ÎµÎ¸Î¿Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï.",
            packageSurcharge: "ÎÎ¹ Î³ÎµÎ½Î¹ÎºÎ­Ï ÏÎ¹Î¼Î­Ï ÏÎ±ÎºÎ­ÏÏÎ½ Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿Î¹ Î¯Î´Î¹ÎµÏ Î³Î¹Î± ÎºÎ¬Î¸Îµ ÎµÏÎ¹Î²Î¬ÏÏÎ½ÏÎ· ÏÎ±ÎºÎ­ÏÎ¿Ï.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "Î ÏÎ¹Î¼Î® ÏÎ·Ï ÏÏÏÏÏÎ¹ÎºÎ®Ï ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎ±Î¹ ÎºÎ±ÏÎ¬ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÎ¼Ï ÏÎ·Ï ÏÎ¹Î¼Î®Ï Î¿Î¼Î¬Î´Î±Ï ÏÎ¹Î¼ÏÎ½.",
            priceGroups:
                "ÎÎ¹ Î¿Î¼Î¬Î´ÎµÏ ÏÎ¹Î¼ÏÎ½ ÎµÎ¼ÏÎ±Î½Î¯Î¶Î¿ÏÎ½ ÏÎ¿Î½ Î±ÏÎ¹Î¸Î¼Ï ÏÎ·Ï ÏÏÎµÏÎ¹ÎºÎ®Ï Î¿Î¼Î¬Î´Î±Ï ÏÎ¹Î¼ÏÎ½ (ÏÎ± ÏÏÎ¹Î± Î¿ÏÎ¯Î¶Î¿Î½ÏÎ±Î¹ ÏÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î® ÏÎµ Î³ÎµÎ½Î¹ÎºÎ® ÏÎ¹Î¼Î¿Î»ÏÎ³Î·ÏÎ·).",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "ÎÎ¹ Î¿Î¼Î¬Î´ÎµÏ ÏÎ¹Î¼ÏÎ½ ÎµÎ¯Î½Î±Î¹ ÏÎ± Î´Î¹Î±ÏÏÎ®Î¼Î±ÏÎ± ÏÎ¹Î¼Î¿Î»ÏÎ³Î·ÏÎ·Ï ÏÎ¿Ï ÏÎµÎ»Î¹ÎºÎ¿Ï ÏÏÏÎ¼Î±ÏÎ¿Ï Î¼Îµ Î²Î¬ÏÎ· ÏÎ¹Ï ÏÎ¹Î¼Î­Ï ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÏÏÎ·Î½ ÏÏÎ½ÏÎ±Î³Î®.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing:
                "Î ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ± ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎ±Î¹ ÏÏÎ±Î½ Î´Î¹Î±Î½Î­Î¼Î¿Î½ÏÎ±Î¹ ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½ÎµÏ ÏÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ.",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "ÎÎ¹ Î³ÎµÎ½Î¹ÎºÎ­Ï ÏÎ¹Î¼Î­Ï ÏÏÎ½ ÏÏÎ¿ÏÏÎ½ÏÏÎ½ Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿Î¹ Î¯Î´Î¹ÎµÏ Î³Î¹Î± ÎºÎ¬Î¸Îµ ÏÏÎ¿ÏÏÎ½. ÎÏÏÎ® Î· Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÎµÎ¯Î½Î±Î¹ ÏÏÎ®ÏÎ¹Î¼Î· ÎµÎ¹Î´Î¹ÎºÎ¬ Î³Î¹Î± ÏÎ¿Î½ ÎºÎ±Î¸Î¿ÏÎ¹ÏÎ¼Ï ÏÎ¿Ï Î¦Î Î.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï ÏÎ¿Î»Î»Î±ÏÎ»ÏÎ½ ÏÎ±ÎºÎ­ÏÏÎ½ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï, ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½, ÏÎ¿Ï ÏÏÎ¿ÏÎ±ÏÎ¾Î®Î¼Î±ÏÎ¿Ï ÎºÎ±Î¹ ÏÎ¿Ï ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ·Ï ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            sellPricePerKg:
                "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î±Î½Î¬ ÏÎ¹Î»Î¹ÏÎ³ÏÎ±Î¼Î¼Î¿ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï, ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½, ÏÎ·Ï ÏÏÎ¿ÏÎ±ÏÎ¾Î·ÏÎ·Ï ÎºÎ±Î¹ ÏÎ¿Ï ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ·Ï ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            sellPricePerL:
                "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï, ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½, ÏÎ¿Ï ÏÏÎ¿ÏÎ±ÏÎ¾Î®Î¼Î±ÏÎ¿Ï ÎºÎ±Î¹ ÏÎ¿Ï ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / ÏÎ®Î¼Î±Î½ÏÎ·Ï).",
            sellPricePerPkg:
                "Î ÏÎ¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï ÎµÎ½ÏÏ ÏÎ±ÎºÎ­ÏÎ¿Ï (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï Î²Î¬ÏÎ·Ï, ÏÏÏÏÏÎ¹ÎºÏÎ½ ÏÏÎ¿ÏÎ±ÏÎ¾Î·ÏÎ·Ï ÎºÎ±Î¹ ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï / Î²Î±Î¸Î¼Î¿Î»ÏÎ³Î·ÏÎ·Ï).",
            setPriceTypesVisibilityAndOrder:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î¦ÏÏÎ¼Î¿ÏÎ»Î±, Î¿Î¹ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½ÎµÏ ÏÎ¹Î¼Î­Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ­Ï ÏÏÎ¿ ÏÎ¼Î®Î¼Î± ÏÎ¹Î¼ÏÎ½. Î ÏÏÎ·Î»ÏÏÎµÏÎ· Î¸Î­ÏÎ· ÎµÎ´Ï Î¿ÏÎ¯Î¶ÎµÎ¹ ÏÎ·Î½ Î±ÏÎ¹ÏÏÎµÏÎ® Î¸Î­ÏÎ· ÏÏÎ¿ ÏÎ¼Î®Î¼Î±.",
            surchargeAll: "Î ÏÎ¹Î¼Î® ÎµÎ½ÏÏ ÏÏÏÏÎ¸ÎµÏÎ¿Ï ÏÎ­Î»Î¿ÏÏ Î³Î¹Î± ÏÎ¿Î»Î»Î±ÏÎ»Î¬ ÏÎ±ÎºÎ­ÏÎ± (Î¼Îµ ÎµÏÎ¹ÏÎ»Î­Î¿Î½ ÏÏÎ­ÏÏÎ·).",
            surchargePerPkg: "Î ÏÎ¹Î¼Î® ÎµÎ½ÏÏ ÏÏÏÏÎ¸ÎµÏÎ¿Ï ÏÎ­Î»Î¿ÏÏ Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ (Î¼Îµ ÎµÏÎ¹ÏÎ»Î­Î¿Î½ ÏÏÎ­ÏÏÎ·).",
            tintPurchaseAll:
                "Î ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î³Î¹Î± Î¿Î»ÏÎºÎ»Î·ÏÎ· ÏÎ· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± ÏÏÏÏÎ·Ï ÏÎ¿Î»Î»Î±ÏÎ»ÏÎ½ ÏÏÏÎºÎµÏÎ±ÏÎ¹ÏÎ½ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½ÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÎºÎ±Î¹ ÏÏÎ¿ÏÎ±ÏÎ¾Î·ÏÎ·Ï).",
            tintPurchasePerPkg:
                "Î ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î³Î¹Î± Î¿Î»ÏÎºÎ»Î·ÏÎ· ÏÎ· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± ÏÏÏÏÎ·Ï ÎµÎ½ÏÏ ÏÎ±ÎºÎ­ÏÎ¿Ï (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½ÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ ÎºÎ±Î¹ ÏÏÎ¿ÏÎ±ÏÎ¾Î·ÏÎ·Ï).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll:
                "Î ÏÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î³Î¹Î± ÏÎ¿Î»Î»Î±ÏÎ»Î­Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï ÎºÎ±Î¹ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½).",
            totalPurchasePerKg:
                "Î ÏÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î±Î½Î¬ ÏÎ¹Î»Î¹ÏÎ³ÏÎ±Î¼Î¼Î¿ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï ÎºÎ±Î¹ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½).",
            totalPurchasePerL:
                "Î ÏÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿ (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï ÎºÎ±Î¹ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½).",
            totalPurchasePerPkg:
                "Î ÏÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï ÏÎ¿Ï ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï Î³Î¹Î± Î¼Î¯Î± ÏÏÏÎºÎµÏÎ±ÏÎ¯Î± (ÏÏÎ¼ÏÎµÏÎ¹Î»Î±Î¼Î²Î±Î½Î¿Î¼Î­Î½Î·Ï ÏÎ·Ï Î²Î¬ÏÎ·Ï ÎºÎ±Î¹ ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î£ÏÎ½ÏÎ±Î³Î®, Î· ÏÎ¹Î¼Î® Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ® ÎºÎ±Î¹ ÏÏÎ¹Ï Î´ÏÎ¿ ÏÎ±ÏÎ±Î»Î»Î±Î³Î­Ï, Î¼Îµ ÎºÎ±Î¹ ÏÏÏÎ¯Ï Î¦Î Î, ÏÎ±ÏÏÏÏÏÎ¿Î½Î±.",
            withVat: "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î£ÏÎ½ÏÎ±Î³Î®, ÏÎ»ÎµÏ Î¿Î¹ ÏÎ¹Î¼Î­Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ­Ï Î¼ÏÎ½Î¿ Î¼Îµ Î¦Î Î.",
            withoutVat: "Î£ÏÎ¿Î½ ÏÎ¯Î½Î±ÎºÎ± Î£ÏÎ½ÏÎ±Î³Î®, ÏÎ»ÎµÏ Î¿Î¹ ÏÎ¹Î¼Î­Ï Î¸Î± ÎµÎ¯Î½Î±Î¹ Î¿ÏÎ±ÏÎ­Ï Î¼ÏÎ½Î¿ ÏÏÏÎ¯Ï Î¦Î Î."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Î£ÏÎ³ÏÏÎ¿Î½Î¯Î¶ÎµÎ¹ Î´ÎµÎ´Î¿Î¼Î­Î½Î± Î¼Îµ ÏÎ·Î½ ÎµÎ½ÏÏÎ·ÏÎ± Î Î»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ POS"
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "Î ÎµÏÎ¹ÏÎºÎµÏÎ¸ÎµÎ¯ÏÎµ",
        visitNoLicense: "ÎÎ¹Î± ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÎµÏÎ¹ÏÎºÎµÏÎ¸ÎµÎ¯ÏÎµ"
    },
    helpSettings: {
        customHelpLink: "Î£ÏÎ½Î´ÎµÏÎ¼Î¿Ï ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿Ï ÎÎ­Î½ÏÏÎ¿Ï Î²Î¿Î®Î¸ÎµÎ¹Î±Ï",
        helpSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î²Î¿Î®Î¸ÎµÎ¹Î±Ï",
        message: "ÎÎ®Î½ÏÎ¼Î±"
    },
    helper: {
        automaticallyCheckForUpdates: "ÎÎ»Î­Î³Î¾ÏÎµ ÏÎ¹Ï ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï Î±ÏÏÏÎ¼Î±ÏÎ±",
        automaticallyDownloadUpdates: "ÎÎ®ÏÎ· ÎµÎ½Î·Î¼ÎµÏÏÏÎµÏÎ½ Î±ÏÏÏÎ¼Î±ÏÎ±",
        automaticallyInstallNewDatabases: "ÎÏÏÏÎ¼Î±ÏÎ· ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· Î½Î­ÏÎ½ DB",
        automaticallyInstallUpdates: "ÎÏÏÏÎ¼Î±ÏÎ· ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÎµÎ½Î·Î¼ÎµÏÏÏÎµÏÎ½",
        bugReport: "ÎÎºÎ¸ÎµÏÎ· ÏÏÎ±Î»Î¼Î¬ÏÏÎ½",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "Î£ÏÎ»Î»Î¿Î³Î®",
        collectLogFiles: "Î£ÏÎ»Î»Î¿Î³Î® Î±ÏÏÎµÎ¯ÏÎ½ ÎºÎ±ÏÎ±Î³ÏÎ±ÏÎ®Ï",
        component: "Î£ÏÏÏÎ±ÏÎ¹ÎºÏ",
        content: "Î ÎµÏÎ¹ÎµÏÏÎ¼ÎµÎ½Î¿",
        contentSize: "ÎÎ­Î³ÎµÎ¸Î¿Ï ÏÎµÏÎ¹ÎµÏÎ¿Î¼Î­Î½Î¿Ï",
        download: "ÎÎ±ÏÎµÎ²Î¬ÏÏÎµ",
        downloadLogFiles: "ÎÎ¬Î½ÏÎµ Î»Î®ÏÎ· Î±ÏÏÎµÎ¯ÏÎ½ ÎºÎ±ÏÎ±Î³ÏÎ±ÏÎ®Ï",
        downloadingData: "ÎÎ®ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        everyHours: "KÎ¬Î¸Îµ %{interval} ÏÏÏÎ½",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "ÎÎ­Î± Î­ÎºÎ´Î¿ÏÎ·",
        notConnected: "Î Î²Î¿Î·Î¸ÏÏ Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿Ï",
        openBugReport: "ÎÎ½Î¿Î¯Î¾ÏÎµ ÏÎ·Î½ Î±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï",
        packageSize: "ÎÎ­Î³ÎµÎ¸Î¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï",
        pleaseWait: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ, Î±ÏÏÏ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î´Î¹Î±ÏÎºÎ­ÏÎµÎ¹ Î»Î¯Î³Î¿.",
        send: "Î£ÏÎµÎ¯Î»ÎµÏÎµ",
        sendBugReportToCustomerService: "Î£ÏÎµÎ¯Î»ÏÎµ Î±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï ÏÏÎ·Î½ ÏÏÎ·ÏÎµÏÎ¯Î± ÎµÎ¾ÏÏÎ·ÏÎ­ÏÎ·ÏÎ·Ï ÏÎµÎ»Î±ÏÏÎ½",
        sendingReport: "ÎÏÎ¿ÏÏÎ¿Î»Î®",
        subject: "ÎÎ­Î¼Î±"
    },
    helperDialog: {
        1: "ÎÏÎ¿ÏÎµÎ¯ÏÎµ Î½Î± ÎµÎ»Î­Î³Î¾ÎµÏÎµ Î³Î¹Î± ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï Î® Î²Î¬ÏÎµÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½.",
        2: "Î£ÏÎ½ÎµÏÎ¯ÏÏÎµ Î¼Îµ ÏÎ· Î»Î®ÏÎ· ÏÏÎ½ ÏÎ±ÎºÎ­ÏÏÎ½ ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        3: "Î£ÏÎ½ÎµÏÎ¯ÏÏÎµ Î¼Îµ ÏÎ·Î½ ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÎ½ ÏÎ±ÎºÎ­ÏÏÎ½ ÎµÎ½Î·Î¼ÎµÏÏÎ¼Î­Î½ÏÎ½ ÎµÎºÎ´ÏÏÎµÏÎ½ ÏÎ¿Ï Î­ÏÎµÏÎµ Î»Î¬Î²ÎµÎ¹",
        10: "ÎÎ»ÎµÎ³ÏÎ¿Ï Î³Î¹Î± ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÎºÎ±Î¹ Î²Î¬ÏÎµÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        11: "Î¥ÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· Î¼Î¹Î± ÎµÎ½Î·Î¼Î­ÏÏÏÎ· Î³Î¹Î± ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® ÏÎ±Ï. ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÎ¿ ÎºÎ±ÏÎµÎ²Î¬ÏÎµÏÎµ",
        12: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï Î³Î¹Î± ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® ÏÎ±Ï.",
        14: "Î Î±ÏÎ¿ÏÏÎ¹Î¬ÏÏÎ·ÎºÎµ ÏÏÎ¬Î»Î¼Î± ÎºÎ±ÏÎ¬ ÏÎ¿Î½ Î­Î»ÎµÎ³ÏÎ¿ Î³Î¹Î± ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï. %{0}",
        15: "Î£ÏÎ³ÏÏÎ¿Î½Î¹ÏÎ¼ÏÏ Î²Î¬ÏÎµÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î¶ÏÎ½Î·Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        20: "ÎÎ®ÏÎ· ÏÎ±ÎºÎ­ÏÎ¿Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        21: "Î¤Î¿ ÎµÎ½Î·Î¼ÎµÏÏÎ¼Î­Î½Î¿ ÏÎ±ÎºÎ­ÏÎ¿ ÏÎ¿Ï Î»Î®ÏÎ¸Î·ÎºÎµ ÎµÎ¯Î½Î±Î¹ ÏÏÏÎ± ÎµÏÎ±Î»Î·Î¸ÎµÏÎ¼Î­Î½Î¿, ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        22: "Î Î»Î®ÏÎ· ÏÎ¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï ÎµÎ½Î·Î¼ÎµÏÏÎ¼Î­Î½Î·Ï Î­ÎºÎ´Î¿ÏÎ·Ï Î±ÏÎ­ÏÏÏÎµ, Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎ¿ÏÏÎ±Î¸Î®ÏÎµÏÎµ Î¾Î±Î½Î¬",
        23: "Î Î»Î®ÏÎ· ÏÎ¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï ÎµÎ½Î·Î¼ÎµÏÏÎ¼Î­Î½ÏÎ½ ÎµÎºÎ´ÏÏÎµÏÎ½ Î±ÏÎ­ÏÏÏÎµ (ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ Î­ÏÎµÎ¹ ÏÎ±ÏÎ±Î¼Î¿ÏÏÏÎ¸ÎµÎ¯), Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎ¿ÏÏÎ±Î¸Î®ÏÎµÏÎµ Î¾Î±Î½Î¬",
        24: "Î£ÏÎ½ÎµÏÎ¯ÏÏÎµ Î¼Îµ ÏÎ·Î½ ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÎ·Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        25: "Î ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÎ·Ï Î±ÏÏÏÎ¼Î±ÏÎ·Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ ÏÏÎ¿ %{0}",
        26: "Î¥ÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· Î¼Î¹Î± ÎµÎ½Î·Î¼Î­ÏÏÏÎ· Î³Î¹Î± ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® ÏÎ±Ï. ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÎ¿ ÎºÎ±ÏÎµÎ²Î¬ÏÎµÏÎµ",
        27: "Î£ÏÎ½ÎµÏÎ¯ÏÏÎµ Î¼Îµ ÏÎ·Î½ ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÎ·Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        40: "Î Î±ÏÏÎ· ÎµÏÎ±ÏÎ¼Î¿Î³ÏÎ½ ÎºÎ±Î¹ ÏÏÎ·ÏÎµÏÎ¹ÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        41: "ÎÎ½ÏÎ¹Î³ÏÎ±ÏÎ® Î½Î­ÏÎ½ Î±ÏÏÎµÎ¯ÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        42: "ÎÎµÎºÎ¹Î½ÏÎ½ÏÎ±Ï ÎµÏÎ±ÏÎ¼Î¿Î³Î­Ï ÎºÎ±Î¹ ÏÏÎ·ÏÎµÏÎ¯ÎµÏ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        43: "Î¤ÎµÏÎ¼Î±ÏÎ¹ÏÎ¼ÏÏ ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ ...",
        44: "Î¤Î¿ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ ÏÎ±Ï ÎµÎ½Î·Î¼ÎµÏÏÎ¸Î·ÎºÎµ Î¼Îµ ÎµÏÎ¹ÏÏÏÎ¯Î±.",
        45: "ÎÎ­Î»ÎµÏÎµ Î½Î± Î´Î¿ÎºÎ¹Î¼Î¬ÏÎµÏÎµ Î¾Î±Î½Î¬ ÏÎ·Î½ ÎµÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ·. ÎÎ½ Î±ÏÎ¿ÏÎ±ÏÎ¯ÏÎµÏÎµ Î½Î± ÏÏÎ¿ÏÏÎ±Î¸Î®ÏÎµÏÎµ Î¾Î±Î½Î¬, Î²ÎµÎ²Î±Î¹ÏÎ¸ÎµÎ¯ÏÎµ ÏÏÎ¹ ÏÎ± ÏÏÎ¿Î¹ÏÎµÎ¯Î± Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï Î´ÎµÎ½ ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î¿ÏÎ½ÏÎ±Î¹ Î±ÏÏÎ®Î½ ÏÎ· ÏÏÎ¹Î³Î¼Î®.",
        46: "ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® Î³Î¹Î± Î½Î± ÎµÏÎ·ÏÎµÎ¬ÏÎµÎ¹ ÏÎ¹Ï Î±Î»Î»Î±Î³Î­Ï, Î· ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· Î¸Î± Î³Î¯Î½ÎµÎ¹ ÏÏÎ¿ %{0}",
        999: "Î Î±ÏÎ¿ÏÏÎ¹Î¬ÏÏÎ·ÎºÎµ ÎµÏÏÏÎµÏÎ¹ÎºÏ ÏÏÎ¬Î»Î¼Î±: %{0}",
        automaticInstallation: "ÎÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· Î±ÏÏÏÎ¼Î±ÏÎ·Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        btnAbort: "ÎÎ±ÏÎ±Î¯ÏÏÎ·",
        btnCancel: "ÎÎºÏÏÏÏÏÎµ",
        btnCheckUpdate: "ÎÎ»ÎµÎ³ÏÎ¿Ï Î³Î¹Î± ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï",
        btnContinue: "Î£ÏÎ½ÎµÏÎ¯ÏÏÎµ",
        btnDownloadUpdate: "ÎÎ®ÏÎ· ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        btnInstallUpdate: "ÎÎ³ÎºÎ±ÏÎ¬ÏÏÎ·ÏÎµ ÏÎ·Î½ ÎµÎ½Î·Î¼Î­ÏÏÏÎ·",
        btnOk: "ÎÎ½ÏÎ¬Î¾ÎµÎ¹",
        btnRetry: "Î ÏÎ¿ÏÏÎ±Î¸Î·ÏÎµ Î¾Î±Î½Î±",
        btnSkip: "Î Î±ÏÎ¬Î»ÎµÎ¹ÏÎ·",
        checkingForUpdates: "ÎÎ»ÎµÎ³ÏÎ¿Ï Î³Î¹Î± ÎµÎ½Î·Î¼ÎµÏÏÏÎµÎ¹Ï",
        downloadingFailed: "Î Î»Î®ÏÎ· Î±ÏÎ­ÏÏÏÎµ",
        downloadingPackage: "ÎÎ®ÏÎ· ÏÎ±ÎºÎ­ÏÎ¿Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        finishingUpdate: "ÎÎ®Î¾Î· ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        installingUpdate: "ÎÎ³ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        internalError: "ÎÏÏÏÎµÏÎ¹ÎºÏ ÏÏÎ¬Î»Î¼Î±",
        rebootRequired: "ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ·",
        startingComponents: "ÎÎºÎºÎ¯Î½Î·ÏÎ· ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï",
        stoppingComponents: "ÎÎ¹Î±ÎºÎ¿ÏÎ® ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï",
        synchronizingDatabases: "Î£ÏÎ³ÏÏÎ¿Î½Î¹ÏÎ¼ÏÏ Î²Î¬ÏÎµÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î¶ÏÎ½Î·Ï",
        updateAvailable: "ÎÎ½Î·Î¼Î­ÏÏÏÎ· Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÏÎ½, ÎµÏÎ¹Î»Î¿Î³Î® ÏÏÎ¿Î¹ÏÎµÎ¯ÏÎ½ ÏÎ¿Ï Î¸Î± ÎµÎ½Î·Î¼ÎµÏÏÎ¸Î¿ÏÎ½",
        updateDownloaded: "Î ÎµÎ½Î·Î¼Î­ÏÏÏÎ· Î­ÏÎµÎ¹ Î¼ÎµÏÎ±ÏÎ¿ÏÏÏÎ¸ÎµÎ¯",
        updateFailed: "Î Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï Î±ÏÎ­ÏÏÏÎµ",
        updateInstalled: "ÎÏÎµÎ¹ ÎµÎ³ÎºÎ±ÏÎ±ÏÏÎ±Î¸ÎµÎ¯ ÎµÎ½Î·Î¼Î­ÏÏÏÎ·",
        verificationFailed: "Î ÎµÏÎ±Î»Î®Î¸ÎµÏÏÎ· ÏÎ¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï Î±ÏÎ­ÏÏÏÎµ",
        verifyingPackage: "ÎÏÎ±Î»Î®Î¸ÎµÏÏÎ· ÏÎ¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï Î»Î®ÏÎ·Ï",
        yourSoftwareIsUpToDate: "Î¤Î¿ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ ÏÎ±Ï ÎµÎ¯Î½Î±Î¹ ÎµÎ½Î·Î¼ÎµÏÏÎ¼Î­Î½Î¿",
        yourSoftwareVersion: "Î Î­ÎºÎ´Î¿ÏÎ· ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÏÎ±Ï: %{0}"
    },
    importData: {
        abortImportingData: "ÎÎºÏÏÏÏÎ· ÎµÎ¹ÏÎ±Î³ÏÎ³Î®Ï",
        aborted: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÎºÏÏÏÎ¸Î·ÎºÎµ.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÏÎ­ÏÏÏÎµ ÎµÏÎµÎ¹Î´Î® ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ ÏÏÎ¿Î­Î»ÎµÏÏÎ·Ï Î´ÎµÎ½ ÏÎµÏÎ¹ÎµÎ¯ÏÎµ Î´ÎµÎ´Î¿Î¼Î­Î½Î±.",
        deleteImportedData: "ÎÎ¹Î±Î³ÏÎ¬ÏÏÎµ ÏÎ± ÎµÎ¹ÏÎ±Î³ÏÎ¼ÎµÎ½Î± Î´ÎµÎ´Î¿Î¼Î­Î½Î±",
        encodingFile: "ÎÏÎ´Î¹ÎºÎ¿ÏÎ¿Î¯Î·ÏÎ· Î±ÏÏÎµÎ¯Î¿Ï",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÏÎ­ÏÏÏÎµ ÎµÏÎµÎ¹Î´Î® ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ ÏÏÎ¿Î­Î»ÎµÏÏÎ·Ï ÏÎ±Î¯Î½ÎµÏÎ±Î¹ Î½Î± Î­ÏÎµÎ¹ ÎºÎ±ÏÎ±ÏÏÏÎ±ÏÎµÎ¯.",
        fileMissing: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÏÎ­ÏÏÏÎµ ÎµÏÎµÎ¹Î´Î® ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ ÏÏÎ¿Î­Î»ÎµÏÏÎ·Ï Î´ÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹.",
        format: "ÎÎ¿ÏÏÎ®",
        formatPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï",
        headerMissing: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÏÎ­ÏÏÏÎµ ÎµÏÎµÎ¹Î´Î® Î»ÎµÎ¯ÏÎµÎ¹ Î· ÎºÎµÏÎ±Î»Î¯Î´Î± Î±ÏÏÎµÎ¯ÏÎ½.",
        import: "ÎÎ¹ÏÎ±Î³ÏÎ³Î®",
        importAborted: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î¼Î±ÏÎ±Î¹ÏÎ¸Î·ÎºÎµ",
        importAborting: "ÎÎ±ÏÎ±Î¯ÏÏÎ· ÎµÎ¹ÏÎ±Î³ÏÎ³Î®Ï",
        importFailed: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÏÎ­ÏÏÏÎµ Î»ÏÎ³Ï Î¼Î· Î±Î½Î±Î¼ÎµÎ½ÏÎ¼ÎµÎ½Î¿Ï ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï.",
        importLocalSettings: "Import Local Settings",
        importPrices: "ÎÎ¹ÏÎ±Î³ÏÎ³Î® ÏÎ¹Î¼ÏÎ½",
        imported: "ÎÏÎ¹ÏÏÏÎ®Ï ÎµÎ¹ÏÎ±Î³ÏÎ³Î®",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "ÎÎ¹ÏÎ±Î³ÏÎ³Î®",
        noFormatAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· Î¼Î¿ÏÏÎ®",
        processing: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î±",
        processingCustomFormulas: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½ÏÎ½ ÏÏÎ½ÏÎ±Î³ÏÎ½",
        processingCustomers: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÎµÎ»Î±ÏÏÎ½",
        productsFile: "ÎÏÏÎµÎ¯Î¿ ÏÏÎ¿ÏÏÎ½ÏÏÎ½",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎµÎ¾Î­Î»Î¹Î¾Î·.",
        unknownFormat: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® Î±ÏÎ­ÏÏÏÎµ ÎµÏÎµÎ¹Î´Î® ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ ÏÏÎ¿Î­Î»ÎµÏÏÎ·Ï ÎµÎ¯Î½Î±Î¹ Î¬Î³Î½ÏÏÏÎ· Î¼Î¿ÏÏÎ®.",
        userFormulasFile: "ÎÏÏÎµÎ¯Î¿ ÏÏÎ½ÏÎ±Î³ÏÎ½ ÏÏÎ®ÏÏÎ·"
    },
    infoType: {
        baseDensity: "ÎÎ¬ÏÎ· ÏÏÎºÎ½ÏÏÎ·ÏÎ±Ï",
        baseMass: "ÎÎ¬Î¶Î± Î²Î¬ÏÎ·Ï",
        baseUfiCode: "Base UFI code",
        baseVolume: "ÎÎ³ÎºÎ¿Ï Î²Î¬ÏÎ·Ï",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "ÎÎ±Î¸Î¼ÏÏ BFS",
        colorLab: "ÎÏÎ³Î±ÏÏÎ®ÏÎ¹Î¿ ÏÏÏÎ¼Î¬ÏÏÎ½",
        colorRgb: "RGB ÏÏÏÎ¼Î±ÏÎ¿Ï",
        colorRgbHex: "Î§ÏÏÎ¼Î± RGB Hex",
        colorXyz: "Î§ÏÏÎ¼Î± xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "ÎÎ¬Î¶Î± ÏÏÏÏÏÎ¹ÎºÏÎ½",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "ÎÎ³ÎºÎ¿Ï ÏÏÏÏÏÎ¹ÎºÎ®Ï",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW",
        isPackageGravimetric: "ÎÎ¯Î½Î±Î¹ Î²Î±ÏÏÎ¼ÎµÏÏÎ¹ÎºÏ ÏÎ±ÎºÎ­ÏÎ¿",
        maxColorantMass: "ÎÎ­Î³Î¹ÏÏÎ· ÎµÏÎ¹ÏÏÎµÏÏÎ¼ÎµÎ½Î· ÏÏÏÎ¼Î±ÏÎ¹ÎºÎ® Î¼Î¬Î¶Î±",
        maxColorantVolume: "ÎÎ­Î³Î¹ÏÏÎ¿Ï ÎµÏÎ¹ÏÏÎµÏÏÎ¼ÎµÎ½Î¿Ï ÏÎ³ÎºÎ¿Ï ÏÏÏÏÏÎ¹ÎºÏÎ½",
        nominalMass: "ÎÎ½Î¿Î¼Î±ÏÏÎ¹ÎºÎ® Î¼Î¬Î¶Î± ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï",
        nominalVolume: "ÎÎ½Î¿Î¼Î±ÏÏÎ¹ÎºÏÏ ÏÎ³ÎºÎ¿Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï",
        overfillDetected: "ÎÎ½ÏÎ¿ÏÎ¯ÏÏÎ·ÎºÎµ ÏÏÎµÏÏÎ»Î®ÏÏÏÎ·",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® Î¼Î¬Î¶Î± ÏÏÏÎ¼Î±ÏÎ¿Ï",
        totalPaintVolume: "Î£ÏÎ½Î¿Î»Î¹ÎºÏÏ ÏÎ³ÎºÎ¿Ï ÏÏÏÎ¼Î±ÏÎ¿Ï",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "Î¤Î¹Î¼Î® Y"
    },
    initialTab: {
        favoriteFormulas: "ÎÎ³Î±ÏÎ·Î¼Î­Î½ÎµÏ ÏÏÎ½ÏÎ±Î³Î­Ï",
        lastDispensedFormulas: "Î¤ÎµÎ»ÎµÏÏÎ±Î¯Î± ÏÏÎ½ÏÎ±Î³Î®",
        searchNewFormula: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· Î½Î­Î±Ï ÏÏÎ½ÏÎ±Î³Î®Ï"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ·Î½ Î¬Î´ÎµÎ¹Î±",
        activateNewLicense: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ Î½Î­Î± Î¬Î´ÎµÎ¹Î±",
        checkLicenseKey: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÎµÎ»Î­Î³Î¾ÎµÏÎµ ÏÎ¿Î½ ÎºÏÎ´Î¹ÎºÏ ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ·Ï",
        companyId: "ÎÏÏÎ¹ÎºÏÏ ÎÏÎ±Î¹ÏÎµÎ¯Î±Ï",
        contactPerson: "Î¥ÏÎµÏÎ¸ÏÎ½Î¿Ï ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î±Ï",
        copy: "Î±Î½ÏÎ¯Î³ÏÎ±ÏÎ¿",
        country: "Î§ÏÏÎ±",
        emptyCity: "Î ÏÏÎ»Î· ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÎ±Î¯ÏÎ·ÏÎ· ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯Î±",
        emptyCountry: "Î ÏÏÏÎ± ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÎ±Î¯ÏÎ·ÏÎ· ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯Î±",
        emptyName: "Î¤Î¿ ÏÎ½Î¿Î¼Î± ÎºÎ±ÏÎ±ÏÏÎ®Î¼Î±ÏÎ¿Ï ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÎ±Î¯ÏÎ·ÏÎ· ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯Î±",
        enterIdentificationKeys: "ÎÎ¹ÏÎ±Î³Î¬Î³ÎµÏÎµ ÏÎ± ÎºÎ»ÎµÎ¹Î´Î¹Î¬ Î±Î½Î±Î³Î½ÏÏÎ¹ÏÎ·Ï",
        expirationDate: "ÎÎ¼ÎµÏÎ¿Î¼Î·Î½Î¯Î± Î»Î®Î¾Î·Ï %{dateTime}",
        fillRegistration: "Fill registration data",
        insertLicense: "ÎÎ¹ÏÎ±Î³ÏÎ³Î® ÏÎ±ÏÎ±Î³ÏÎ¼ÎµÎ½Î¿Ï ÎºÎ»ÎµÎ¹Î´Î¹Î¿Ï Î³Î¹Î± ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· ÎµÎºÏÏÏ ÏÏÎ½Î´ÎµÏÎ·Ï",
        invalidEmail: "Î ÎµÎ¹ÏÎ±Î³ÏÎ³Î® email Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î­Î³ÎºÏÏÎ·",
        invalidPhone: "Î ÎµÎ¯ÏÎ±Î³ÏÎ³Î® ÏÎ·Î»ÎµÏÏÎ½Î¿Ï Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î­Î³ÎºÏÏÎ·",
        itemsMarkedasterisk: "(ÏÎ± ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ¿Ï ÏÎ·Î¼ÎµÎ¹ÏÎ½Î¿Î½ÏÎ±Î¹ Î¼Îµ Î±ÏÏÎµÏÎ¯ÏÎºÎ¿ ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ¼ÏÎ»Î·ÏÏÎ¸Î¿ÏÎ½)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "ÎÎ¹ÏÎ¸ÏÎ¼Î­Î½Î· Î¬Î´ÎµÎ¹Î±",
        licenseActivated: "License already activated",
        licenseStatus: "ÎÎ±ÏÎ¬ÏÏÎ±ÏÎ· Î¬Î´ÎµÎ¹Î±Ï",
        licenseWillExpire: "Î Î¬Î´ÎµÎ¹Î¬ ÏÎ±Ï Î»Î®Î³ÎµÎ¹ ÏÎµ %{dayCount} Î·Î¼Î­ÏÎµÏ",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "Î Î»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ Î¼Î·ÏÎ±Î½Î®Ï",
        noLicenseAvailable: "Î´ÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· Î¬Î´ÎµÎ¹Î±",
        noProductsForKey: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î± ÏÏÎ¿ÏÏÎ½ÏÎ± Î³Î¹Î± ÏÎ± Î±Î½Î±ÏÎµÏÏÎ¼ÎµÎ½Î± ÎºÎ»ÎµÎ¹Î´Î¹Î¬ Î±Î½Î±Î³Î½ÏÏÎ¹ÏÎ·Ï.",
        pointOfSale: "Î£Î·Î¼ÎµÎ¯Î¿ ÏÏÎ»Î·ÏÎ·Ï",
        producer: "Î Î±ÏÎ±Î³ÏÎ³ÏÏ",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "Î ÎµÏÎ¹Î¿ÏÎ®",
        registerLicense: "Î Î¬ÏÏÎµ Î­Î½Î± Î±Î½ÏÎ¯Î³ÏÎ±ÏÎ¿ ÏÎ¿Ï Î±Î¹ÏÎ®Î¼Î±ÏÎ¿Ï ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ·Ï ÎºÎ±Î¹ Î¼ÎµÏÎ±Î²ÎµÎ¯ÏÎµ ÏÏÎ· Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ·:",
        registrationForm: "ÎÎ³Î³ÏÎ±ÏÎ®",
        selectProduct: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÎ¿ÏÏÎ½",
        serialNumber: "Î£ÎµÎ¹ÏÎ¹Î±ÎºÏÏ Î±ÏÎ¹Î¸Î¼ÏÏ",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "ÎÏÎµÏÎ¹ÏÏÎ¹ÏÏÎ· Î¬Î´ÎµÎ¹Î±",
        userId: "ÏÎ±ÏÏÏÏÎ·ÏÎ± ÏÏÎ®ÏÏÎ·",
        uuid: "UUID Î¬Î´ÎµÎ¹Î±Ï",
        versionDetails: "ÎÎµÏÏÎ¿Î¼Î­ÏÎµÎ¹ÎµÏ Î­ÎºÎ´Î¿ÏÎ·Ï",
        versionScope: "Î ÎµÎ´Î¯Î¿ Î­ÎºÎ´Î¿ÏÎ·Ï",
        versionType: "Î¤ÏÏÎ¿Ï Î­ÎºÎ´Î¿ÏÎ·Ï",
        zip: "ÎÎÎ¡"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "ÎÎ¹ÏÎ±Î³ÏÎ³Î®",
        loginAs: "Î£ÏÎ½Î´ÎµÎ¸ÎµÎ¯ÏÎµ ÏÏ Î¬Î»Î»Î¿Ï ÏÏÎ®ÏÏÎ·Ï",
        messages: {
            incorrectUsername: "ÎÎ½Î¿Î¼Î± ÏÏÎ®ÏÏÎ· Î® ÎºÏÎ´Î¹ÎºÏÏ ÎµÎ¯Î½Î±Î¹ ÎµÏÏÎ±Î»Î¼Î­Î½Î¿Ï."
        },
        password: "ÎÏÎ´Î¹ÎºÏÏ",
        username: "ÎÎ½Î¿Î¼Î± ÏÏÎ®ÏÏÎ·"
    },
    machineActionHistory: {
        actionHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÎµÎ½ÎµÏÎ³ÎµÎ¹ÏÎ½"
    },
    machineErrors: {
        channel: "ÎÎ±Î½Î¬Î»Î¹",
        code: "ÎÏÎ´Î¹ÎºÎ±Ï",
        machineErrors: "Î£ÏÎ¬Î»Î¼Î±ÏÎ± Î¼Î·ÏÎ±Î½Î®Ï ÏÏÏÎ¼Î±ÏÎ¹Î¼ÏÎ¿Ï",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ±Î»Î¼Î¬ÏÏÎ½"
    },
    machineSettings: {
        action: "ÎÏÎ¬ÏÎ·",
        addAutotask: "Add autotask",
        autoCanisterIn: "ÎÏÏÏÎ¼Î±ÏÎ· ÎµÎ¹ÏÎ±Î³ÏÎ³Î® ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        autoCanisterOut: "ÎÏÏÏÎ¼Î±ÏÎ· ÎµÎ¾Î±Î³ÏÎ³Î® ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        automaticRefill: "ÎÏÏÏÎ¼Î±ÏÎ· ÎµÏÎ±Î½Î±ÏÎ»Î®ÏÏÏÎ·",
        autotaskSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î±ÏÏÏÎ¼Î±ÏÎ·Ï Î´Î¹ÎµÏÎ³Î±ÏÎ¯Î±Ï",
        backupConfiguration: "ÎÎ¹Î±Î¼ÏÏÏÏÏÎ· Î±Î½ÏÎ¹Î³ÏÎ¬ÏÏÎ½ Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        brushMaintenance: "Î£ÏÎ½ÏÎ®ÏÎ·ÏÎ· Î²Î¿ÏÏÏÏÎ±Ï",
        capMaintenance: "Î£ÏÎ½ÏÎ®ÏÎ·ÏÎ· ÎºÎ±ÏÎ±ÎºÎ¹Î¿Ï",
        checkCanisterBeforeDispense: "ÎÎ»ÎµÎ³ÏÎ¿Ï ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï ÏÏÎ¹Î½ ÏÎ· Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "ÎÎ±Î¸Î±ÏÎ¯ÏÏÎµ ÏÎ»Î±",
        computerReboot: "ÎÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        computerShutdown: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        connectMachine: "Î£ÏÎ½Î´Î­ÏÏÎµ ÏÎ· Î¼Î·ÏÎ±Î½Î®",
        days: "ÎÎ¼Î­ÏÎµÏ",
        daysOfMonth: "ÎÎ­ÏÎµÏ ÏÎ¿Ï Î¼Î®Î½Î±",
        devices: "ÏÏÏÎºÎµÏÎ­Ï",
        disabled: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®Î¸Î·ÎºÎµ",
        dispenseAndPurge: "ÎÎ¹Î±Î½ÎµÎ¯Î¼ÎµÏÎµ ÎºÎ±Î¹ ÎºÎ±Î¸Î±ÏÎ¯ÏÏÎµ",
        dispenseOnly: "ÎÎ¹Î±Î½ÎµÎ¯Î¼ÎµÏÎµ Î¼ÏÎ½Î¿",
        dispenserCleaning: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ Î´Î¹Î±Î½Î¿Î¼Î­Î±",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "Edit autotask",
        firstRun: "First run",
        hours: "Î©ÏÎµÏ",
        humidifier: "Î¥Î³ÏÎ±Î½ÏÎ®ÏÎ±Ï",
        humidifierWaterLevelMaintenance: "Î£ÏÎ½ÏÎ®ÏÎ·ÏÎ· ÏÎ·Ï ÏÏÎ¬Î¸Î¼Î·Ï ÏÎ¿Ï Î½ÎµÏÎ¿Ï ÏÎ¿Ï ÏÎ³ÏÎ±Î½ÏÎ®ÏÎ±",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "ÎÎ½Î¿Î¼Î± Î¼Î·ÏÎ±Î½Î®Ï ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
        machineSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¼Î·ÏÎ±Î½Î®Ï",
        manualPuncher: "Î§ÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ¿ ÏÏÏÏÎ·ÏÎ®ÏÎ¹",
        minDispensedAmount: "ÎÎ»Î¬ÏÎ¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        minutes: "ÎÎµÏÏÎ¬",
        nextRun: "ÎÏÏÎ¼ÎµÎ½Î· ÎµÎºÏÎ­Î»ÎµÏÎ·",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÏÏÎ½Î´ÎµÎ¸ÎµÎ¯ ÎºÎ±Î½Î­Î½Î± Î¼Î·ÏÎ¬Î½Î·Î¼Î±",
        onStart: "Î£ÏÎ·Î½ Î±ÏÏÎ®",
        plugger: "Î¥ÏÎ¿Î´Î¿ÏÎ­Î±Ï",
        postpone: "Postpone",
        puncher: "ÎÎ¹Î±ÏÏÎ·ÏÎ®Ï",
        purgeAll: "ÎÎ±Î¸Î±ÏÎ¯ÏÏÎµ ÏÎ»Î±",
        purgeOnly: "Purge only",
        recirculateAll: " ÎÎ½Î±ÎºÎ»ÏÎºÎ»ÏÏÏÎµ ÏÎ»Î±",
        recirculateChannels: "ÎÎ½Î±ÎºÏÎºÎ»ÏÏÏÎµ ÏÎ± ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        recirculationSpeed: "Î¤Î±ÏÏÏÎ·ÏÎ± Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ·Ï",
        recirculationTime: "Î§ÏÏÎ½Î¿Ï Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ·Ï",
        refillAll: "ÎÏÎ±Î½Î±ÏÎ»Î·ÏÏÏÏÎµ ÏÎ»Î±",
        refillCanisters: "ÎÏÎ±Î½Î±ÏÎ»Î·ÏÏÏÏÎµ ÏÎ± ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        runAt: "Run at",
        runDefinedDaysAt: "ÎÏÎ¹ÏÎ¼Î­Î½ÎµÏ Î·Î¼Î­ÏÎµÏ ÏÎµ",
        runEvery: "ÎÎºÏÎµÎ»Î­ÏÏÎµ ÎºÎ¬Î¸Îµ",
        runInDays: "ÎÎºÏÎ­Î»ÎµÏÎ· ÏÎµ Î·Î¼Î­ÏÎµÏ",
        serialNum: "S/N",
        settingsMachine: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¼Î·ÏÎ±Î½Î®Ï ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
        smartPurgeAll: "ÎÎ¾ÏÏÎ½Î¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÏÎ»ÏÎ½",
        smartPurgeChannels: "ÎÎ¾ÏÏÎ½Î¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        smartPurgeRules: "ÎÎ¾ÏÏÎ½Î¿Î¹ ÎºÎ±Î½ÏÎ½ÎµÏ ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï",
        startType: "Î¤ÏÏÎ¿Ï ÎµÎºÎºÎ¯Î½Î·ÏÎ·Ï",
        stirAll: "ÎÎ½Î±ÎºÎ±ÏÎ­ÏÏÎµ ÏÎ»Î±",
        stirCanisters: "ÎÎ½Î±ÎºÎ±ÏÎ­ÏÏÎµ ÏÎ± ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        stirringSpeed: "Î¤Î±ÏÏÏÎ·ÏÎ± Î±Î½Î¬Î´ÎµÏÏÎ·Ï",
        stirringTime: "Î§ÏÏÎ½Î¿Ï Î±Î½Î¬Î´ÎµÏÏÎ·Ï",
        switchPlateMaintenance: "Î£ÏÎ½ÏÎ®ÏÎ·ÏÎ· Î´Î¯ÏÎºÎ¿Ï ÏÏÎ½ÏÎ®ÏÎ·ÏÎ·Ï",
        theCurrentlySelectedMachine: "ÎÏÎ¹Î»Î¿Î³Î® ÏÏÎ³ÎºÎµÎºÏÎ¹Î¼Î­Î½Î·Ï Î¼Î·ÏÎ±Î½Î®Ï ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
        threshold: "ÎÎ±ÏÏÏÎ»Î¹",
        turntable: "ÎÎ¹Î½Î·ÏÏ ÏÏÎ±ÏÎ­Î¶Î¹",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "ÎÎ½ÏÎ±ÏÎ· ÎÎ§ÎÎ¥",
        weekdays: "ÎÏÎ³Î¬ÏÎ¹Î¼ÎµÏ"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÎ± Î±Î³Î±ÏÎ·Î¼Î­Î½Î±",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "ÎÎ½Î± Î® ÏÎµÏÎ¹ÏÏÏÏÎµÏÎ± ÏÏÏÏÏÎ¹ÎºÎ¬ Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î­Î³ÎºÏÏÎ±",
        dispensedPackages: "ÎÎ¹Î±Î½ÎµÎ¼Î·Î¼Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ±",
        dispensingInProgress: "ÎÎ¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ· ÏÎµ ÎµÎ¾Î­Î»Î¹Î¾Î·",
        dispensingIsAborted: "Î Î´Î¹Î±Î½Î¿Î¼Î® Î±ÎºÏÏÏÎ½ÎµÏÎ±Î¹",
        dispensingIsNotAvailable: "Î Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ· Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        dispensingProgress: "%{done} ÏÎ¿Ï %{all}",
        editColorant: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÏÏÏÎ¹ÎºÏÎ½",
        editNote: "Edit Note",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "ÎÎ½Î±Î³ÎºÎ±ÏÏÎ¹ÎºÎ® Î´Î¹Î±Î½Î¿Î¼Î®",
        formulaInvalidColorants: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± ÏÎµÏÎ¹Î­ÏÎµÎ¹ Î¼Î· Î­Î³ÎºÏÏÎµÏ ÏÏÏÏÏÎ¹ÎºÎ­Ï: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "ÎÏÏÎ¿ÏÎ¹ÎºÎ­Ï ÏÏÏÎ¼Î¿ÏÎ»ÎµÏ",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "Î£ÏÎ¬Î»Î¼Î± Î¼Î·ÏÎ±Î½Î®Ï",
        machineIsBusy: "Î Î¼Î·ÏÎ±Î½Î® ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÏÎ¿Î»Î·Î¼Î­Î½Î·",
        machineNotConnected: "Î Î¼Î·ÏÎ±Î½Î® Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î·",
        manualColorantAddition: "Î§ÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· ÏÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÏÏÏÎ¹ÎºÎ®Ï",
        modifiedFormula: "Î ÏÏÎ½ÏÎ±Î³Î® ÏÏÎ¿ÏÎ¿ÏÎ¿Î¹ÎµÎ¯ÏÎ±Î¹",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î· Î²Î¬ÏÎ·",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ ÏÏÏÏÏÎ¹ÎºÎ­Ï",
        noCustomer: "ÎÎ±Î½Î­Î½Î±Ï ÏÎµÎ»Î¬ÏÎ·Ï",
        noCustomers: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿Î¹ ÏÎµÎ»Î¬ÏÎµÏ",
        noDispenseNotesAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ ÏÎ·Î¼ÎµÎ¹ÏÏÎµÎ¹Ï Î³Î¹Î± ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÏÎ½ÏÎ±Î³Î®",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÏÎ·Î¼ÎµÎ¹ÏÏÎµÎ¹Ï",
        noPackageAvailable: "No package is available",
        noPackageSelected: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "Î Î±ÏÎ±Î³Î³ÎµÎ»Î¯Î±",
        orderingIsNotAvailable: "Î ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î± Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        originalColor: "Original color",
        overAvailableLevel: "Î Î¬Î½Ï Î±ÏÏ ÏÎ¿ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿ ÎµÏÎ¯ÏÎµÎ´Î¿",
        package: "Î£ÏÏÎºÎµÏÎ±ÏÎ¯Î±",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Î ÎµÎºÏÏÏÏÏÎ· Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        productFiles: "ÎÏÏÎµÎ¯Î± ÏÏÎ¿ÏÏÎ½ÏÏÎ½",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Î¤Î¹Î¼Î® Î¤Î¹Î¼Î¿ÎºÎ±ÏÎ±Î»ÏÎ³Î¿Ï",
        resetFormulaData: "ÎÎ­Î± ÏÏÏÎ¼Î¿ÏÎ»Î±",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏ",
        saveToStatsIsNotAvailable: "Î Î±ÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¿ Î¹ÏÏÎ¿ÏÎ¹ÎºÏ Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "ÎÎ¹Î´Î¹ÎºÎ® ÏÎ¹Î¼Î®",
        specialPriceVip: "ÎÎ¹Î´Î¹ÎºÎ® ÏÎ¹Î¼Î® VIP",
        splitFormula: "ÎÎ¹Î±Î¯ÏÎµÏÎ· ÏÏÎ½ÏÎ±Î³Î®Ï",
        withVAT: "Î¼Îµ Î¦Î Î",
        withoutVAT: "ÏÏÏÎ¯Ï Î¦Î Î"
    },
    marginSettings: {
        allBases: "all bases",
        allProducts: "all products",
        editMargin: "Edit margin",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÎµÏÎ¹Î¸ÏÏÎ¯Î¿Ï",
        marginsFor: "Î ÎµÏÎ¹Î¸ÏÏÎ¹Î± Î³Î¹Î±",
        markupColorants: "Î£Î®Î¼Î±Î½ÏÎ· ÏÏÏÎ¼Î±ÏÎ¹ÏÎºÎ¿Ï",
        sizeOfPackage: "ÎÎ­Î³ÎµÎ¸Î¿Ï ÏÎ±ÎºÎ­ÏÎ¿Ï",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "ÎÎ»Î»Î¬Î¾ÏÎµ ÏÎ· Î¼Î¿Î½Î¬Î´Î± ÏÏÏÏÏÎ¹ÎºÎ®Ï",
        payAttention: "ÎÏÏÏÎµ ÏÏÎ¿ÏÎ¿ÏÎ®!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Î¦Î¯Î»ÏÏÎ¿ Î§ÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
            formulasOverLimit:
                "Î ÎµÏÎ¯ÏÎ¿Ï ÏÎ± %{count} Î±ÏÎ¿ÏÎµÎ»Î­ÏÎ¼Î±ÏÎ±. ÎÎ¿ÎºÎ¹Î¼Î¬ÏÏÎµ Î½Î± ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÎµÏÎµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎ¿ÏÏ ÏÎ±ÏÎ±ÎºÏÎ®ÏÎµÏ.",
            foundFormulas: "%{count} ÏÏÏÎ¿Î¹ Î²ÏÎ­Î¸Î·ÎºÎ±Î½",
            help: "ÎÎ¿Î®Î¸ÎµÎ¹Î±:",
            helpText:
                "Î¤ÏÏÎ¿Ï Ï.Ï. '%{filter}' Î³Î¹Î± Î½Î± Î±Î½Î±Î¶Î·ÏÎ®ÏÎµÏÎµ ÏÏÏÎ¿ÏÏ ÏÎ¿Ï Î±ÏÏÎ¯Î¶Î¿ÏÎ½ Î¼Îµ '%{formula}', ÏÏÎ¿ÏÏÎ½ ÏÎ¿Ï Î¾ÎµÎºÎ¹Î½Î¬ÎµÎ¹ Î¼Îµ '%{product}' ÎºÎ±Î¹ fandeck '%{fandeck}'.",
            productFilter: "Î¦Î¯Î»ÏÏÎ¿ Î ÏÎ¿ÏÏÎ½ÏÎ¿Ï",
            searchInFormulas: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· ÏÎµ ÏÏÎ½ÏÎ±Î³Î­Ï",
            typeMore: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎµÏÎ¹ÏÏÏÏÎµÏÎ¿ÏÏ ÏÎ±ÏÎ±ÎºÏÎ®ÏÎµÏ"
        },
        menu: {
            actionHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÏÏÎ®ÏÎ·Ï",
            additionalFormulaTab: "Î ÏÏÏÎ¸ÎµÏÎ· ÎºÎ±ÏÏÎ­Î»Î± ÏÏÏÏÎ½",
            advancedSettings: "Î ÏÎ¿Î·Î³Î¼Î­Î½ÎµÏ ÏÏÎ¸Î¼Î¯ÏÎµÎ¹Ï",
            autotaskSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î±ÏÏÎ¿Î¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
            availableDatabases: "ÎÎ¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ Î²Î¬ÏÎµÎ¹Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
            availablePrices: "ÎÎ¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÏÎ¹Î¼Î­Ï",
            bugReport: "ÎÎºÎ¸ÎµÏÎ· ÏÏÎ±Î»Î¼Î¬ÏÏÎ½",
            canisterBarcodes: "ÎÏÎ´Î¹ÎºÎ¿Î¹ Barcodes",
            canisterDispensingLogic: "ÎÎ¿Î³Î¹ÎºÎ® Î´Î¹Î±Î½Î¿Î¼Î®Ï",
            canisterFilling: "Canister filling",
            canisterSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
            clientServerSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î ÎµÎ»Î¬ÏÎ·/ÎÎ¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
            closing: "ÎÎ»ÎµÎ¯ÏÎ¹Î¼Î¿",
            color: "Î§ÏÏÎ¼Î±",
            colorModification: "Î¤ÏÎ¿ÏÎ¿ÏÎ¿Î¯Î·ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "ÎÎ½Î±ÏÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï & Î´ÎµÎ´Î¿Î¼Î­Î½Î±",
            colorSearch: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï",
            colorant: "Î§ÏÏÏÏÎ¹ÎºÎ®",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Colorant pricing",
            colorantRefillHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ Î¾Î±Î½Î±Î³ÎµÎ¼Î¯ÏÎ¼Î±ÏÎ¿Ï ÏÏÏÏÏÎ¹ÎºÏÎ½",
            competitiveSearch: "ÎÎ½ÏÎ±Î³ÏÎ½Î¹ÏÏÎ¹ÎºÎ® Î±Î½Î±Î¶Î®ÏÎ·ÏÎ· ÏÏÏÎ¼Î±ÏÎ¿Ï",
            connections: "Î£ÏÎ½Î´Î­ÏÎµÎ¹Ï",
            currency: "Currency",
            customData: "Custom Data",
            database: "ÎÎ¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
            databaseCheck: "ÎÎ»ÎµÎ³ÏÎ¿Ï Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
            databaseConnection: "Database connection",
            defaultValues: "Default Values",
            devices: "ÏÏÏÎºÎµÏÎ­Ï",
            dispensingHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÎÎ¹Î±Î½Î¿Î¼Î®Ï",
            dispensingSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï",
            driverSettings: "Driver settings",
            environment: "ÏÎµÏÎ¹Î²Î¬Î»Î»Î¿Î½",
            environmentConfiguration: "Environment settings",
            environmentalSettings: "Î ÎµÏÎ¹Î²Î±Î»Î»Î¿Î½ÏÎ¹ÎºÎ­Ï ÏÏÎ¸Î¼Î¯ÏÎµÎ¹Ï",
            favorites: "ÎÎ³Î±ÏÎ·Î¼Î­Î½Î±",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "ÎÎµÎ´Î¿Î¼Î­Î½Î±",
            formulaModification: "Formula modification",
            formulaPanels: "Î Î¯Î½Î±ÎºÎµÏ Î£ÏÎ½ÏÎ±Î³ÏÎ½",
            formulaSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
            formulaUnit: "ÎÎ¿Î½Î¬Î´Î± Î¼Î­ÏÏÎ·ÏÎ·Ï Î£ÏÎ½ÏÎ±Î³Î®Ï",
            generalSearch: "ÎÎµÎ½Î¹ÎºÎ® Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "Help settings",
            importAndExport: "ÎÎ¹ÏÎ±Î³ÏÎ³Î® ÎºÎ±Î¹ ÎµÎ¾Î±Î³ÏÎ³Î®",
            importAndExportData: "ÎÎ¹ÏÎ±Î³ÏÎ³Î® ÏÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½ÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
            importCustomData: "ÎÎ¹ÏÎ±Î³ÏÎ³Î® Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
            initialFormulaTab: "ÎÏÏÎ¹ÎºÎ® ÎºÎ±ÏÏÎ­Î»Î± ÏÏÎ½ÏÎ±Î³ÏÎ½",
            interfaceSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎµÏÎ¹ÏÎ¬Î½ÎµÎ¹Î±Ï",
            keyboardShortcuts: "Î£ÏÎ½ÏÎ¿Î¼ÎµÏÏÎµÎ¹Ï ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
            language: "Language Settings",
            languageSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î³Î»ÏÏÏÎ±Ï",
            layout: "Î£ÏÎ­Î´Î¹Î¿",
            license: "ÎÎ´ÎµÎ¹Î±",
            licenseData: "ÎÎµÎ´Î¿Î¼Î­Î½Î± Î¬Î´ÎµÎ¹Î±Ï",
            licenseIdentification: "ÎÎ½Î±Î³Î½ÏÏÎ¹ÏÎ· Î¬Î´ÎµÎ¹Î±Ï",
            licenseStatus: "License status",
            licenseSupplier: "Î ÏÎ¿Î¼Î·Î¸ÎµÏÏÎ®Ï Î¬Î´ÎµÎ¹Î±Ï",
            licenseVersion: "ÎÎºÎ´Î¿ÏÎ· Î¬Î´ÎµÎ¹Î±Ï",
            localData: "Local Data",
            machine: "ÎÎ·ÏÎ±Î½Î® ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
            machineActions: "Machine actions",
            machineAndDevices: "ÎÎ·ÏÎ±Î½Î® & ÏÏÏÎºÎµÏÎ­Ï",
            machineManagement: "ÎÎ¹Î±ÏÎµÎ¯ÏÎ¹ÏÎ· Î¼Î·ÏÎ±Î½ÏÎ½",
            machineSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¼Î·ÏÎ±Î½Î®Ï ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
            mainSettings: "Main Settings",
            maintenance: "Î£ÏÎ½ÏÎ®ÏÎ·ÏÎ·",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Î£ÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ»Î¿Î®Î³Î·ÏÎ·Ï",
            newFormulaWindow: "ÎÎ­Î¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ ÏÏÎ½ÏÎ±Î³Î®Ï",
            orderSearch: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï",
            orderSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±Ï",
            packageSurcharge: "Package Surcharge",
            popUps: "ÎÎ½Î±Î´ÏÏÎ¼ÎµÎ½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ±",
            posInfo: "POS info",
            price: "Price settings",
            priceManagement: "ÎÎ¹Î±ÏÎµÎ¯ÏÎ¹ÏÎ· ÏÎ¹Î¼ÏÎ½",
            priceSettings: "Price settings",
            pricingOptions: "Pricing Options",
            printSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎµÎºÏÏÏÏÏÎ·Ï",
            productPricing: "Product pricing",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "ÎÏÎ®Î³Î¿ÏÎ· ÎÎ¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·",
            rccConfig: "RCC Congiguration",
            rccConnection: "RCC connection",
            rccSettings: "RCC settings",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "ÎÎ³Î³ÏÎ±ÏÎ®",
            searchSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·Ï",
            serverPlugins: "Î ÏÎ¿ÏÎ¸Î®ÎºÎµÏ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
            serviceActions: "ÎÎ½Î­ÏÎ³ÎµÎ¹ÎµÏ ÏÏÎ·ÏÎµÏÎ¹ÏÎ½",
            settings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï",
            simplifiers: "ÎÏÎ»Î¿ÏÎ¿Î¹Î·ÏÎ­Ï",
            singleActions: "ÎÎ½Î¹Î±Î¯ÎµÏ Î´ÏÎ¬ÏÎµÎ¹Ï",
            smartPurgeRules: "Smart purge rules",
            softwareOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï",
            spectroSettings: "Spectro settings",
            statistics: "Statistic",
            switchToFrontdesk: "ÎÎµÏÎ±Î²ÎµÎ¯ÏÎµ ÏÏÎ¿ Frontdesk",
            switchToFullRedlike: "ÎÎµÏÎ±Î²ÎµÎ¯ÏÎµ ÏÏÎ¿ %{name}",
            switchToLight: "ÎÎµÏÎ±Î²ÎµÎ¯ÏÎµ ÏÏÎ¿ %{name}",
            switchToMachine: "ÎÎµÏÎ±Î²ÎµÎ¯ÏÎµ ÏÏÎ· Î¼Î·ÏÎ±Î½Î®",
            tabs: "ÎÎ±ÏÏÎ­Î»ÎµÏ ÎºÎ±Î¹ Î±Î½Î±Î´ÏÏÎ¼ÎµÎ½Î± ÏÎ±ÏÎ¬Î¸ÏÏÎ±",
            testBarcodes: "Test Barcodes",
            updateOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
            userManagemenet: "ÎÎ¹Î±ÏÎµÎ¯ÏÎ¹ÏÎ· ÏÏÎ·ÏÏÏÎ½",
            visibleUnits: "ÎÏÎ±ÏÎ­Ï Î¼Î¿Î½Î¬Î´ÎµÏ"
        },
        navBar: {
            barcode: "barcode",
            help: "ÎÎ¿Î®Î¸ÎµÎ¹Î±",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î½Î­ÎµÏ ÎµÎ¹Î´Î¿ÏÎ¿Î¹Î®ÏÎµÎ¹Ï"
        },
        tabBar: {
            closeActive: "ÎÎ»ÎµÎ¹ÏÎ¹Î¼Ï ÎµÎ½ÎµÏÎ³Î¿Ï",
            closeAll: "ÎÎ»ÎµÎ¯ÏÎ¹Î¼Î¿ ÏÎ»ÏÎ½",
            closeAllExceptActive: "ÎÎ»ÎµÎ¯ÏÎ¹Î¼Î¿ ÏÎ»ÏÎ½ ÎµÎºÏÏÏ ÏÎ¿Ï ÎµÎ½ÎµÏÎ³Î¿Ï",
            customFormula: "Custom Formula",
            dispensingHistory: "ÎÏÏÎ¿ÏÎ¹ÎºÏ ÎÎ¹Î±Î½Î¿Î¼Î®Ï",
            favorites: "ÎÎ³Î±ÏÎ·Î¼Î­Î½Î±",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "ÎÎ½Î±Î¸Î­ÏÏ",
        assignment: "ÎÎÎÎÎÎ£Î",
        createdDate: "Created date",
        finishDispensing: "ÎÎ»Î¿ÎºÎ»Î®ÏÏÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        foundInOrders: "ÎÏÎ­Î¸Î·ÎºÎµ ÏÏÎ¹Ï ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯ÎµÏ",
        inactiveDatabase: "Î ÏÏÎ½ÏÎ±Î³Î® ÎµÎ¯Î½Î±Î¹ Î±ÏÏ Î±Î½ÎµÎ½ÎµÏÎ³Î® Î® Î¬Î³Î½ÏÏÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ %{0}",
        inactiveUnknownDatabase: "Î ÏÏÎ½ÏÎ±Î³Î® ÎµÎ¯Î½Î±Î¹ Î±ÏÏ Î±Î½ÎµÎ½ÎµÏÎ³Î® Î® Î¬Î³Î½ÏÏÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        newOrderReceived: "ÎÏÎµÏÎµ Î»Î¬Î²ÎµÎ¹ Î½Î­Î± ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±!",
        noOrderSelected: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÎºÎ±Î¼Î¯Î± ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¯Î±",
        release: "ÎÎ»ÎµÏÎ¸Î­ÏÏÏÎ·",
        status: {
            accepted: "Î±ÏÎ¿Î´ÎµÎºÏÏ",
            canceled: "Î±ÎºÏÏÏÎ¸Î·ÎºÎµ",
            created: "Î´Î·Î¼Î¹Î¿ÏÏÎ³Î®Î¸Î·ÎºÎµ",
            done: "ÎÎ»Î¿ÎºÎ»Î·ÏÏÎ¸Î·ÎºÎµ",
            partlyDone: "ÎµÎ½ Î¼Î­ÏÎµÎ¹",
            preparing: "ÏÏÎ¿ÎµÏÎ¿Î¹Î¼Î±ÏÎ¯Î±",
            unknown: "Î¬Î³Î½ÏÏÏÎ¿Ï"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "ÎÎ¹ÎµÏÎ¸ÏÎ½ÏÎ·",
        contactName: "ÎÎ½Î¿Î¼Î± ÎµÏÎ±ÏÎ®Ï",
        contactPerson: "Î ÏÏÏÏÏÎ¿ ÎµÏÎ±ÏÎ®Ï",
        identification: "Î¤Î±ÏÏÎ¿ÏÎ¿Î¯Î·ÏÎ·",
        machineInformation: "Î Î»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ¿Ï",
        pos: "Î£Î·Î¼ÎµÎ¯Î¿ ÏÏÎ»Î·ÏÎ·Ï",
        secondAddress: "ÎÎµÏÏÎµÏÎ· Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ·",
        shopIdentification: "ÎÎ½Î±Î³Î½ÏÏÎ¹ÏÎ· ÎºÎ±ÏÎ±ÏÏÎ®Î¼Î±ÏÎ¿Ï",
        shopName: "ÎÎ½Î¿Î¼Î± ÎºÎ±ÏÎ±ÏÏÎ®Î¼Î±ÏÎ¿Ï",
        url: "Url",
        zipCode: "Î¤Î±ÏÏÎ´ÏÎ¿Î¼Î¹ÎºÏÏ ÎºÏÎ´Î¹ÎºÎ±Ï"
    },
    priceTypeList: {
        priceBasePurchase: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÎ· Î²Î¬ÏÎ·",
        priceBaseSell: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± Î²Î¬ÏÎ·",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï",
        priceCntPurchaseByColorantName: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÎ¿ %{0} ÏÏÏÏÏÎ¹ÎºÏ",
        priceCntPurchaseByName: "Î¤Î¹Î¼Î­Ï ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï Î¼Îµ Î²Î¬ÏÎ· ÏÎ¿ ÏÎ½Î¿Î¼Î±",
        priceCntSell: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï",
        priceCntSellByColorantName: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± ÏÎ¿ %{0} ÏÏÏÏÏÎ¹ÎºÏ",
        priceCntSellByName: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï ÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½ Î¼Îµ Î²Î¬ÏÎ· ÏÎ¿ ÏÎ½Î¿Î¼Î±",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "Î ÎµÏÎ¹Î¸ÏÏÎ¹Î¿ Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ±",
        priceMarginPerPkg: "Î ÎµÏÎ¹Î¸ÏÏÎ¹Î¿ Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿",
        priceSellPriceAll: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ±",
        priceSellPricePerKg: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î±Î½Î¬ ÎºÎ¹Î»Ï",
        priceSellPricePerL: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿",
        priceSellPricePerPkg: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿",
        priceSurchargeAll: "Î ÏÏÏÎ¸ÎµÏÎ· ÏÏÎ­ÏÏÎ· Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ±",
        priceSurchargePerPkg: "Î ÏÏÏÎ¸ÎµÏÎ· ÏÏÎ­ÏÏÎ· Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿",
        priceTintPurchaseAll: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±ÏÏÏÏÏÏÎ·Ï Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ±",
        priceTintPurchasePerPkg: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±ÏÏÏÏÏÏÎ·Ï Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ±",
        priceTotalPurchasePerKg: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±Î½Î¬ ÎºÎ¹Î»Ï",
        priceTotalPurchasePerL: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±Î½Î¬ Î»Î¯ÏÏÎ¿",
        priceTotalPurchasePerPkg: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "ÎÎ»ÎµÏ Î¿Î¹ Î²Î¬ÏÎµÎ¹Ï",
        allPackages: "ÎÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ±",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Colorant pricing",
        export: "ÎÎ¾Î±Î³ÏÎ³Î®",
        import: "ÎÎ¹ÏÎ±Î³ÏÎ³Î®",
        packagePricing: "Package pricing",
        packageSurcharge: "Î ÏÎ¿ÏÏÎ¿ÏÎ¬ ÏÎ±ÎºÎ­ÏÎ¿Ï",
        packages: "Î Î±ÎºÎ­ÏÎ±",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Î¤Î¹Î¼Î® Î¿Î¼Î¬Î´Î±Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿",
        priceGroups: "ÎÎ¼Î¬Î´ÎµÏ ÏÎ¹Î¼ÏÎ½",
        pricePerLiter: "Î¤Î¹Î¼Î® Î±Î½Î¬ Î»Î¯ÏÏÎ¿",
        productPricing: "Product pricing",
        purchasePrice: "Î¤Î¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï",
        purchasePricePerLiter: "Î¤Î¹Î¼Î® Î±Î³Î¿ÏÎ¬Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿",
        sellPrice: "Sell price",
        surcharge: "Î ÏÎ¿ÏÎ±ÏÎ¾Î·ÏÎ·"
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "ÎÎ± ÎµÏÎ¹ÏÏÎ­ÏÎµÏÎ±Î¹ Î· Î±ÏÏÏÎ¼Î±ÏÎ· ÎµÎºÏÏÏÏÏÎ·",
        allowPrintAfterDispensing: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ· Î¼ÎµÏÎ¬ ÏÎ·Î½ Î´Î¹Î±Î½Î¿Î¼Î®",
        allowPrintBeforeDispensing: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ·Î½ ÎµÎºÏÏÏÏÏÎ· ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        automaticPrint: "ÎÎºÏÏÏÏÏÎ· Î±ÏÏÏÎ¼Î±ÏÎ±",
        choosePrinter: "Choose printer",
        chooseSettings: "Edit Settings",
        chooseTemplate: "Choose template",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "ÎÎºÏÏÏÏÏÎ®Ï",
        defaultSettings: "Default settings",
        defaultTemplate: "Î ÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÏÏÏÏÎ¿",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÎµÎºÏÏÏÏÏÎ®Ï",
        noPrintersAvailable: "ÎÎµÎ½ Î´Î¹Î±ÏÎ¯Î¸ÎµÎ½ÏÎ±Î¹ ÎµÎºÏÏÏÏÏÎ­Ï",
        noTemplateSelected: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÏÏÏÏÏÎ¿",
        noTemplatesAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î± ÏÏÏÏÏÏÎ±",
        numberOfCopies: "ÎÏÎ¹Î¸Î¼ÏÏ Î±Î½ÏÎ¯Î³ÏÎ±ÏÏÎ½",
        openTemplateEditor: "ÎÎ½Î¿Î¯Î¾ÏÎµ ÏÎ¿Î½ ÎµÏÎµÎ¾ÎµÏÎ³Î±ÏÏÎ® ÏÏÎ¿ÏÏÏÏÎ½",
        printAfterDispensing: "ÎÎºÏÏÏÏÏÎ· Î¼ÎµÏÎ¬ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        printAsImage: "ÎÎºÏÏÏÏÏÎ· ÏÏ ÎµÎ¹ÎºÏÎ½Î±",
        printBeforeDispensing: "ÎÎºÏÏÏÏÏÎ· ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        printOnRequest: "ÎÎºÏÏÏÏÏÎ· ÎºÎ±ÏÏÏÎ¹Î½ Î±Î¹ÏÎ®Î¼Î±ÏÎ¿Ï",
        printOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï ÎµÎºÏÏÏÏÏÎ·Ï",
        printPagesAfterDispensing: "ÎÏÎ¹Î¸Î¼ÏÏ Î±Î½ÏÎ¹Î³ÏÎ¬ÏÏÎ½ Î¼ÎµÏÎ¬ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® ÏÎ¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        printPagesBeforeDispensing: "ÎÏÎ¹Î¸Î¼ÏÏ Î±Î½ÏÎ¹Î³ÏÎ¬ÏÏÎ½ ÏÏÎ¹Î½ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î® ÏÎ¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        printPreview: "Î ÏÎ¿ÎµÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÎµÎºÏÏÏÏÏÎ·Ï",
        printSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÎµÎºÏÏÏÏÏÎ·Ï",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "ÎÎ½Î¿Î¼Î± ÎµÎºÏÏÏÏÏÎ®",
        printerOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï ÎµÎºÏÏÏÏÏÎ®",
        printerSettings: "Printer Options",
        quickTintTemplate: "Î ÏÏÏÏÏÎ¿ Î³ÏÎ®Î³Î¿ÏÎ·Ï Î±ÏÏÏÏÏÏÎ·Ï",
        setDefaultPrinter: "ÎÏÎ¹ÏÎ¼ÏÏ ÏÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿Ï ÎµÎºÏÏÏÏÏÎ®",
        setDefaultTemplate: "ÎÏÎ¯ÏÏÎµ ÏÏÎ¿ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿ ÏÏÏÏÏÏÎ¿",
        setQuickTintTemplate: "ÎÏÎ¯ÏÏÎµ ÏÏÏÏÏÏÎ¿ Î³ÏÎ®Î³Î¿ÏÎ·Ï Î±ÏÏÏÏÏÏÎ·Ï",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "Î ÏÏÏÏÏÎ¿",
        templateName: "ÎÎ½Î¿Î¼Î± ÏÏÎ¿ÏÏÏÎ¿Ï",
        templateSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÏÎ¿ÏÏÏÎ¿Ï"
    },
    printTemplate: {
        baseCode: "ÎÎ±ÏÎ¹ÎºÏÏ ÎºÏÎ´Î¹ÎºÏÏ",
        baseName: "ÎÎ½Î¿Î¼Î± Î²Î¬ÏÎ·Ï",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Î ÏÏÎ»Î· ÏÏÎ½ ÏÎµÎ»Î±ÏÏÎ½",
        customerEmail: "ÎÎ»ÎµÎºÏÏÎ¿Î½Î¹ÎºÏ ÏÎ±ÏÏÎ´ÏÎ¿Î¼ÎµÎ¯Î¿ ÏÎµÎ»Î±ÏÏÎ½",
        customerName: "ÎÎ½Î¿Î¼Î± ÏÎµÎ»Î¬ÏÎ·",
        customerPhone: "Î¤Î·Î»Î­ÏÏÎ½Î¿ ÏÎµÎ»Î±ÏÏÎ½",
        customerStreet: "ÎÎ´ÏÏ ÏÎµÎ»Î±ÏÏÎ½",
        customerZipCode: "Î¤Î±ÏÏÎ´ÏÎ¿Î¼Î¹ÎºÏÏ ÎºÏÎ´Î¹ÎºÎ±Ï ÏÎµÎ»Î¬ÏÎ·",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "ÎÎ±Î¸Î¼ÏÏ BFS",
        orderQrCode: "ÎÏÎ´Î¹ÎºÏÏ QR",
        packageOrderCount: "Package order count",
        posAddress: "ÎÎ¹ÎµÏÎ¸ÏÎ½ÏÎ· POS",
        posAddressSecond: "ÎÎ¹ÎµÏÎ¸ÏÎ½ÏÎ· POS 2",
        posCity: "Î ÏÎ»Î· POS",
        posContact: "ÎÏÎ±ÏÎ® POS",
        posEmail: "ÎÎ»ÎµÎºÏÏÎ¿Î½Î¹ÎºÎ® Î´Î¹ÎµÏÎ¸ÏÎ½ÏÎ· POS",
        posPhone: "Î¤Î·Î»Î­ÏÏÎ½Î¿ POS",
        posUrl: "ÎÎ¹ÎµÏÎ¸ÏÎ½ÏÎ· URL POS",
        posZipCode: "Î¤ÏÎ±ÏÏÎ´ÏÎ¿Î¼Î¹ÎºÏÏ ÎºÏÎ´Î¹ÎºÎ±Ï POS",
        priceBasePurchaseWithTax: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± Î²Î¬ÏÎ· Î¼Îµ Î¦Î Î",
        priceBaseSellWithTax: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± Î²Î¬ÏÎ· Î¼Îµ Î¦Î Î",
        priceCntPurchaseWithTax: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï Î¼Îµ Î¦Î Î",
        priceCntTotalSellWithTax: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± ÏÏÏÏÏÎ¹ÎºÎ­Ï Î¼Îµ Î¦Î Î",
        priceMarginAllWithTax: "Î ÎµÏÎ¹Î¸ÏÏÎ¹Î¿ Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ Î¼Îµ Î¦Î Î",
        priceMarginPerPkgWithTax: "Î ÎµÏÎ¹Î¸ÏÏÎ¹Î¿ Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ Î¼Îµ Î¦Î Î",
        priceSellPriceAllWithTax: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ Î¼Îµ Î¦Î Î",
        priceSellPricePerKgWithTax: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î±Î½Î¬ ÎºÎ¹Î»Ï Î¼Îµ Î¦Î Î",
        priceSellPricePerLWithTax: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î±Î½Î¬ Î»Î¯ÏÏÎ¿ Î¼Îµ Î¦Î Î",
        priceSellPricePerPkgWithTax: "Î¤Î¹Î¼Î® ÏÏÎ»Î·ÏÎ·Ï Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ Î¼Îµ Î¦Î Î",
        priceSurchargeAllWithTax: "Î ÏÏÏÎ¸ÎµÏÎ· ÏÏÎ­ÏÏÎ· Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ Î¼Îµ Î¦Î Î",
        priceSurchargePerPkgWithTax: "Î ÏÏÏÎ¸ÎµÏÎ· ÏÏÎ­ÏÏÎ· Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ Î¼Îµ Î¦Î Î",
        priceTintPurchaseAllWithTax: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±ÏÏÏÏÏÏÎ·Ï Î³Î¹Î± ÏÎ»Î± ÏÎ± ÏÎ±ÎºÎ­ÏÎ± Î¼Îµ Î¦.Î .Î.",
        priceTintPurchasePerPkgWithTax: "Î¤Î¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±ÏÏÏÏÏÏÎ·Ï Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ Î¼Îµ Î¦Î Î",
        priceTotalPurchaseAllWithTax: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± ÏÎ»ÎµÏ ÏÎ¹Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ Î¼Îµ Î¦Î Î",
        priceTotalPurchasePerKgWithTax: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±Î½Î¬ ÎºÎ¹Î»Ï Î¼Îµ Î¦Î Î",
        priceTotalPurchasePerLWithTax: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î±Î½Î¬ Î»Î¯ÏÏÎ¿ Î¼Îµ Î¦Î Î",
        priceTotalPurchasePerPkgWithTax: "Î£ÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¹Î¼Î® ÎºÏÏÏÎ¿ÏÏ Î³Î¹Î± Î­Î½Î± ÏÎ±ÎºÎ­ÏÎ¿ Î¼Îµ Î¦Î Î",
        productAltName: "Î ÏÎ¿ÏÏÎ½",
        recipeInline: "Î£ÏÎ½ÏÎ±Î³Î®"
    },
    products: {
        bases: "ÎÎ¬ÏÎµÎ¹Ï",
        numberOfProducts: "ÎÏÎ¹Î¸Î¼ÏÏ Î ÏÎ¿ÏÏÎ½ÏÏÎ½",
        packagesFor: "Î£ÏÏÎºÎµÏÎ±ÏÎ¯ÎµÏ Î³Î¹Î±",
        sizeOfPackage: "ÎÎ­Î³ÎµÎ¸Î¿Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï"
    },
    purgeModal: {
        purgeAll: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÏÎ»ÏÎ½",
        purgeAllChannels: "ÎÎºÎºÎ±Î¸Î¬ÏÎ¹ÏÎ· ÏÎ»ÏÎ½ ÏÏÎ½ ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
        purgeVolume: "ÎÎ³ÎºÎ¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï",
        startPurge: "ÎÎ½Î±ÏÎ¾Î· ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "ÎÎ¹Î±Î½Î¿Î¼Î® ÏÎµ ÎµÎ¾Î­Î»Î¹Î¾Î·",
        dispensingIsNotAvailable: "Î Î´Î¹Î±Î½Î¿Î¼Î® Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î·",
        machineNotConnected: "Î¤Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿",
        noColorantsSelected: "ÎÎµÎ½ Î­ÏÎ¿ÏÎ½ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÏÏÏÏÎ¹ÎºÎ­Ï",
        noPrinterAvailable: "ÎÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´ÏÎ½Î±ÏÎ® Î· ÎµÎºÏÏÏÏÏÎ· ÎºÎ±Î¸ÏÏ Î´ÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿Ï ÎµÎºÏÏÏÏÏÎ®Ï.",
        noTemplateAvailable: "ÎÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´ÏÎ½Î±ÏÎ® Î· ÎµÎºÏÏÏÏÏÎ· ÎºÎ±Î¸ÏÏ Î´ÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿ ÏÏÏÏÏÏÎ¿.",
        overMaxCanisterSize: "One or more colorant amounts are over their maximum"
    },
    quickTintSettings: {
        alphabetically: "ÎÎ»ÏÎ±Î²Î·ÏÎ¹ÎºÎ¬",
        byCanister: "ÎÎµ ÎºÎ¬Î½Î¹ÏÏÏÎ¿",
        closeAfterDispensing: "ÎÎ»ÎµÎ¯ÏÏÎµ Î¼ÎµÏÎ¬ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        closeBeforeDispensing: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        quickTintSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÎ±ÏÎµÎ¯Î±Ï Î±ÏÏÏÏÏÏÎ·Ï",
        sorting: "Î¤Î±Î¾Î¹Î½ÏÎ¼Î·ÏÎ·",
        windowClosingRules: "ÎÎ±Î½ÏÎ½ÎµÏ ÎºÎ»ÎµÎ¹ÏÎ¯Î¼Î±ÏÎ¿Ï ÏÎ±ÏÎ±Î¸ÏÏÏÎ½"
    },
    rccButtons: {
        abort: "ÎÎ±ÏÎ±Î¯ÏÏÎ·",
        all: "ÏÎ»Î±",
        cancel: "Î±ÎºÏÏÏÏÎ·",
        continue: "Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÎ¹",
        help: "Î²Î¿Î®Î¸ÎµÎ¹Î±",
        ignore: "Î±Î³Î½ÏÎ·ÏÎµ",
        no: "ÏÏÎ¹",
        noToAll: "ÏÏÎ¹ ÏÎµ ÏÎ»Î±",
        ok: "ÎÎ½ÏÎ¬Î¾ÎµÎ¹",
        postpone: "Î±Î½Î±Î²Î¬Î»Î»Ï",
        resume: "Î ÎµÏÎ¯Î»Î·ÏÎ·",
        retry: "ÏÏÎ¿ÏÏÎ±Î¸Î·ÏÎµ Î¾Î±Î½Î±",
        skip: "ÏÎ±ÏÎ±Î»ÎµÎ¯ÏÎµ",
        yes: "ÎÎ±Î¯",
        yesToAll: "ÎÎ±Î¹ ÏÎµ ÏÎ»Î±"
    },
    rccDialog: {
        98: "Please Verify the %{0} Base with the Barcode.",
        99: "Please Insert Base %{0} and Confirm (Click OK)",
        100: "Î¤Î¿ Î¼Î·Î½Î¬Î½Î·Î¼Î± Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï, ÎµÏÎ±Î½Î±ÏÎ­ÏÎµÏÎµ ÏÏÎ¬Î»Î¼Î±ÏÎ±",
        101: "Î¤Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï, Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ½ÎµÏÎ¹ÏÏÎµÎ¯",
        102: "Î ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬ Î±ÏÎ­ÏÏÏÎµ, Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ½ÎµÏÎ¹ÏÏÎµÎ¯",
        103: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± ÏÎµÏÎ¹Î­ÏÎµÎ¹ Î¼Î· Î­Î³ÎºÏÏÎ· ÏÏÏÎ¼Î±ÏÎ¹ÎºÎ®: %{0}",
        104: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± ÏÎµÏÎ¹Î­ÏÎµÎ¹ Î¼Î· Î­Î³ÎºÏÏÎµÏ ÏÏÏÏÏÎ¹ÎºÎ­Ï: %{0}",
        105: "Î¤Î¿ ÏÏÏÏÏÎ¹ÎºÏ: %{0} Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎµÏÎ¯ÏÎµÎ´Î¿ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·Ï",
        106: "ÎÎ¹ ÏÏÏÏÏÎ¹ÎºÎ­Ï: %{0} Î²ÏÎ¯ÏÎºÎ¿Î½ÏÎ±Î¹ ÏÎµ ÎµÏÎ¯ÏÎµÎ´Î¿ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·Ï",
        107: "Î¤Î¿ ÏÏÏÏÏÎ¹ÎºÏ: %{0} Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÎºÎ¬ÏÏ Î±ÏÏ ÏÎ¿ ÎºÏÎ¯ÏÎ¹Î¼Î¿ ÎµÏÎ¯ÏÎµÎ´Î¿",
        108: "ÎÎ¹ ÏÏÏÏÏÎ¹ÎºÎ­Ï: %{0} Î²ÏÎ¯ÏÎºÎ¿Î½ÏÎ±Î¹ ÎºÎ¬ÏÏ Î±ÏÏ ÎºÏÎ¯ÏÎ¹Î¼Î¿ ÎµÏÎ¯ÏÎµÎ´Î¿",
        109: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿",
        110: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï: %{0} Î³Î¹Î± ÏÎ¿Î½ ÏÏÏÎ¿: %{1}",
        111: "ÎÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿",
        112: "Î¤ÏÏÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿",
        113: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ½ ÏÏÎ±Î»Î¼Î¬ÏÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        114: "ÎÎµÏÎ±ÎºÎ¹Î½Î®ÏÏÎµ ÏÎ¿ ÏÎ¬ÏÎ¹, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        115: "ÎÎ¹Î¬ÏÏÎ·ÏÎ· Î´Î¿ÏÎµÎ¯Î¿Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        116: "Î£ÏÎ½ÏÎ±Î³Î® Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·Ï %{0}, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ|Î Î±ÎºÎ­ÏÎ¿: %{1} Î±ÏÏ %{2} | Î ÏÎ¿ÏÏÎ½: %{3} | ÎÎ¬ÏÎ·: %{4}|ÎÎ­Î³ÎµÎ¸Î¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï: %{5}",
        117: "Î£ÏÎ½ÏÎ±Î³Î® Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·Ï %{0}, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ|Î Î±ÎºÎ­ÏÎ¿: %{1} Î±ÏÏ %{2} | Î ÏÎ¿ÏÏÎ½: %{3} | ÎÎ¬ÏÎ·: %{4}|ÎÎ­Î³ÎµÎ¸Î¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï: %{5}",
        118: "ÎÎ¹Î±Î½Î¿Î¼Î®, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ | Î Î±ÎºÎ­ÏÎ¿: %{0} Î±ÏÏ %{1}",
        119: "ÎÎ¹Î±Î½Î¿Î¼Î®, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ | Î Î±ÎºÎ­ÏÎ¿: %{0} Î±ÏÏ %{1}",
        120: "Cancelling dispense, please wait",
        121: "ÎÏÎ¹ÎºÏÏÏÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î¼Îµ barcode",
        122: "ÎÏÎ¹ÎºÏÏÏÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï| Î ÏÎ¿ÏÏÎ½: %{0} | ÎÎ¬ÏÎ·: %{1} | ÎÎ­Î³ÎµÎ¸Î¿Ï Î¼ÎµÎ³Î­Î¸Î¿ÏÏ: %{2}",
        123: "Î Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± Î´Î¹Î±Î½Î¿Î¼Î®Ï Î­ÏÎµÎ¹ Î´Î¹Î±ÎºÎ¿ÏÎµÎ¯, Î¸Î­Î»ÎµÏÎµ Î½Î± ÎµÏÎ±Î½Î±Î»Î¬Î²ÎµÏÎµ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        124: "Dispenser error occoured %{0} : %{1}. Do you want to resume dispensing?",
        125: "ÎÎµÎ²Î±Î¹ÏÎ¸ÎµÎ¯ÏÎµ ÏÏÎ¹ Î­ÏÎµÎ¹ ÏÎ¿ÏÎ¿Î¸ÎµÏÎ·Î¸ÎµÎ¯ ÏÎ¿ ÏÏÎ¿Î·Î³Î¿ÏÎ¼Î­Î½ÏÏ ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î·Î¼Î­Î½Î¿ Î´Î¿ÏÎµÎ¯Î¿",
        126: "ÎÎµÎ²Î±Î¹ÏÎ¸ÎµÎ¯ÏÎµ ÏÏÎ¹ ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎµ Î½Î­Î¿ Î´Î¿ÏÎµÎ¯Î¿ ÎºÎ±Î¸ÏÏ Î· Î´Î¹Î±Î´Î¹ÎºÎ±ÏÎ¯Î± Î´Î¹Î±Î½Î¿Î¼Î®Ï Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î±ÏÏ ÏÎ·Î½ Î±ÏÏÎ®",
        127: "Î§ÏÏÏÏÎ¹ÎºÎ®: %{0} ÎµÎ¯Î½Î±Î¹ ÎºÎ¬ÏÏ Î±ÏÏ ÏÎ¿ ÎµÎ»Î¬ÏÎ¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î®Ï. ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ ÏÎ±ÏÎ¬ Î±ÏÏÎ®Î½ ÏÎ·Î½ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·",
        128: "Î§ÏÏÏÏÎ¹ÎºÎ­Ï: %{0} ÎµÎ¯Î½Î±Î¹ ÎºÎ¬ÏÏ Î±ÏÏ ÏÎ¿ ÎµÎ»Î¬ÏÎ¹ÏÏÎ· ÏÎ¿ÏÏÏÎ·ÏÎ± Î´Î¹Î±Î½Î¿Î¼Î®Ï. ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ ÏÎ±ÏÎ¬ Î±ÏÏÎ®Î½ ÏÎ·Î½ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·",
        129: "Selected formula brokes the overfill rule, total amount of colorans: %{0} %{1}, maximum allowed amounts of colorants: %{2} %{3}. Do you want to continue despite this warning?",
        130: "Î¤Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï, ÎµÏÎ±Î½Î±ÏÎ­ÏÎµÏÎµ ÏÏÎ¬Î»Î¼Î±ÏÎ±",
        131: "Î¤Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎºÎ±ÏÎ¬ÏÏÎ±ÏÎ· ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï, Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ½ÎµÏÎ¹ÏÏÎµÎ¯",
        132: "Î ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬ Î±ÏÎ­ÏÏÏÎµ, Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ½ÎµÏÎ¹ÏÏÎµÎ¯",
        133: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÎµÎ¯Î½Î±Î¹ ÎºÎµÎ½Î®, Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÎ½ÎµÏÎ¹ÏÏÎµÎ¯",
        134: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÏÎµÏÎ¹Î­ÏÎµÎ¹ ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ¿Ï Î´ÎµÎ½ Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÏÎ¿ÏÎ½, Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ",
        135: "Place canister for purge",
        136: "Remove canister for purge",
        137: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ½ ÏÏÎ±Î»Î¼Î¬ÏÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        138: "ÎÎµÏÎ±ÎºÎ¹Î½Î®ÏÏÎµ ÏÎ¿ ÏÎ¬ÏÎ¹, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        139: "ÎÎ±Î¸Î±ÏÎ¯ÏÏÎµ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        140: "ÎÎ±Î¸Î±ÏÎ¯ÏÏÎµ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        141: "Cancelling purge, please wait",
        142: "Î¤Î¿ Î´Î¿ÏÎµÎ¯Î¿ ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï Î»ÎµÎ¯ÏÎµÎ¹, ÎµÎ»Î­Î³Î¾ÏÎµ ÏÏÎ¹ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ ÏÎ¿ÏÎ¿Î¸ÎµÏÎµÎ¯Î¸Î·ÎºÎµ ÏÏÏÏÎ¬",
        143: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï ÏÎµÏÎ¹Î­ÏÎµÎ¹ ÏÏÎ¿Î¹ÏÎµÎ¯Î± ÏÎ¿Ï Î´ÎµÎ½ Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÏÎ¿ÏÎ½, Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ",
        144: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î³Î¹Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Ï",
        145: "Î ÏÎ¿ÎµÏÎ¿Î¹Î¼Î±ÏÎ¯Î±, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        146: "Î¤ÎµÎ»ÎµÎ¹ÏÎ½Î¿Î½ÏÎ±Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        150: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        151: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        152: "Cancelling clean, please wait",
        160: "ÎÎ½Î±ÎºÏÎºÎ»ÏÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        161: "ÎÎ½Î±ÎºÏÎºÎ»ÏÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        162: "Cancelling recirculation, please wait",
        170: "ÎÎ½Î¬Î´ÎµÏÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        171: "ÎÎ½Î¬Î´ÎµÏÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        172: "Cancelling stir, please wait",
        180: "ÎÏÏÎ¹ÎºÎ¿ÏÎ¿Î¹ÏÎ½ÏÎ±Ï ÏÎ· ÏÏÎ½Î´ÎµÏÎ· Î¼Îµ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î±, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        181: "Î ÏÏÎ½Î´ÎµÏÎ· Î¼Îµ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÎµÏÎ¹ÏÎµÏÏÎ¸ÎµÎ¯ %{0}:%{1}",
        182: "Î ÏÏÎ½Î´ÎµÏÎ· Î¼Îµ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÎµÏÎ¹ÏÎµÏÏÎ¸ÎµÎ¯. ÎÎµÎ¯ÏÎµ ÏÎ± Î±ÏÏÎµÎ¯Î± ÎºÎ±ÏÎ±Î³ÏÎ±ÏÎ®Ï Î³Î¹Î± ÏÎµÏÎ¹ÏÏÏÏÎµÏÎµÏ ÏÎ»Î·ÏÎ¿ÏÎ¿ÏÎ¯ÎµÏ",
        183: "ÎÎµÎ¯ÏÎµÎ¹ Î· ÏÏÏÏÏÎ¹ÎºÎ® ÏÏÎ¿ Dispenser: %{0} ÏÎ¿Ï Î¿ÏÎ¯Î¶ÎµÏÎ±Î¹ ÏÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ±Ï",
        184: "ÎÎµÎ¯ÏÎ¿ÏÎ½ ÏÏÏÏÏÎ¹ÎºÎ­Ï ÏÏÎ¿ Dispenser: %{0} ÏÎ¿Ï Î¿ÏÎ¯Î¶Î¿Î½ÏÎ±Î¹ ÏÏÎ· Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ±Ï",
        185: "ÎÎ»ÎµÎ¯ÏÎ¹Î¼Î¿ ÏÏÎ½Î´ÎµÏÎ·Ï Î¼Îµ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î±, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        190: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÎ¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ ÏÏÎ·ÏÎµÏÎ¯Î±Ï Î³Î¹Î± Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ",
        200: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        201: "Î£ÎºÎ»Î·ÏÎ® ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        202: "ÎÏÏÎ¹ÎºÎ¿ÏÎ¿Î¯Î·ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        203: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ½ ÏÏÎ±Î»Î¼Î¬ÏÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        205: "ÎÎ½Î¿Î¹Î³Î¼Î± autocap, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        206: "KÎ»ÎµÎ¯ÏÎ¹Î¼Î¿ autocap, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        207: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï autocap, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        210: "ÎÎ¹Î¬ÏÏÎ·ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        211: "Î£ÏÎ½Î´Î­ÏÏÎµ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        215: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÎ¬ÏÎ¹Î¿Ï ÎµÏÎ¬Î½Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        216: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÎ¿ ÏÎ¬ÏÎ¹ ÏÏÎ¿Ï ÏÎ± ÎºÎ¬ÏÏ, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        217: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÎ¬ÏÎ¹Î¿Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        220: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· ÏÏÎ±ÏÎµÎ¶Î¹Î¿Ï ÏÎµ Î¸Î­ÏÎ· ÎµÏÎ±Î½Î±ÏÎ»Î®ÏÏÏÎ·Ï: %{0}, ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        221: "ÎÎµÏÎ±ÎºÎ¹Î½Î®ÏÏÎµ ÏÎ¿ ÏÏÎ±ÏÎ­Î¶Î¹ ÏÏÎ·Î½ Î±ÏÏÎ¹ÎºÎ® Î¸Î­ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        222: "ÎÎ¹Î½Î¿ÏÎ¼ÎµÎ½Î¿ ÏÏÎ±ÏÎ­Î¶Î¹, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        230: "Î¤Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÏÎ¿Î»Î·Î¼Î­Î½Î¿, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        240: "Refill canister %{0}",
        241: "Please refill canister %{0}",
        242: "Î¤Î¿ÏÎ¿Î¸Î­ÏÎ·ÏÎ· ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï: %{0} (%{1}) Î³Î¹Î± Î½Î± Î¾Î±Î½Î±Î³ÎµÎ¼Î¯ÏÎµÏÎµ ÏÎ· Î¸Î­ÏÎ·",
        243: "Î£ÏÎ¼ÏÎ»Î·ÏÏÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ %{0} ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÏÎ½ÏÎ±Ï Î³ÏÎ±Î¼Î¼ÏÏÏ ÎºÏÎ´Î¹ÎºÎ±",
        244: "Î£ÏÎ¼ÏÎ»Î·ÏÏÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ %{0} ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÏÎ½ÏÎ±Ï Î³ÏÎ±Î¼Î¼ÏÏÏ ÎºÏÎ´Î¹ÎºÎ±",
        250: "ÎÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ ÏÎ·Ï Î²Î¿ÏÏÏÏÎ±Ï, ÎºÎ±Î¸Î±ÏÎ¯ÏÏÎµ ÏÎ¿ ÎºÎ±Î¹ Î³ÎµÎ¼Î¯ÏÏÎµ ÏÎ¿ Î¼Îµ Î½ÎµÏÏ ÏÏÎ¼ÏÏÎ½Î± Î¼Îµ ÏÎ¹Ï Î¿Î´Î·Î³Î¯ÎµÏ",
        251: "Put back brush conainer",
        254: "ÎÎ½Î¿Î¹Î³Î¼Î± autocap",
        255: "ÎÎ±Î¸Î±ÏÎ¯ÏÏÎµ ÏÎ¿ autocap ÏÏÎ¼ÏÏÎ½Î± Î¼Îµ ÏÎ¹Ï Î¿Î´Î·Î³Î¯ÎµÏ",
        256: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÏÎ¹ Î¿ ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ Î­ÏÎµÎ¹ ÏÎµÎ»ÎµÎ¹ÏÏÎµÎ¹ ÎºÎ±Î¹ ÏÎ¿ autocap ÎµÏÎ¹ÏÏÏÎ­ÏÎµÎ¹ ÏÏÎ· Î¸Î­ÏÎ· ÏÎ¿Ï",
        257: "ÎÎ»ÎµÎ¯ÏÎ¹Î¼Î¿ autocap",
        260: "ÎÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ·Î½ ÏÎ»Î¬ÎºÎ± Î´Î¹Î±ÎºÏÏÏÎ· ÎºÎ±Î¹ ÎºÎ±Î¸Î±ÏÎ¯ÏÏÎµ ÏÎ·Î½",
        261: "ÎÎ¬Î»ÏÎµ ÏÎ¯ÏÏ ÏÎ·Î½ ÏÎ»Î¬ÎºÎ± ÏÎ¿Ï Î´Î¹Î±ÎºÏÏÏÎ·",
        265: "ÎÎ±Î¸Î±ÏÎ¯ÏÏÎµ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î¼Îµ Î­Î½Î± ÏÎ±Î½Î¯ ÎºÎ±Î¹ Î±ÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ»Î± ÏÎ± ÏÏÎ¼Î­Î½Î± ÏÏÏÏÏÎ¹ÎºÎ¬ Î® Î¬Î»Î»Î± ÏÎ³ÏÎ¬",
        266: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÏÏÎµ Î¿Î»Î¿ÎºÎ»Î·ÏÏÎ¸Î·ÎºÎµ",
        270: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î½ÎµÏÎ¿Ï ÏÎ¿Ï ÏÎ³ÏÎ±Î½ÏÎ®ÏÎ± ÎºÎ±Î¹ ÎµÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÎ¿ ÏÏÎ±Î½ ÏÎ¿ ÎºÎ¬Î½ÎµÏÎµ",
        271: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î½ÎµÏÎ¿Ï ÏÎ¿Ï ÏÎ³ÏÎ±Î½ÏÎ®ÏÎ± ÎºÎ±Î¹ ÎµÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÎ¿ ÏÏÎ±Î½ ÏÎ¿ ÎºÎ¬Î½ÎµÏÎµ",
        272: "Î ÏÏÎ¬Î¸Î¼Î· ÏÎ¿Ï Î½ÎµÏÎ¿Ï ÎµÎ¯Î½Î±Î¹ Î±ÎºÏÎ¼Î± ÏÎ±Î¼Î·Î»Î®, ÎµÎ»Î­Î³Î¾ÏÎµ Î¾Î±Î½Î¬",
        273: "Î ÏÏÎ¬Î¸Î¼Î· ÏÎ¿Ï Î½ÎµÏÎ¿Ï ÎµÎ¯Î½Î±Î¹ Î±ÎºÏÎ¼Î± ÏÎ±Î¼Î·Î»Î®, ÎµÎ»Î­Î³Î¾ÏÎµ Î¾Î±Î½Î¬",
        274: "Check the water level in humidifier container",
        275: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        280: "ÎÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        281: "Î¤ÎµÏÎ¼Î±ÏÎ¹ÏÎ¼ÏÏ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        300: "Base can missing, check that the can is properly placed",
        301: "Î ÏÎ¿ÎµÏÎ¿Î¹Î¼Î±ÏÎ¯Î±, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        302: "Î¤ÎµÎ»ÎµÎ¹ÏÎ½Î¿Î½ÏÎ±Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        303: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÏÎ¼Î±ÏÎ¹ÏÏÎµÎ¯, ÎºÎ±Î¸ÏÏ ÏÎµÏÎ¹Î­ÏÎµÎ¹ ÏÏÏÏÏÎ¹ÎºÎ®: %{0} Î· Î¿ÏÎ¿Î¯Î± ÎµÎ¯Î½Î±Î¹ ÏÎ¬Î½Ï Î±ÏÏ ÏÎ¿ Î¼Î­Î³Î¹ÏÏÎ¿ ÏÎ¿ÏÏ Î´Î¹Î±Î½Î¿Î¼Î®Ï ÏÎ¿Ï Î¿ÏÎ¯Î¶ÎµÏÎ±Î¹ Î³Î¹Î± ÏÎ¿ ÎºÎ¬Î½Î¹ÏÏÏÎ¿",
        304: "Î ÏÏÏÎ¼Î¿ÏÎ»Î± Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± ÏÏÏÎ¼Î±ÏÏÎµÎ¯, ÎºÎ±Î¸ÏÏ ÏÎµÏÎ¹Î­ÏÎµÎ¹ ÏÏÏÏÏÎ¹ÎºÎ­Ï: %{0} Î¿Î¹ Î¿ÏÎ¿Î¯ÎµÏ ÎµÎ¯Î½Î±Î¹ ÏÎ¬Î½Ï Î±ÏÏ ÏÎ± Î¼Î­Î³Î¹ÏÏÎ± ÏÎ¿ÏÎ¬ Î´Î¹Î±Î½Î¿Î¼Î®Ï ÏÎ¿Ï Î¿ÏÎ¯Î¶Î¿Î½ÏÎ±Î¹ Î³Î¹Î± ÏÎ± ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        305: "Î§ÏÏÏÏÎ¹ÎºÎ®: %{0} Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯ ÏÎ±ÏÏÏÏÏÎ¿Î½Î±, Î¸Î­Î»ÎµÏÎµ Î½Î± Î´Î¹Î±Î¹ÏÎ­ÏÎµÏÎµ ÏÎ¿Î½ ÏÏÏÎ¿",
        306: "Î§ÏÏÏÏÎ¹ÎºÎ­Ï: %{0} Î´ÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯ ÏÎ±ÏÏÏÏÏÎ¿Î½Î±, Î¸Î­Î»ÎµÏÎµ Î½Î± Î´Î¹Î±Î¹ÏÎ­ÏÎµÏÎµ ÏÎ¿Î½ ÏÏÏÎ¿",
        307: "Î§ÏÏÏÏÎ¹ÎºÎ®: %{0} Î´ÎµÎ½ Î¸Î± Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯ Î±ÏÏ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î±, Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ ÎºÎ±Î¹ Î½Î± ÏÎ¿ ÏÏÎ¿ÏÎ¸Î­ÏÎµÏÎµ Î¼Îµ ÏÎ¿ ÏÎ­ÏÎ¹",
        308: "Î§ÏÏÏÏÎ¹ÎºÎ­Ï: %{0} Î´ÎµÎ½ Î¸Î± Î´Î¹Î±Î½Î­Î¼Î¿Î½ÏÎ±Î¹ Î±ÏÏ ÏÎ¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î±, Î¸Î­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ ÎºÎ±Î¹ Î½Î± ÏÎ± ÏÏÎ¿ÏÎ¸Î­ÏÎµÏÎµ Î¼Îµ ÏÎ¿ ÏÎ­ÏÎ¹",
        309: "Î ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· ÏÏÏÎ¼Î¿ÏÎ»Î± ÎµÎ¯Î½Î±Î¹ ÎºÎµÎ½Î®, ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï ÏÏÏÏ ÎµÎ¯Î½Î±Î¹",
        310: "ÎÎµÎ½ Î¼ÏÎ¿ÏÎµÎ¯ Î½Î± Î´Î¹Î±Î½ÎµÎ¼Î·Î¸ÎµÎ¯ ÎºÎ±Î½Î­Î½Î± Î´Î¿ÏÎµÎ¯Î¿ ÏÏÏÏÏÎ¹ÎºÎ®Ï, ÏÏÎ¿ÎµÏÎ¿Î¹Î¼Î¬ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï Î³Î¹Î± ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· ÏÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÏÏÏÎ¹ÎºÏÎ½",
        311: "ÎÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï ÎºÎ±Î¹ ÏÏÎ¿ÎµÏÎ¿Î¹Î¼Î¬ÏÏÎµ ÏÎ¿ Î³Î¹Î± ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· ÏÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÏÏÏÎ¹ÎºÏÎ½",
        312: "Î ÏÎ¿ÏÎ¸Î­ÏÏÎµ ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ± ÏÎ¿ %{0} %{1} ÏÎ·Ï ÏÏÏÏÏÎ¹ÎºÎ®Ï :%{2}, ÎµÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÏÎ±Î½ ÏÎµÎ»ÎµÎ¹ÏÏÎµÏÎµ",
        313: "ÎÎ¹Î±Î½ÎµÎ¯Î¼ÎµÏÎµ ÏÎ· ÏÏÏÎ¼Î¿ÏÎ»Î± Î¼Îµ ÏÎ¿ ÏÎ­ÏÎ¹",
        314: "Î ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· ÏÏÎ½ÏÎ±Î³Î® ÏÏÎ¬ÎµÎ¹ ÏÎ¿Î½ ÎºÎ±Î½ÏÎ½Î± ÏÏÎµÏÏÎ»Î®ÏÏÏÎ·Ï, ÏÏÎ½Î¿Î»Î¹ÎºÎ® ÏÎ¿ÏÏÏÎ·ÏÎ± ÏÏÏÏÏÎ¹ÎºÏÎ½: %{0} %{1}, Î¼Î­Î³Î¹ÏÏÎµÏ ÎµÏÎ¹ÏÏÎµÏÏÎ¼ÎµÎ½ÎµÏ ÏÎ¿ÏÏÏÎ·ÏÎµÏ ÏÏÏÏÏÎ¹ÎºÏÎ½: %{2} %{3}. ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÏÎ½ÎµÏÎ¯ÏÎµÏÎµ ÏÎ±ÏÎ¬ Î±ÏÏÎ®Î½ ÏÎ·Î½ ÏÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Î ÎµÏÎ³Î±ÏÎ¯Î± Î±ÏÏÏÎ¼Î±ÏÎ¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ ",
        401: "Î ÎµÏÎ³Î±ÏÎ¯Î± Î±ÏÏÏÎ¼Î±ÏÎ¿Ï ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼Î¿Ï Î¸Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ ",
        405: "Î¤Î¿ Î´Î¿ÏÎµÎ¯Î¿ ÏÎ·Ï Î²Î¿ÏÏÏÏÎ±Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ½ÏÎ·ÏÎ·Î¸ÎµÎ¯",
        406: "Î¤Î¿ Î´Î¿ÏÎµÎ¯Î¿ ÏÎ·Ï Î²Î¿ÏÏÏÏÎ±Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ½ÏÎ·ÏÎ·Î¸ÎµÎ¯",
        410: "ÎÎ± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î· Î±ÏÏÏÎ¼Î±ÏÎ· ÏÏÎ½ÏÎ®ÏÎ·ÏÎ· ÏÎ¿Ï autocap",
        411: "ÎÎ± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î· Î±ÏÏÏÎ¼Î±ÏÎ· ÏÏÎ½ÏÎ®ÏÎ·ÏÎ· ÏÎ¿Ï autocap",
        415: "Î ÏÎ»Î¬ÎºÎ± Î´Î¹Î±ÎºÏÏÏÎ· ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÏÎµÎ¯",
        416: "Î ÏÎ»Î¬ÎºÎ± Î´Î¹Î±ÎºÏÏÏÎ· ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÏÎµÎ¯",
        420: "Î Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÏÎµÎ¯",
        421: "Î Î´Î¹Î±Î½Î¿Î¼Î­Î±Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎºÎ±Î¸Î±ÏÎ¹ÏÏÎµÎ¯",
        425: "Î ÎµÏÎ±Î½Î±ÏÎ»Î®ÏÏÏÎ· ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½ Î¸Î± Î±ÏÏÎ¯ÏÎµÎ¹",
        426: "Î ÎµÏÎ±Î½Î±ÏÎ»Î®ÏÏÏÎ· ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½ Î¸Î± Î±ÏÏÎ¯ÏÎµÎ¹",
        430: "Î ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        431: "Î ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        435: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        436: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ® Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        440: "Î ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î± Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        441: "Î ÎºÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î± Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        445: "Î Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ· ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î± Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        446: "Î Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ· ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î± Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        450: "Î Î±Î½Î¬Î´ÎµÏÏÎ· ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½ ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î± Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        451: "Î Î±Î½Î¬Î´ÎµÏÏÎ· ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½ ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î± Î­ÏÎµÎ¹ ÏÏÎ¿Î³ÏÎ±Î¼Î¼Î±ÏÎ¹ÏÏÎµÎ¯",
        990: "Dispenser error occoured %{0} : %{1}. Do you want to retry task?",
        991: "Internal error occoured: %{0}",
        200000001: "Place Can",
        200000002: "Remove Can",
        200000003: "Î¤Î¿ ÏÎ¿ÏÏ Î³Î¹Î± ÏÎ¿ '%{0}' ÎºÎ¬ÏÏ Î±ÏÏ ÏÎ¿ ÎµÎ»Î¬ÏÎ¹ÏÏÎ¿ ÏÎ¿ÏÏ Î´Î¹Î±Î½Î¿Î¼Î®Ï, ÏÏÎ½ÎµÏÎ¯Î¶ÎµÏÎ±Î¹ Î¼Îµ Î´Î¹ÎºÎ® ÏÎ¿Ï ÎµÏÎ¸ÏÎ½Î·",
        200000004: "ÎÏÎ±Î½Î±ÏÎ»Î·ÏÏÏÏÎµ '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        dispenser: "ÎÎ¹Î±Î½Î¿Î¼Î­Î±Ï",
        dispenserConfigurationFile: "ÎÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï Î´Î¹Î±Î½Î¿Î¼Î­Î±",
        driverPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® Î¿Î´Î·Î³Î¿Ï",
        extensionPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÎµÏÎ­ÎºÏÎ±ÏÎ·Ï",
        folder: "ÎÏÎ¿ÏÎ¹Î­",
        formulaPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÎ·Ï ÏÏÏÎ¼Î¿ÏÎ»Î±Ï",
        host: "Î Î»Î®Î¸Î¿Ï",
        iddPath: "ÎÏÏÎµÎ¯Î¿ Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï IDD",
        italtintoPath: "Italtinto Î´Î¹Î±Î´ÏÎ¿Î¼Î® Î´Î¹Î±Î¼ÏÏÏÏÏÎ·Ï",
        lldPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® LLD",
        machineType: "Î¤ÏÏÎ¿Ï Î¼Î·ÏÎ±Î½Î®Ï",
        noMachineAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿ Î¼Î·ÏÎ¬Î½Î·Î¼Î±",
        protocolVersion: "ÎÎºÎ´Î¿ÏÎ· ÏÏÏÏÎ¿ÎºÏÎ»Î»Î¿Ï",
        rccDriverSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï ÏÏÎ¿Î³ÏÎ¬Î¼Î¼Î±ÏÎ¿Ï Î¿Î´Î®Î³Î·ÏÎ·Ï",
        resultPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® Î±ÏÎ¿ÏÎµÎ»Î­ÏÎ¼Î±ÏÎ¿Ï",
        save: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¸Î¼Î¯ÏÎµÏÎ½",
        saveSettingsWarning:
            "Î ÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ·! ÎÎ¹ Î±Î»Î»Î±Î³Î­Ï ÏÎµ Î±ÏÏÎ® ÏÎ·Î½ ÎµÎ½ÏÏÎ·ÏÎ± ÎµÎ½Î´Î­ÏÎµÏÎ±Î¹ Î½Î± ÏÏÎ¿ÎºÎ±Î»Î­ÏÎ¿ÏÎ½ Î´ÏÏÎ»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± ÏÎ¿Ï Î´Î¹Î±Î½Î¿Î¼Î­Î±.",
        serviceSwPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÏÏÎ·ÏÎµÏÎ¯Î±Ï",
        simulationPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ÏÎ¿Î¼Î¿Î¯ÏÏÎ·Ï"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "ÎÏÎ¹ÏÏÎ­ÏÏÎµ ÏÎ· ÏÎµÎ¹ÏÎ¿ÎºÎ¯Î½Î·ÏÎ· ÏÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÏÏÏÎ¹ÎºÏÎ½",
        ask: "Î Î±ÏÎ±ÎºÎ±Î»Ï",
        canHandlingOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï Î´Î¹Î±ÏÎµÎ¯ÏÎ·ÏÎ·Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        checkCanBeforeDispense: "ÎÎ»ÎµÎ³ÏÎ¿Ï Î´Î¿ÏÎµÎ¯Î¿Ï ÏÏÎ¹Î½ Î±ÏÏ ÏÎ· Î´Î¹Î±Î½Î¿Î¼Î®",
        checkOverfill: "ÎÎ»Î­Î³Î¾ÏÎµ ÏÎ·Î½ ÏÏÎµÏÏÎ»Î®ÏÏÏÎ·",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ·",
        dispenseInvalidColorants: "ÎÎ±ÏÎ±Î½Î¿Î¼Î® Î¼Î· Î­Î³ÎºÏÏÏÎ½ ÏÏÏÏÏÎ¹ÎºÏÎ½",
        dispensingOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        enable: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ·",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "Î ÏÎ¿ÎµÎ¹Î´Î¿ÏÎ¿Î¯Î·ÏÎ· Î±ÎºÏÎ¯Î²ÎµÎ¹Î±Ï Î¼Î·ÏÎ±Î½Î®Ï",
        machineOptions: "ÎÏÎ¹Î»Î¿Î³Î­Ï Î¼Î·ÏÎ±Î½Î®Ï",
        machineUnit: "ÎÎ¿Î½Î¬Î´Î± Î¼Î·ÏÎ±Î½Î®Ï",
        minimalDispenseAmount: "ÎÎ»Î¬ÏÎ¹ÏÏÎ¿ ÏÎ¿ÏÏ Î´Î¹Î±Î½Î¿Î¼Î®Ï",
        placeCanSensor: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î´Î¿ÏÎµÎ¯Î¿Ï",
        placeCanSensorDelay: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ·Î½ ÎºÎ±Î¸ÏÏÏÎ­ÏÎ·ÏÎ· ÏÎ¿Ï Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î´Î¿ÏÎµÎ¯Î¿Ï",
        rccMachineSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¼Î·ÏÎ±Î½Î®Ï",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "ÎÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ¿Î½ Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î´Î¿ÏÎµÎ¯Î¿Ï",
        removeCanSensorDelay: "ÎÏÎ±Î¹ÏÎ­ÏÏÎµ ÏÎ·Î½ ÎºÎ±Î¸ÏÏÏÎ­ÏÎ·ÏÎ· ÏÎ¿Ï Î±Î¹ÏÎ¸Î·ÏÎ®ÏÎ± Î´Î¿ÏÎµÎ¯Î¿Ï",
        save: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¸Î¼Î¯ÏÎµÏÎ½",
        sec: "Î´ÎµÏÏ.",
        skipPlaceCanDialog: "Î Î±ÏÎ¬Î»ÎµÎ¹ÏÎ· Î´Î¹Î±Î»ÏÎ³Î¿Ï ÏÎ¿ÏÎ¿Î¸Î­ÏÎ·ÏÎ·Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        skipRemoveCanDialog: "Î Î±ÏÎ¬Î»ÎµÎ¹ÏÎ· Î´Î¹Î±Î»ÏÎ³Î¿Ï Î±ÏÎ±Î¯ÏÎµÏÎ·Ï Î´Î¿ÏÎµÎ¯Î¿Ï",
        splitFormula: "Split Formula",
        tmcEnabled: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ¿ TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Base can barcode validation",
        validateBarcodeRefill: "Refill barcode validation",
        validateColorantsDuringInit: "ÎÏÎ±Î»Î·Î¸ÎµÏÏÏÎµ ÏÎ¹Ï ÏÏÏÏÏÎ¹ÎºÎ­Ï ÎºÎ±ÏÎ¬ ÏÎ·Î½ Î±ÏÏÎ¹ÎºÎ¿ÏÎ¿Î¯Î·ÏÎ·"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Î¥ÏÎ¬ÏÏÎ¿ÏÎ½ ÎºÎ¬ÏÎ¿Î¹ÎµÏ ÎµÎ½Î­ÏÎ³ÎµÎ¹Ï ÏÎ¿Ï ÎµÎºÏÎµÎ»Î¿ÏÎ½ÏÎ±Î¹ ÏÏÎ·Î½ Î¼Î·ÏÎ±Î½Î® ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï",
        addLevel: "Î ÏÎ¿ÏÎ¸Î®ÎºÎ· ÏÏÎ¬Î¸Î¼Î·Ï...",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "ÎÎÎ¤ÎÎÎ©Î£Î",
        dispenseFormula: "ÎÎ¹Î±Î½Î¿Î¼Î® ÏÏÎ½ÏÎ±Î³Î®Ï",
        dispenserIdle: "Î Î¼Î·ÏÎ±Î½Î® ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï ÎµÎ¯Î½Î±Î¹ Î±Î½ÎµÎ½ÎµÏÎ³Î®",
        dispenserIsBusy: "Î Î¼Î·ÏÎ±Î½Î® ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï ÎµÎ¯Î½Î±Î¹ Î±ÏÎ±ÏÏÎ¿Î»Î·Î¼Î­Î½Î·",
        dispenserIsIdle: "Î Î¼Î·ÏÎ±Î½Î® ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï ÎµÎ¯Î½Î±Î¹ Î±Î½ÎµÎ½ÎµÏÎ³Î®",
        dispenserIsReady: "Î Î¼Î·ÏÎ±Î½Î® ÏÏÏÎ¼Î±ÏÎ¹ÏÎ¼Î¿Ï ÎµÎ¯Î½Î±Î¹ Î­ÏÎ¿Î¹Î¼Î·",
        dispensingFormula: "Î£ÏÎ½ÏÎ±Î³Î® Î´Î¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ·Ï",
        errorCode: "ÎÏÎ´Î¹ÎºÏÏ Î»Î¬Î¸Î¿ÏÏ",
        explanation: "ÎÎ¾Î®Î³Î·ÏÎ·",
        fillToMax: "ÎÎµÎ¼Î¯ÏÏÎµ ÏÏÎ¿ Î¼Î­Î³Î¹ÏÏÎ¿",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "Î Î¼Î·ÏÎ±Î½Î® ÎµÎ¯Î½Î±Î¹ Î­ÏÎ¿Î¹Î¼Î·",
        moveToFill: "ÎÎµÏÎ±ÎºÎ¯Î½Î·ÏÎ· Î³Î¹Î± Î½Î± Î³ÎµÎ¼Î¯ÏÎµÏÎµ",
        noMachineDialog: "ÎÎ±Î½Î­Î½Î± Î¼Î·ÏÎ¬Î½Î·Î¼Î± Î´ÎµÎ½ Î­ÏÎµÎ¹ ÏÏÎ½Î´ÎµÎ¸ÎµÎ¯",
        of: "ÎÏÏ",
        packageSize: "ÎÎ­Î³ÎµÎ¸Î¿Ï ÏÏÏÎºÎµÏÎ±ÏÎ¯Î±Ï",
        placeBaseCan: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï",
        pleaseCheckYourMachineConnection: "ÎÎ»Î­Î³Î¾ÏÎµ ÏÎ· ÏÏÎ½Î´ÎµÏÎ· ÏÎ¿Ï Î¼Î·ÏÎ±Î½Î®Î¼Î±ÏÎ¿Ï.",
        pleaseRefill: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÎµÏÎ±Î½Î±Î³ÎµÎ¼Î¯ÏÏÎµ",
        solution: "ÎÏÏÎ·",
        subErrors: "Î¥ÏÎ¿ ÏÏÎ¬Î»Î¼Î±ÏÎ±",
        timeToEnd: "ÎÏÎ± Î½Î± ÏÎµÎ»ÎµÎ¹ÏÏÎµÎ¹",
        tintingFormula: "ÎÎ¿ÏÎ¿Î¼ÎµÏÏÎ·Î¼Î­Î½Î· ÏÏÎ½ÏÎ±Î³Î®",
        tintingPleaseWait: "ÎÎ¿ÏÎ¿Î¼Î­ÏÏÎ·ÏÎ· , ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        validateBaseCan: "ÎÏÎ¹ÎºÏÏÏÏÏÎµ ÏÎ¿ Î´Î¿ÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï RCC",
        rccUrl: "RCC url"
    },
    rccSpectroDialog: {
        100: "Î£ÏÎ½Î´ÎµÏÎ· ÏÏÎ· ÏÏÏÎºÎµÏÎ® ÏÎ±Ï Î¼Î­ÏÏ Bluetooth. ÎÎµÎ²Î±Î¹ÏÎ¸ÎµÎ¯ÏÎµ ÏÏÎ¹ Î­ÏÎµÏÎµ ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î®ÏÎµÎ¹ ÏÎ¿ Bluetooth ÎºÎ±Î¹ ÏÏÎ¹ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÎ±Ï ÎµÎ¯Î½Î±Î¹ ÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¹Î·Î¼Î­Î½Î¿.",
        101: "Instrument hasn't been detected. Do you want to retry?",
        110: "ÎÎµÎ²Î±Î¹ÏÎ¸ÎµÎ¯ÏÎµ ÏÏÎ¹ ÏÎ¿ Nano ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿ ÎºÎ±Î¹ ÏÎ¹Î­ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î³Î¹Î± Î½Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÎ¹ Î· ÏÏÎ¿ÎµÏÎ¿Î¹Î¼Î±ÏÎ¯Î±",
        111: "Nano hasn't been detected. Do you want to retry?",
        112: "ÎÏÎ¿ÏÏÎ½Î´Î­ÏÏÎµ ÏÎ¿ Nano, ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ 10 Î´ÎµÏÏÎµÏÏÎ»ÎµÏÏÎ±, ÏÏÎ½Î´Î­ÏÏÎµ ÏÎ¿ Î¾Î±Î½Î¬ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        120: "Î£ÏÎ½Î´Î­ÎµÏÎµ ÏÏÎ· ÏÏÏÎºÎµÏÎ® ÏÎ±Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        121: "Î¤Î¿ ÏÏÎ³Î±Î½Î¿ Î´ÎµÎ½ Î­ÏÎµÎ¹ Î±Î½Î¹ÏÎ½ÎµÏÎ¸ÎµÎ¯. ÎÎ­Î»ÎµÏÎµ Î½Î± ÏÏÎ¿ÏÏÎ±Î¸Î®ÏÎµÏÎµ Î¾Î±Î½Î¬",
        200: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î¼Î±ÏÏÎ¿ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ Î® ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        201: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î¼Î±ÏÏÎ¿ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        202: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î¼Î±ÏÏÎ¿ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½ÏÎ½",
        205: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î»ÎµÏÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ Î® ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        206: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î»ÎµÏÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        207: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î»ÎµÏÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ ÏÎ¿Ï Î¿ÏÎ³Î¬Î½Î¿Ï",
        210: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î´Î¹Î±Î³Î½ÏÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ Î® ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        211: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î´Î¹Î±Î³Î½ÏÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        212: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î´Î¹Î±Î³Î½ÏÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ ÏÎ¿Ï Î¿ÏÎ³Î¬Î½Î¿Ï",
        215: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÎ¿ ÎºÎ¬Î»ÏÎ¼Î¼Î± ÏÎ¿Ï Î¿ÏÎ³Î¬Î½Î¿Ï ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ Î® ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        216: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÎ¿ ÎºÎ¬Î»ÏÎ¼Î¼Î± ÏÎ¿Ï Î¿ÏÎ³Î¬Î½Î¿Ï ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        217: "ÎÎ»ÎµÎ¯ÏÏÎµ ÏÎ¿ ÎºÎ¬Î»ÏÎ¼Î¼Î± ÏÎ¿Ï Î¿ÏÎ³Î¬Î½Î¿Ï ÎºÎ±Î¹ ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        220: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÎµ Î±ÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ Î® ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        221: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î±ÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        222: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÎµ Î±ÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿ ÎºÎ±Î¹ ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½ÏÎ½",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "ÎÎ»Î¿ÎºÎ»Î®ÏÏÏÎ· Î²Î±Î¸Î¼Î¿Î½ÏÎ¼Î·ÏÎ·Ï ÏÏÎ¿ ÏÎ±ÏÎ¬Î¸ÏÏÎ¿ ÏÎ¿Ï Î¿Î´Î·Î³Î¿Ï",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "Î ÏÎ¿ÎµÏÎ¿Î¹Î¼Î¬Î¶ÎµÏÎµ Î³Î¹Î± ÏÎ¿ Î²Î®Î¼Î± Î²Î±Î¸Î¼Î¿Î½ÏÎ¼Î·ÏÎ·Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        298: "ÎÎ±Î¸Î¼Î¿Î½ÏÎ¼Î·ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        299: "ÎÎ»Î¿ÎºÎ»Î·ÏÏÎ½ÎµÏÎµ ÏÎ¿ Î²Î®Î¼Î± Î²Î±Î¸Î¼Î¿Î½ÏÎ¼Î·ÏÎ·Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        300: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î´ÎµÎ¯Î³Î¼Î± ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ Î® ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ Î¿ÏÎ³Î¬Î½Î¿Ï",
        301: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î´ÎµÎ¯Î³Î¼Î± ÎºÎ±Î¹ ÏÏÎ½ÎµÏÎ¯ÏÏÎµ",
        302: "Î¤Î¿ÏÎ¿Î¸ÎµÏÎ®ÏÏÎµ ÏÎ¿ ÏÏÎ³Î±Î½Î¿ ÏÏÎ¿ Î´ÎµÎ¯Î³Î¼Î± ÎºÎ±Î¹ ÏÎ±ÏÎ®ÏÏÎµ ÏÎ¿ ÎºÎ¿ÏÎ¼ÏÎ¯ ÏÎ¿Ï Î¿ÏÎ³Î¬Î½Î¿Ï",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "Finish measure in driver window",
        397: "Î ÏÎ¿ÎµÏÎ¿Î¹Î¼Î±ÏÎ¯Î± Î³Î¹Î± Î¼Î­ÏÏÎ·ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        398: "ÎÎ­ÏÏÎ·ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        399: "ÎÎ»Î¿ÎºÎ»Î·ÏÏÎ½ÎµÏÎµ ÏÎ· Î¼Î­ÏÏÎ·ÏÎ·, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        498: "ÎÎ®ÏÎ· Î¼Î­ÏÏÎ·ÏÎ·Ï, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        499: "ÎÎ®ÏÎ· ÏÎ»ÏÎ½ ÏÏÎ½ Î¼ÎµÏÏÎ®ÏÎµÏÎ½, ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ",
        900: "Instrument error occoured %{0} : %{1}. Do you want to retry task?",
        901: "Internal error occoured: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Î ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®Ï ÏÏÎ­ÏÎµÎ¹ Î½Î± Î´Î¹Î±Î¸Î­ÏÎµÎ¹ ÏÏÎ½Î´ÎµÏÎ· Bluetooth. Î¤Î¿ ÏÎ¬ÏÎ¼Î± ÏÏÎ­ÏÎµÎ¹ Î½Î± ÏÏÎ½Î´ÏÎ±ÏÏÎµÎ¯ Î¼Îµ ÏÎ¿Î½ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®. ÎÏÎ±Î¹ÏÎ¿ÏÎ½ÏÎ±Î¹ Windows 10 Î¼Îµ Î±ÏÏÏÎ¼Î±ÏÎ· ÎµÎ½Î·Î¼Î­ÏÏÏÎ· 2018.",
        DatacolorSilent:
            "ÎÏÎ±Î½ ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ÏÎµ ÏÎ· Î»ÎµÎ¹ÏÎ¿ÏÏÎ³Î¯Î± Silent, ÏÎ± ÏÎ±ÏÎ¬Î¸ÏÏÎ± Datacolor ÎµÎ¼ÏÎ±Î½Î¯Î¶Î¿Î½ÏÎ±Î¹ Î±ÏÎµÏÎ¸ÎµÎ¯Î±Ï ÏÏÎ¿ %{name}. Î£Îµ Î±ÏÏÎ¬ ÏÎ± ÏÎ±ÏÎ¬Î¸ÏÏÎ±, Î¿Î¹ ÏÎ±ÏÎ¬Î¼ÎµÏÏÎ¿Î¹ ÏÎ¬ÏÎ¼Î±ÏÎ¿Ï Î´ÎµÎ½ Î¼ÏÎ¿ÏÎ¿ÏÎ½ Î½Î± Î±Î»Î»Î¬Î¾Î¿ÏÎ½.",
        DatacolorUseDiagnosticTile: "Î ÏÏÎ®ÏÎ· ÏÎ»Î±ÎºÎ¹Î´Î¯ÏÎ½ Î´Î¹Î¬Î³Î½ÏÏÎ·Ï Î²ÎµÎ»ÏÎ¹ÏÎ½ÎµÎ¹ ÏÎ·Î½ ÏÎ¿Î¹ÏÏÎ·ÏÎ± Î¼Î­ÏÏÎ·ÏÎ·Ï.",
        comPort: "Î ÏÏÏÎ± ÎµÏÎ¹ÎºÎ¿Î¹Î½ÏÎ½Î¯Î±Ï",
        diagnosticTile: "Î¤Î¿ Datacolor ÏÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹ÎµÎ¯ Î´Î¹Î±Î³Î½ÏÏÏÎ¹ÎºÏ ÏÎ»Î±ÎºÎ¯Î´Î¹Î¿",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "ÎÎ¿Î½ÏÎ­Î»Î¿",
        noSpectroAvailable: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿ spectro",
        rccSpectroSettings: "Î¡ÏÎ¸Î¼Î¯ÏÎµÎ¹Ï Î¦Î±ÏÎ¼Î¿ÏÏÏÎ¿Î¼Î­ÏÏÎ¿Ï",
        save: "ÎÏÎ¿Î¸Î®ÎºÎµÏÏÎ· ÏÏÎ¸Î¼Î¯ÏÎµÏÎ½",
        silent: "Datacolor Silent",
        simulationPath: "ÎÎ¹Î±Î´ÏÎ¿Î¼Î® ÏÏÎ¿ÏÎ¿Î¼Î¿Î¯ÏÏÎ·Ï",
        spectroType: "Î¤ÏÏÎ¿Ï Î¦Î±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿Ï",
        useProfiledValues: "Î§ÏÎ·ÏÎ¹Î¼Î¿ÏÎ¿Î¹Î®ÏÏÎµ ÏÎ¹Î¼Î­Ï ÏÏÎ¿ÏÎ¯Î»"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirculate all",
        recirculateChannels: "Recirculate channels",
        recirculatingSpeed: "Î¤Î±ÏÏÏÎ·ÏÎ± Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ·Ï",
        recirculatingTime: "Î§ÏÏÎ½Î¿Ï Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ·Ï",
        startRecirculating: "ÎÎµÎºÎ¹Î½Î®ÏÏÎµ ÏÎ·Î½ Î±Î½Î±ÎºÏÎºÎ»ÏÏÎ·"
    },
    redlikeLight: {
        finishPreviousSteps: "Î Î±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¼Î±ÏÎ¯ÏÏÎµ ÏÎ± ÏÏÎ¿Î·Î³Î¿ÏÎ¼ÎµÎ½Î± Î²Î®Î¼Î±ÏÎ±",
        searchBySpectro: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· Î¼Îµ ÏÎ±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿",
        searchFormula: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· ÏÏÎ½ÏÎ±Î³Î®Ï",
        selectBase: "Select base",
        selectColor: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÏÎ¼Î±",
        selectCustomer: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎµÎ»Î¬ÏÎ·",
        selectFandeck: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        selectPackage: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ±ÎºÎ­ÏÎ¿",
        selectProduct: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÏÎ¿ÏÏÎ½",
        startSelectFandeck: "Start to select fandeck",
        startSelectProduct: "Start to select product",
        stepByStepProgress: "ÎÏÎ¿ÏÎµÎ¯ÏÎµ Î½Î± ÏÏÎ¿ÏÏÏÎ®ÏÎµÏÎµ Î²Î®Î¼Î± ÏÏÎ¿Ï Î²Î®Î¼Î±",
        typeHereToSearch: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÎµÎ´Ï Î³Î¹Î± Î±Î½Î±Î¶Î®ÏÎ·ÏÎ·",
        typeToFilter: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ Î³Î¹Î± ÏÎ¹Î»ÏÏÎ¬ÏÎ¹ÏÎ¼Î±"
    },
    restartModal: {
        computerNeedsRestart: "Î ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®Ï ÏÏÎµÎ¹Î¬Î¶ÎµÏÎ±Î¹ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ·!",
        notCompletelyTranslated:
            "Î Î±Î»Î»Î±Î³Î® Î³Î»ÏÏÏÎ±Ï Î±ÏÎ±Î¹ÏÎµÎ¯ ÎµÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï. ÎÏÎ¹ÏÎ¼Î­Î½Î± ÏÎ¼Î®Î¼Î±ÏÎ± ÏÎ¿Ï Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÎ¿Ï ÎµÎ½Î´Î­ÏÎµÏÎ±Î¹ Î½Î± Î¼Î·Î½ Î¼ÎµÏÎ±ÏÏÎ¬Î¶Î¿Î½ÏÎ±Î¹ ÏÎ»Î®ÏÏÏ Î±ÏÏÎ® ÏÎ· ÏÏÎ¹Î³Î¼Î®.",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} needs restart!"
    },
    searchPanel: {
        basePlaceholder: "or type a base name",
        baseStartPlaceholder: "Start by typing a base name",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "Î® ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿Î½ ÎºÏÎ´Î¹ÎºÏ ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        colorCodeStartPlaceholder: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿Î½ ÎºÏÎ´Î¹ÎºÏ ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "Î® ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        colorNameStartPlaceholder: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "Î® ÏÎ»Î·ÎºÏÏÎ¿Î»Î³Î®ÏÏÎµ ÏÎ¿ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        fandeckStartPlaceholder: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿ ÏÏÏÎ¼Î±ÏÎ¿Î»ÏÎ³Î¹Î¿",
        formulaByColor: "Î¤ÏÏÎ¿Ï Î±Î½Î¬ ÏÏÏÎ¼Î±",
        noResultsFound: "No results found",
        packagePlaceholder: "or type a package name",
        packageStartPlaceholder: "Start by typing a package name",
        productPlaceholder: "Î® ÏÎ»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿ ÏÏÎ¿ÏÏÎ½ ÏÎ·Ï ÏÏÎ½ÏÎ±Î³Î®Ï",
        productStartPlaceholder: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÏÎ¿ ÏÏÎ¿ÏÏÎ½",
        standard: "Î ÏÏÏÏÏÎ¿",
        typeFandeckToFilter: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÎµÎ´Ï Î³Î¹Î± Î½Î± ÏÎ¹Î»ÏÏÎ¬ÏÎµÏÎµ Î¼Îµ ÏÎ½Î¿Î¼Î± ÏÏÏÎ¼Î±ÏÎ¿Î»Î¿Î³Î¯Î¿Ï",
        typeProductToFilter: "Î Î»Î·ÎºÏÏÎ¿Î»Î¿Î³Î®ÏÏÎµ ÎµÎ´Ï Î³Î¹Î± Î½Î± ÏÎ¹Î»ÏÏÎ¬ÏÎµÏÎµ Î¼Îµ Î²Î¬ÏÎ· ÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÏÎ¿ÏÏÎ½ÏÎ¿Ï"
    },
    sendOrderModal: {
        customNote: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î· ÏÎ·Î¼ÎµÎ¯ÏÏÎ·",
        noCompatibleServers: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ ÏÏÎ¼Î²Î±ÏÎ¿Î¯ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ­Ï ÏÏÎ¿ Î´Î¯ÎºÏÏÏ ÏÎ±Ï",
        orderOverview: "ÎÏÎ¹ÏÎºÏÏÎ·ÏÎ· ÏÎ±ÏÎ±Î³Î³ÎµÎ»Î¹ÏÎ½",
        selectTargetMachine: "Select target machine",
        sendOrder: "ÎÏÎ¿ÏÏÎ¿Î»Î® ÎµÎ½ÏÎ¿Î»Î®Ï",
        sendOrderTo: "Your order will be sent to %{serverName}",
        targetMachine: "Î£ÏÎ¿ÏÎµÏÏÎ¼ÎµÎ½Î· Î¼Î·ÏÎ±Î½Î®"
    },
    server: {
        computerId: "ÎÎ½Î±Î³Î½ÏÏÎ¹ÏÏÎ¹ÎºÏ ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        ip: "IP",
        selectServer: "ÎÏÎ¹Î»Î­Î¾ÏÎµ Î­Î½Î±Î½ Î±ÏÏ ÏÎ¿ÏÏ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿ÏÏ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ­Ï",
        server: "ÎÎ¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®Ï"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "ÎÎ½ÎµÏÎ³Î­Ï ÏÏÎ¿ÏÎ¸Î®ÎºÎµÏ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®",
        currentlyActive: "ÎÎ¹ ÏÏÎ­ÏÎ¿ÏÏÎµÏ ÎµÎ½ÎµÏÎ³Î­Ï ÏÏÎ¿ÏÎ¸Î®ÎºÎµÏ",
        plugin: "Î ÏÏÏÎ¸ÎµÏÎ¿",
        pluginName: "ÎÎ½Î¿Î¼Î± ÏÏÎ¿ÏÎ¸Î®ÎºÎ·Ï",
        statusActive: "ÎÎ½ÎµÏÎ³ÏÏ",
        statusInactive: "ÎÎ½ÎµÎ½ÎµÏÎ³Ï"
    },
    serviceActionsSettings: {
        canisterLevel: "Î£ÏÎ¬Î¸Î¼Î· ÎºÎ±Î½Î¯ÏÏÏÎ¿Ï",
        capClose: "ÎÎ»ÎµÎ¹ÏÏÏ",
        capMiddle: "ÎÎ­ÏÎ·",
        capOpen: "ÎÎ½Î¿Î¹ÏÏÏ",
        cleanAllChannels: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÏÎ»ÏÎ½ ÏÏÎ½ ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
        cleanChannels: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
        computer: "Î¥ÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        computerReboot: "ÎÏÎ±Î½ÎµÎºÎºÎ¯Î½Î·ÏÎ· ÏÎ¿Ï ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        computerShutdown: "ÎÏÎµÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· ÏÏÎ¿Î»Î¿Î³Î¹ÏÏÎ®",
        connectMachine: "Î£ÏÎ½Î´Î­ÏÏÎµ ÏÎ· Î¼Î·ÏÎ±Î½Î®",
        general: "ÎÎµÎ½Î¹ÎºÎ¬",
        initialize: "ÎÏÏÎ¹ÎºÎ¿ÏÎ¿Î¯Î·ÏÎ·",
        noMachineIsConnected: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î· Î¼Î·ÏÎ±Î½Î®",
        plug: "ÎÏÏÎ¼Î±",
        plugger: "ÎÏÏÎ¼Î±ÏÎ±",
        punch: "ÎÎ¹Î¬ÏÏÎ·ÏÎ·",
        puncher: "ÎÎ¹Î±ÏÏÎ·ÏÎ®Ï",
        purgeChannels: "ÎÎ±Î¸Î±ÏÎ¹ÏÎ¼ÏÏ ÎºÎ±Î½Î±Î»Î¹ÏÎ½",
        recirculate: "ÎÎ½Î±ÎºÏÎºÎ»Î¿ÏÎ¿ÏÎ¯Î±",
        recirculateAllChannels: "ÎÎ½Î±ÎºÏÎºÎ»ÏÏÎ· ÏÎ»ÏÎ½ ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        recirculateChannels: "ÎÎ½Î±ÎºÏÎºÎ»ÏÏÎ· ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        serviceActions: "ÎÎ½Î­ÏÎ³ÎµÎ¹ÎµÏ ÏÏÎ·ÏÎµÏÎ¹ÏÎ½",
        setCanisterLevel: "Î¡ÏÎ¸Î¼Î¹ÏÎ· ÎµÏÎ¹ÏÎ­Î´Î¿Ï ÏÏÎ¬Î¸Î¼Î·Ï",
        shelfDown: "Î¡Î¬ÏÎ¹ ÎºÎ¬ÏÏ",
        shelfUp: "Î¡Î¬ÏÎ¹ ÎµÏÎ¬Î½Ï",
        showServiceWindow: "ÎÎ¼ÏÎ¬Î½Î¹ÏÎ· ÏÎ±ÏÎ±Î¸ÏÏÎ¿Ï ÏÏÎ·ÏÎµÏÎ¹ÏÎ½",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "ÎÎºÎºÎ¯Î½Î·ÏÎ· ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ¬Î»Î¼Î±ÏÎ¿Ï",
        startHardReset: "ÎÎºÎºÎ¯Î½Î·ÏÎ· Î¿Î»Î¹ÎºÎ®Ï ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬Ï",
        startReset: "ÎÎºÎºÎ¯Î½Î·ÏÎ· ÎµÏÎ±Î½Î±ÏÎ¿ÏÎ¬Ï",
        stirAllCanisters: "ÎÎ½Î¬Î´ÎµÏÏÎ· ÏÎ»ÏÎ½ ÏÏÎ½ ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        stirCanisters: "ÎÎ½Î¬Î´ÎµÏÏÎ· ÎºÎ±Î½Î¯ÏÏÏÏÎ½",
        stirCanistersMore: "ÎÎ½Î¬Î´ÎµÏÏÎ· ÎºÎ±Î½Î¯ÏÏÏÏÎ½"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Î¡ÏÎ¸Î¼Î¹ÏÎ·",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "Î£ÏÎ½Î´Î­ÏÏÎµ ÏÏÏÎºÎµÏÎ®",
        connectedTo: "Î£ÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿ ÏÎµ",
        connectingDevice: "Î ÏÏÏÎºÎµÏÎ® ÏÎ±Ï ÏÏÎ½Î´Î­ÎµÏÎ±Î¹",
        deselectAll: "ÎÏÎ¿ÎµÏÎ¹Î»Î¿Î³Î® ÏÎ»ÏÎ½",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Î ÏÏÏÎºÎµÏÎ® ÏÎ±Ï Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ¸Î¼Î¹Î¶Î¼Î­Î½Î·",
        eraseResult: "Erase result",
        filter: "Î¦Î¯Î»ÏÏÎ¿",
        foundInFormulas: "ÎÏÎ­Î¸Î·ÎºÎµ ÏÎµ ÏÏÎ½ÏÎ±Î³Î­Ï",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "ÎÏÎ¿ÏÎ­Î»ÎµÏÎ¼Î± Î¼Î­ÏÏÎ·ÏÎ·Ï",
        noFilters: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î± ÏÎ¯Î»ÏÏÎ±",
        noFormulas: "ÎÎµÎ½ Î²ÏÎ­Î¸Î·ÎºÎ±Î½ ÏÏÎ½ÏÎ±Î³Î­Ï",
        noSelectedSpectro: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÏÎ¹Î»ÎµÎ³ÎµÎ¯ ÏÏÏÎºÎµÏÎ®",
        notSelected: "ÎÎ· ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î¿",
        pressConnectButton: "ÎÏÎ¹Î²ÎµÎ²Î±Î¹ÏÏÏÎµ ÏÏÎ¹ Î· ÏÏÏÎºÎµÏÎ® ÏÎ±Ï ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î· ÎºÎ±Î¹ ÏÎ¹Î­ÏÏÎµ Î£ÏÎ½Î´ÎµÏÎ·",
        searchFormulas: "ÎÎ½Î±Î¶Î®ÏÎ·ÏÎ· Î£ÏÎ½ÏÎ±Î³Î®Ï",
        selectSpectro: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÏÎ±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿",
        showDetails: "ÎÎµÎ¯Î¾Îµ Î»ÎµÏÏÎ¿Î¼Î­ÏÎµÎ¹ÎµÏ",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "Î¤Î¿ ÏÎ±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿ ÎµÎ¯Î½Î±Î¹ ÏÏÎ½Î´ÎµÎ´ÎµÎ¼Î­Î½Î¿",
        spectroIsReady: "Î¤Î¿ ÏÎ±ÏÎ¼Î±ÏÎ¿ÏÏÏÏÎ¼ÎµÏÏÎ¿ ÎµÎ¯Î½Î±Î¹ Î­ÏÎ¿Î¹Î¼Î¿",
        spectroReady: "Î ÏÏÏÎºÎµÏÎ® ÎµÎ¯Î½Î±Î¹ Î­ÏÎ¿Î¹Î¼Î· Î³Î¹Î± ÏÎµÏÎ±Î¹ÏÎ­ÏÏ ÎµÏÎ³Î±ÏÎ¯ÎµÏ",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "Î ÏÏÏÎºÎµÏÎ® ÏÎ±Ï ÎµÎ¯Î½Î±Î¹ ÏÏÎ¸Î¼Î¹ÏÎ¼Î­Î½Î· ÎºÎ±Î¹ Î¼ÏÎ¿ÏÎµÎ¯ÏÎµ Î½Î± Î¾ÎµÎºÎ¹Î½Î®ÏÎµÏÎµ ÏÎ¹Ï Î¼ÎµÏÏÎ®ÏÎµÎ¹Ï ÏÎ±Ï",
        tolerance: "ÎÎ­Î»ÏÎ± Î (CIE 2000)",
        toleranceOfDevitation: "ÎÎ­Î»ÏÎ± E (CIE 2000) Î±Î½Î¿ÏÎ®"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Î ÏÎ¿ÏÎ±ÏÎ¼Î¿ÏÎ¼Î­Î½Î¿ %{1} %{2}",
        deleteSelectedRecords: "ÎÎ¹Î±Î³ÏÎ¬ÏÏÎµ ÏÎ± ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î± Î±ÏÏÎµÎ¯Î±",
        exportHistory: "ÎÎ¾Î±Î³ÏÎ³Î® Î¹ÏÏÎ¿ÏÎ¹ÎºÎ¿Ï",
        finishFormula: "Î¤ÎµÎ»ÎµÎ¹ÏÏÏÎµ ÏÎ·Î½ ÏÏÎ½ÏÎ±Î³Î®",
        foundInFormulas: "ÎÏÎ­Î¸Î·ÎºÎµ ÏÎµ ÏÏÎ½ÏÎ±Î³Î­Ï",
        hideHiddenRecords: "ÎÎ·Î½ ÎµÎ¼ÏÎ±Î½Î¯Î¶ÎµÏÎµ ÎºÏÏÏÎ­Ï ÎµÎ³Î³ÏÎ±ÏÎ­Ï",
        hideSelectedRecord: "ÎÏÏÎºÏÏÏÎ· ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î·Ï ÎµÎ³Î³ÏÎ±ÏÎ®Ï",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "ÎÏÎ±Î½Î±ÏÎ­ÏÎµÏÎµ ÏÎ·Î½ ÎµÏÎ¹Î»ÎµÎ³Î¼Î­Î½Î· ÎµÎ³Î³ÏÎ±ÏÎ®",
        showAllRecords: "ÎÎ¼ÏÎ¬Î½Î¹ÏÎ· ÏÎ»ÏÎ½ ÏÏÎ½ ÎµÎ³Î³ÏÎ±ÏÏÎ½",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "ÎÏÎ¹Î»Î­Î¾ÏÎµ ÎºÎ¬Î½Î¹ÏÏÏÎ±",
        startStirring: "ÎÎµÎºÎ¹Î½Î®ÏÏÎµ ÏÎ·Î½ Î±Î½Î¬Î´ÎµÏÏÎ·",
        stirAllCanisters: "Stir all canisters",
        stirCanisters: "Stir canisters",
        stirringSpeed: "Î¤Î±ÏÏÏÎ·ÏÎ± Î±Î½Î¬Î´ÎµÏÏÎ·Ï",
        stirringTime: "Î§ÏÏÎ½Î¿Ï Î±Î½Î¬Î´ÎµÏÏÎ·Ï"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "ÎÎµÎ½ Î­ÏÎµÎ¹ ÎµÎºÏÏÏÎ·Î¸ÎµÎ¯ ÎºÎ±Î½Î­Î½Î± ÏÏÎ¿Î¹ÏÎµÎ¯Î¿ ÏÏÎ¿ barcode %{code}",
        pleaseScanBarcode: "Please scan the barcode of base, product, package or another items",
        testBarcodes: "Test barcodes"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "ÏÎµÎ»ÎµÏÏÎ±Î¯Î¿Ï",
        next: "ÎÏÏÎ¼ÎµÎ½Î¿"
    },
    ufiCodeModal: {
        currentStatus: "Current Status",
        detailedInfoForColorant: "Detailed info for colorant %{colorantName}",
        userSetUfiCode: "User set UFI code, current value"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI code validation",
        confirmColorantRefilling: "Confirm colorant refilling",
        enableUfiCodes: "Enable UFI codes",
        printUfiCode: "Print if amount of colorant is over",
        printUfiCodePercentage: "Print percentage if amount of colorant is over",
        scanOrTypeUfiCode: "Scan or type UFI code",
        scanOrTypeUfiCodeOfBase: "Scan or type UFI code of base can",
        ufiCodesByPercentage: "Use UFI codes by percentage",
        ufiCodesFromDatabase: "Use UFI codes from the database",
        ufiCodesFromLastFilling: "Use UFI codes from the last filling"
    },
    userSettings: {
        addUser: "Î ÏÏÏÎ¸ÎµÏÎµ ÏÏÎ®ÏÏÎ·",
        assignedUserGroups: "ÎÎ¼Î±Î´Î¿ÏÎ¿Î¹Î·Î¼Î­Î½ÎµÏ Î¿Î¼Î¬Î´ÎµÏ ÏÏÎ·ÏÏÏÎ½",
        availableUserGroups: "ÎÎ¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ Î¿Î¼Î¬Î´ÎµÏ ÏÏÎ·ÏÏÏÎ½",
        barcode: "barcode",
        confirmNewPassword: "ÎÏÎ¹Î²ÎµÎ²Î±Î¯ÏÏÎ· ÎÏÎ´Î¹ÎºÎ¿Ï",
        editPassword: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÎºÏÎ´Î¹ÎºÎ¿Ï ÏÏÏÏÎ²Î±ÏÎ·Ï",
        editUser: "ÎÏÎµÎ¾ÎµÏÎ³Î±ÏÎ¯Î± ÏÏÎ®ÏÏÎ·",
        enableAutoLogin: "ÎÎ½ÎµÏÎ³Î¿ÏÎ¿Î¯Î·ÏÎ· Î±ÏÏÏÎ¼Î±ÏÎ·Ï ÏÏÎ½Î´ÎµÏÎ·Ï",
        newPassword: "ÎÎ­Î¿Ï ÎÏÎ´Î¹ÎºÏÏ",
        noChange: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ Î±Î»Î»Î±Î³Î® Î³Î¹Î± Î±ÏÎ¿Î¸Î®ÎºÎµÏÏÎ·",
        oldPassword: "Î ÎÎÎÎÎ£ ÎÎ©ÎÎÎÎÎ£",
        password: "ÎÏÎ´Î¹ÎºÏÏ ÏÏÏÏÎ²Î±ÏÎ·Ï",
        passwordsDoNotMatch: "ÎÎ¹ ÎºÏÎ´Î¹ÎºÎ¿Î¯ ÏÏÏÏÎ²Î±ÏÎ·Ï Î´ÎµÎ½ ÏÎ±Î¹ÏÎ¹Î¬Î¶Î¿ÏÎ½",
        restoreUser: "This user is deleted. Do you want to restore him?",
        userGroup: "User Group",
        userGroups: "ÎÎ¼Î¬Î´ÎµÏ ÏÏÎ·ÏÏÏÎ½",
        userManagement: "ÎÎ¹Î±ÏÎµÎ¯ÏÎ¹ÏÎ· ÏÏÎ·ÏÏÏÎ½",
        userSettings: "User settings",
        username: "ÎÎ½Î¿Î¼Î± ÏÏÎ®ÏÏÎ·",
        usernameIsMissing: "ÎÎµÎ¯ÏÎµÎ¹ ÏÎ¿ ÏÎ½Î¿Î¼Î± ÏÏÎ®ÏÏÎ·."
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Î Î±ÏÎ±ÏÎºÎµÏÎ®",
        monday: "ÎÎµÏÏÎ­ÏÎ±",
        saturday: "Î£Î¬Î²Î²Î±ÏÎ¿",
        sunday: "ÎÏÏÎ¹Î±ÎºÎ®",
        thursday: "Î Î­Î¼ÏÏÎ·",
        tuesday: "Î¤ÏÎ¯ÏÎ·",
        wednesday: "Î¤ÎµÏÎ¬ÏÏÎ·"
    },
    welcome: {
        availableDatabase: "Server cannot connect to database. Please check your database configuration.",
        availableDatabaseLocalError:
            "Î£ÏÎ¬Î»Î¼Î± ÎºÎ±ÏÎ¬ ÏÎ· ÏÏÎ½Î´ÎµÏÎ· Î¼Îµ ÏÎ·Î½ ÏÎ¿ÏÎ¹ÎºÎ® Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ (Î»Î¬Î¸Î¿Ï Î±ÏÏÎµÎ¯Î¿, Î¼Î· Î­Î³ÎºÏÏÎ¿Ï ÎºÏÎ´Î¹ÎºÏÏ ÏÏÏÏÎ²Î±ÏÎ·Ï)",
        availableDatabaseLocalMissing: "Î ÏÎ¿ÏÎ¹ÎºÎ® Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ Î»ÎµÎ¯ÏÎµÎ¹",
        availableDatabaseLocalUpdate: "Î ÏÎ¿ÏÎ¹ÎºÎ® Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ½Î·Î¼ÎµÏÏÎ¸ÎµÎ¯ Î¼Îµ ÏÎ· Î½ÎµÏÏÎµÏÎ· Î­ÎºÎ´Î¿ÏÎ·",
        availableDatabaseMainAndLocalError:
            "Error during connecting to both main and local databases (wrong file, invalid password)",
        availableDatabaseMainAndLocalMissing: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎ¿ÏÎ½ Î±ÏÏÎµÎ¯Î± ÎºÏÏÎ¹ÏÎ½ ÎºÎ±Î¹ ÏÎ¿ÏÎ¹ÎºÏÎ½ Î²Î¬ÏÎµÏÎ½ Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        availableDatabaseMainAndLocalUpdate:
            "Î¤ÏÏÎ¿ Î¿Î¹ ÎºÏÏÎ¹ÎµÏ ÏÏÎ¿ ÎºÎ±Î¹ Î¿Î¹ ÏÎ¿ÏÎ¹ÎºÎ­Ï Î²Î¬ÏÎµÎ¹Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ½Î·Î¼ÎµÏÏÎ½Î¿Î½ÏÎ±Î¹ Î¼Îµ ÏÎ· Î½ÎµÏÏÎµÏÎ· Î­ÎºÎ´Î¿ÏÎ·",
        availableDatabaseMainError:
            "Î£ÏÎ¬Î»Î¼Î± ÎºÎ±ÏÎ¬ ÏÎ· ÏÏÎ½Î´ÎµÏÎ· Î¼Îµ ÏÎ·Î½ ÎºÏÏÎ¹Î± Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ (Î»Î¬Î¸Î¿Ï Î±ÏÏÎµÎ¯Î¿, Î¼Î· Î­Î³ÎºÏÏÎ¿Ï ÎºÏÎ´Î¹ÎºÏÏ ÏÏÏÏÎ²Î±ÏÎ·Ï)",
        availableDatabaseMainMissing: "ÎÎµÎ½ ÏÏÎ¬ÏÏÎµÎ¹ ÎºÏÏÎ¹Î¿ Î±ÏÏÎµÎ¯Î¿ Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Î ÎºÏÏÎ¹Î± Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÏÎ­ÏÎµÎ¹ Î½Î± ÎµÎ½Î·Î¼ÎµÏÏÎ¸ÎµÎ¯ Î¼Îµ ÏÎ· Î½ÎµÏÏÎµÏÎ· Î­ÎºÎ´Î¿ÏÎ·",
        closing: "Î¤Î¿ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ ÎºÎ»ÎµÎ¯Î½ÎµÎ¹",
        compatibility:
            "ÎÎ»Î­Î³Î¾ÏÎµ ÏÎ·Î½ Î­ÎºÎ´Î¿ÏÎ· ÏÎ¿Ï Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ® ÏÎ±Ï. Î ÏÎµÎ»Î¬ÏÎ·Ï ÏÎ±Ï ÎµÎ¯Î½Î±Î¹ ÏÏÎ¼Î²Î±ÏÏÏ Î¼ÏÎ½Î¿ Î¼Îµ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ® %{0} Î® ÏÏÎ·Î»ÏÏÎµÏÎ·.",
        compatibilityCheck: "Î Î­Î»ÎµÎ³ÏÎ¿Ï ÏÏÎ¼Î²Î±ÏÏÏÎ·ÏÎ±Ï Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎµÎ¾Î­Î»Î¹Î¾Î·",
        compatibilityDatabase:
            "Î Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ±Ï Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ¼Î²Î±ÏÎ® Î¼Îµ ÏÎ¿ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®. ÎÎ»Î­Î³Î¾ÏÎµ ÏÎ· Î´Î¹Î±Î¼ÏÏÏÏÏÎ· ÏÎ·Ï Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ±Ï.",
        connectingServer: "Î£ÏÎ½Î´ÎµÏÎ· ÏÏÎ¿ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ® %{ip}",
        databaseCompatibility: "Î Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ±Ï Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ¼Î²Î±ÏÎ® Î¼Îµ ÏÎ¿ ÏÏÎ­ÏÎ¿Î½ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ",
        databasesCompatibility: "ÎÎ¹ Î²Î¬ÏÎµÎ¹Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÏÎ±Ï Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ ÏÏÎ¼Î²Î±ÏÎ­Ï Î¼Îµ ÏÎ¿ ÏÏÎ­ÏÎ¿Î½ Î»Î¿Î³Î¹ÏÎ¼Î¹ÎºÏ",
        licenseVerification: "Î ÎµÏÎ±Î»Î®Î¸ÎµÏÏÎ· ÏÎ·Ï Î¬Î´ÎµÎ¹Î±Ï Î²ÏÎ¯ÏÎºÎµÏÎ±Î¹ ÏÎµ ÎµÎ¾Î­Î»Î¹Î¾Î·",
        loading: "Î¦ÏÏÏÏÏÎ·",
        lostConnection: "Î ÏÏÎ½Î´ÎµÏÎ· Î¼Îµ ÏÎ¿ Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ® ÏÎ¬Î¸Î·ÎºÎµ",
        moduleMessage:
            "Pay attention to module selection, because future change of module will be available only for privileged users.",
        refresh: "Î¦ÏÎµÏÎºÎ¬ÏÏ",
        restoring: "ÎÏÎ±Î½Î±ÏÎ¿ÏÎ¬ ÏÏÎ½Î´ÎµÏÎ·Ï",
        selectModule: "ÎÏÎ¹Î»Î­Î¾ÏÎµ Î¼Î¯Î± Î±ÏÏ ÏÎ¹Ï Î´Î¹Î±Î¸Î­ÏÎ¹Î¼ÎµÏ ÎµÎ½ÏÏÎ·ÏÎµÏ.",
        stopUpdate: "ÎÎ¹Î±ÎºÎ¿ÏÎ® ÎµÎ½Î·Î¼Î­ÏÏÏÎ·Ï",
        updateDatabase: "ÎÎ½Î·Î¼Î­ÏÏÏÎ· Î²Î¬ÏÎ·Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½",
        updatingDatabase: "Î Î²Î¬ÏÎ· Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÎµÎ½Î·Î¼ÎµÏÏÎ½ÎµÏÎ±Î¹",
        updatingDatabases: "ÎÎ¹ Î²Î¬ÏÎµÎ¹Ï Î´ÎµÎ´Î¿Î¼Î­Î½ÏÎ½ ÎµÎ½Î·Î¼ÎµÏÏÎ½Î¿Î½ÏÎ±Î¹",
        updatingWarning: "Database structure is being updated to the newest version, please wait.",
        updatingWarningInfo:
            "Do not close this window as it would result in the necessity to do the update from scratch."
    }
};
